import Vue from 'vue'
import VueRouter from 'vue-router'
import AdminLayout from '../layout/admin/AdminLayout'
import SchoolLayout from '../layout/school/SchoolLayout'
import SchoolLayoutDataCenter from '../layout/school/SchoolLayoutDataCenter'
import TeacherLayout from '../layout/teacher/TeacherLayout'
import TeacherCourseLayout from '../layout/teacher/TeacherCourseLayout'
import TeacherDataCenterLayout from '../layout/teacher/TeacherDataCenterLayout'
import JudgesLayout from '../layout/judges/JudgesLayout'
import studentTrainingLayout from '../layout/student/studentTrainingLayout'
import studentExamLayout from '../layout/student/studentExamLayout'
import studentCourseLayout from "../layout/student/studentCourseLayout";
import Main from '../layout/Main'
import ExamDataLayout from '../layout/teacher/ExamDataLayout'
import TrainDataLayout from '../layout/teacher/TrainDataLayout'
import GoodsInfoLayout from '../layout/student/GoodsInfoLayout'
import GoodsShopLayout from '../layout/student/GoodsShopLayout'
import OrderLayout from '../layout/student/OrderLayout'
import JudgesTypeLayout from '../layout/judges/JudgesTypeLayout'
import CertificateLayout from '../layout/teacher/CertificateLayout'
import softPromotionLayout from '../layout/student/softPromotionLayout'
import livePromotionLayout from '../layout/student/livePromotionLayout'
import goodsManageLayout from '../layout/student/goodsManageLayout'
import ECommerceCollectCleanLayout from '../layout/student/ECommerceCollectCleanLayout'
import ECommerceFansLayout from '../layout/student/ECommerceFansLayout'
import DataCenterLayout from '../layout/admin/DataCenterLayout'
import InfographicPromotionLayout from '../layout/student/InfographicPromotionLayout'
import JDDirectInvestmentLayout from '../layout/student/JDDirectInvestmentLayout'
import InfographicPromotionStepLayout from '../layout/student/InfographicPromotionStepLayout'
import JDDirectInvestmentStepLayout from '../layout/student/JDDirectInvestmentStepLayout'
import operationPromotionLayout from "../layout/student/operationPromotionLayout"
import studentCreatePlanLayout from "../layout/student/studentCreatePlanLayout";
import CyberCustomerServiceLayout from "../layout/student/CyberCustomerServiceLayout";
import OnlineTradingLayout from "../layout/student/OnlineTradingLayout";
import TrainAdminLayout from "../layout/student/TrainAdminLayout";
import ECommerceAnalysisApplyLayout from "../layout/student/ECommerceAnalysisApplyLayout";
import EcommerceDataCenterLayout from "../layout/student/EcommerceDataCenterLayout";
import SocialECommerceLayout from "../layout/student/SocialECommerceLayout";
import dataAnalysisLayout from "../layout/student/dataAnalysisLayout";
import OnlineShopProductPricingLayout from "../layout/student/OnlineShopProductPricingLayout";
import EvaluationLayout from "../layout/evaluation/EvaluationLayout";
import EvaluationExamDataLayout from "../layout/evaluation/ExamDataLayout";
import EvaluationStudentExamLayout from "../layout/evaluation/studentExamLayout";
import ShopOpenPage from '../layout/student/ShopOpenPage'

//课程那边的重复跳转报错处理
import Router from 'vue-router'
import JudgesMain from "../layout/judges/JudgesMain";
import {config} from "@/utils/config"

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

export const LoginRoutes = [{
        path: '/',
        name: 'login',
        component: () =>
            import ('../views/Login.vue'),
        meta: {
            title: config.appName,
            role: 1
        }
    },
    {
        path: '/upload',
        name: 'upload',
        component: () =>
            import ('../views/Upload.vue'),
        meta: {
            title: '分片上传demo',
            role: 1,
        }
    },
    {
        path: '/teacher/goods/detail',
        name: 'teacherGoodsDetail',
        component: () =>
            import ('../views/goodsDetail/goodsDetail.vue'),
        meta: {
            title: '商品详情',
            role: 3,
        }
    },
    {
        path: '/goods/detail',
        name: 'goodsDetail',
        component: () =>
            import ('../views/goodsDetail/goodsDetail.vue'),
        meta: {
            title: '商品详情',
            role: 5
        }
    },
    {
        path: '/chat',
        name: 'chat',
        component: () =>
            import ('../views/student/chat/Index.vue'),
        meta: {
            title: '在线对话',
            role: 5,
        }
    },
    {
        path: '/student/exam/communitypromote/index',
        name: 'studentExamCommunityPromoteIndex',
        component: () =>
            import ('../views/student/exam/internetMarketing/CommunityPromote/Index'),
        meta: {
            title: '社群推广',
            role: 5,
        },
    },
    {
        path: '/student/trainCenter/ECommerceDataAnalysisAndApplication/reportProductDesign',
        name: 'studentTrainCenterECommerceDataAnalysisAndApplicationReportProductDesign',
        component: () =>
            import('../views/student/exam/ECommerceDataAnalysisAndApplication/ReportProductDesign.vue'),
        meta: {
            title: '电子商务数据报表设计制作',
            tabName: 'studentTrainCenterECommerceDataAnalysisAndApplicationReportProductDesign',
            role: 5,
            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
        },
        children:[

        ]
    },
    {
        path: '/student/trainCenter/ECommerceDataAnalysisAndApplication/viewImportedAdminData',
        name: 'studentTrainCenterECommerceDataAnalysisAndApplicationViewImportedAdminData',
        component: () =>
            import('../views/student/exam/ECommerceDataAnalysisAndApplication/viewImportedAdminData.vue'),
        meta: {
            title: '查看数据详情',
            tabName: 'studentTrainCenterECommerceDataAnalysisAndApplicationViewImportedAdminData',
            role: 5,
            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
        },
    },

    //社群推广学生训练
    {
        path: '/student/trainCenter/startTraining/communitypromote/index',
        name: 'studentTrainCenterStartTrainingCommunityPromoteIndex',
        component: () =>
            import ('../views/student/exam/internetMarketing/CommunityPromote/Index'),
        meta: {
            title: '社群推广',
            role: 5,
        }
    },
    {
        path: "/authen/authenticate",
        name: "authenticate",
        component: () =>
            import ("../views/student/authen/authenticate.vue"),
        meta: {
            title: "考试界面",
            role: 5,
        },
    },
    {
        path: "/jdLogin",
        name: "evaluationLogin",
        component: () =>
            import ("../views/evaluationLogin.vue"),
        meta: {
            title: "电子商务师--鉴定中心",
            role: 6,
        },
    },
    {
        path: "/stuGoodDetail",
        name: "stuGoodDetail",
        component: () =>
            import ("../views/student/exam/storeDecoration/GoodDetail"),
        meta: {
            title: "商品详情",
            role: 5,
        },
    },
    {
        path: "/pwGoodDetail",
        name: "pwGoodDetail",
        component: () =>
            import ("../views/student/exam/storeDecoration/GoodDetail"),
        meta: {
            title: "商品详情",
            role: 4,
        },
    },
    {
        path: "/jdGoodDetail",
        name: "jdGoodDetail",
        component: () =>
            import ("../views/student/exam/storeDecoration/GoodDetail"),
        meta: {
            title: "商品详情",
            role: 6,
        },
    },
    {
        path: "/stuStore",
        name: "stuStore",
        component: () =>
            import ("../views/student/exam/storeDecoration/Store"),
        meta: {
            title: "店铺首页",
            role: 4,
        },
    },
    {
        path: "/stuStore1",
        name: "stuStore1",
        component: () =>
            import ("../views/student/exam/storeDecoration/Store"),
        meta: {
            title: "店铺首页",
            role: 6,
        },
    },
    {
        path: "/newStuStore1",
        name: "/newStuStore1",
        component: () =>
            import ("../views/student/exam/storeDecoration/newStore"),
        meta: {
            title: "店铺首页",
            role: 6,
        },
    },
    {
        path: "/examApply",
        name: "examApply",
        component: () =>
            import ("../views/evaluation/examRoomManage/ExamApply"),
        meta: {
            title: "考场申请单",
        },
    },
]

// export const commonRoutes = []

export const adminRoutes = [{
    path: '/admin',
    name: 'admin',
    redirect: '/identifyCenter/index',
    component: AdminLayout,
    children: [{
            path: "/identifyCenter",
            name: "identifyCenter",
            redirect: "/identifyCenter/index",
            component: Main,
            meta: {
                title: "鉴定中心管理员",
                icon: "&#xe6b2;",
                role: 1,
            },
            children: [{
                    path: "/identifyCenter/index",
                    name: "identifyCenterIndex",
                    component: () =>
                        import ("../views/admin/identifyCenterManage/Index.vue"),
                    meta: {
                        title: "鉴定中心管理",
                        role: 1,
                        parentName: ["identifyCenter"],
                    },
                },
                {
                    path: "/identifyCenter/identifyAccountManage",
                    name: "identifyAccountManage",
                    component: () =>
                        import (
                            "../views/admin/identifyCenterManage/IdentifyAccountManage.vue"
                        ),
                    meta: {
                        title: "鉴定中心账号管理",
                        role: 1,
                        parentName: ["identifyCenter"],
                    },
                },
            ],
        },
        {
            path: '/classification',
            name: 'classification',
            redirect: '/classification/index',
            component: Main,
            meta: {
                title: '分类管理',
                icon: '&#xe6ae;',
                role: 1
            },
            children: [{
                    path: "/classification/index",
                    name: "TheoryCateManage",
                    component: () =>
                        import ("../views/admin/classificationManage/TheoryCateManage.vue"),
                    meta: {
                        title: "理论分类管理",
                        role: 1,
                        parentName: ["classification"],
                    },
                },
                {
                    path: "/classification/actualCateManage",
                    name: "ActualCateManage",
                    component: () =>
                        import ("../views/admin/classificationManage/ActualCateManage.vue"),
                    meta: {
                        title: "实操分类管理",
                        role: 1,
                        parentName: ["classification"],
                    },
                },
                // {
                //     path: '/classification/index',
                //     name: 'classificationIndex',
                //     component: () => import('../views/admin/classificationManage/Index.vue'),
                //     meta: {
                //         title: '课程管理',
                //         role: 1,
                //         parentName: ['classification']
                //     },
                // },
                // {
                //     path: '/classification/resources',
                //     name: 'classificationResources',
                //     component: () => import('../views/admin/classificationManage/Resources.vue'),
                //     meta: {
                //         title: '资源库分类',
                //         role: 1,
                //         parentName: ['classification']
                //     },
                // },
                // {
                //     path: '/classification/questions',
                //     name: 'classificationQuestions',
                //     component: () => import('../views/admin/classificationManage/Questions.vue'),
                //     meta: {
                //         title: '试题库分类',
                //         role: 1,
                //         parentName: ['classification']
                //     },
                // },
            ]
        },
        {
            path: '/theory',
            name: 'theory',
            redirect: '/theory/index',
            component: Main,
            meta: {
                title: '理论题',
                icon: '&#xe6b2;',
                role: 1
            },
            children: [{
                    path: '/theory/index',
                    name: 'theoryIndex',
                    component: () =>
                        import ('../views/admin/theoryQuestions/Index.vue'),
                    meta: {
                        title: '理论题',
                        role: 1,
                        parentName: ['theory']
                    },
                },
                {
                    path: '/theory/add',
                    name: 'theoryAdd',
                    component: () =>
                        import ('../views/admin/theoryQuestions/AddQuestion'),
                    meta: {
                        title: '添加试题',
                        role: 1,
                        parentName: ['theory', 'theoryIndex'],
                        hidden: true,
                        level: 2
                    },
                },
                {
                    path: '/theory/questions',
                    name: 'theoryQuestions',
                    component: () =>
                        import ('../views/admin/theoryQuestions/Questions.vue'),
                    meta: {
                        title: '试卷管理',
                        role: 1,
                        parentName: ['theory']
                    },
                },
                {
                    path: '/theory/questions/add',
                    name: 'theoryQuestionsAdd',
                    component: () =>
                        import ('../views/admin/theoryQuestions/TheoryQuestionsAdd.vue'),
                    meta: {
                        title: '添加试卷',
                        role: 1,
                        parentName: ['theory', 'theoryQuestions'],
                        hidden: true,
                        level: 2
                    }
                },
            ]
        },
        {
            path: '/practice',
            name: 'practice',
            redirect: '/practice/index',
            component: Main,
            meta: {
                title: '实操题',
                icon: '&#xe6b2;',
                role: 1
            },
            children: [{
                    path: '/practice/index',
                    name: 'practiceIndex',
                    component: () =>
                        import ('../views/admin/practiceQuestions/Index.vue'),
                    meta: {
                        title: '实操题',
                        role: 1,
                        parentName: ['practice']
                    },
                },
                {
                    path: '/practice/goods',
                    name: 'practiceGoods',
                    component: () =>
                        import ('../views/admin/practiceQuestions/Goods.vue'),
                    meta: {
                        title: '商品',
                        role: 1,
                        parentName: ['practice']
                    },
                },
                {
                    path: '/practice/goodsCategory',
                    name: 'practiceGoodsCategory',
                    component: () =>
                        import ('../components/admin/practicalExercises/goods/GoodsCategory'),
                    meta: {
                        title: '选择分类',
                        role: 1,
                        parentName: ['practice', 'practiceGoods'],
                        hidden: true,
                        level: 2
                    },
                },
                {
                    path: '/practice/goodsAdd',
                    name: 'practiceGoodsAdd',
                    component: () =>
                        import ('../components/admin/practicalExercises/goods/GoodsAdd'),
                    meta: {
                        title: '添加商品',
                        role: 1,
                        parentName: ['practice', 'practiceGoods'],
                        hidden: true,
                        level: 2
                    },
                },
                {
                    path: '/practice/hotKeywords',
                    name: 'practiceHotKeywords',
                    component: () =>
                        import ('../views/admin/practiceQuestions/HotKeywords.vue'),
                    meta: {
                        title: '热门关键词',
                        role: 1,
                        parentName: ['practice']
                    },
                },
                {
                    path: '/practice/hotKeywords/create',
                    name: 'practiceHotKeywordsCreate',
                    component: () =>
                        import ('../views/admin/practiceQuestions/HotKeywordsCreate.vue'),
                    meta: {
                        title: '添加关键词',
                        role: 1,
                        parentName: ['practice', 'practiceHotKeywords'],
                        hidden: true,
                        level: 2,
                    },
                },
                {
                    path: '/practice/customerServiceManagement',
                    name: 'practiceCustomerServiceManagement',
                    component: () =>
                        import ('../views/admin/practiceQuestions/CustomerServiceManagement.vue'),
                    meta: {
                        title: '客服管理',
                        role: 1,
                        parentName: ['practice']
                    },
                },
                {
                    path: '/practice/addCustomerServiceManagement',
                    name: 'practiceAddCustomerServiceManagement',
                    component: () =>
                        import ('../views/admin/practiceQuestions/AddCustomerServiceManagement.vue'),
                    meta: {
                        title: '添加客服数据',
                        role: 1,
                        parentName: ['practice', 'practiceCustomerServiceManagement'],
                        hidden: true,
                        level: 2,
                    }
                },
                {
                    path: '/practice/customerInformation',
                    name: 'practiceCustomerInformation',
                    component: () =>
                        import ('../views/admin/practiceQuestions/CustomerInformation.vue'),
                    meta: {
                        title: '客户信息',
                        role: 1,
                        parentName: ['practice']
                    },
                },
                {
                    path: '/practice/addCustomerInformation',
                    name: 'practiceAddCustomerInformation',
                    component: () =>
                        import ('../views/admin/practiceQuestions/AddCustomerInformation.vue'),
                    meta: {
                        title: '添加客户信息',
                        role: 1,
                        parentName: ['practice'],
                        hidden: true,
                        level: 2,
                    },
                },
                {
                    path: '/practice/fanCharacteristics',
                    name: 'practiceFanCharacteristics',
                    component: () =>
                        import ('../views/admin/practiceQuestions/FanCharacteristics.vue'),
                    meta: {
                        title: '粉丝特征',
                        role: 1,
                        parentName: ['practice']
                    },
                },
                {
                    path: '/practice/fanCharacteristics/create',
                    name: 'practiceFanCharacteristicsCreate',
                    component: () =>
                        import ('../views/admin/practiceQuestions/FanCharacteristicsCreate.vue'),
                    meta: {
                        title: '添加粉丝特征',
                        role: 1,
                        parentName: ['practice', 'practiceFanCharacteristics'],
                        hidden: true,
                        level: 2,
                    },
                },
                {
                    path: '/practice/operationPromote',
                    name: 'practiceOperationPromote',
                    component: () =>
                        import ('../views/admin/practiceQuestions/OperationPromote.vue'),
                    meta: {
                        title: '运营推广',
                        role: 1,
                        parentName: ['practice']
                    },
                },
                {
                    path: '/practice/operationPromote/create',
                    name: 'practiceOperationPromoteCreate',
                    component: () =>
                        import ('../views/admin/practiceQuestions/AddOperationPromote.vue'),
                    meta: {
                        title: '添加运营推广',
                        role: 1,
                        parentName: ['practice', 'practiceOperationPromote'],
                        hidden: true,
                        level: 2,
                    },
                },
                {
                    path: '/practice/customerRelationshipManagement',
                    name: 'practiceCustomerRelationshipManagement',
                    component: () =>
                        import ('../views/admin/practiceQuestions/CustomerRelationshipManagement.vue'),
                    meta: {
                        title: '客户关系管理',
                        role: 1,
                        parentName: ['practice']
                    },
                },
                {
                    path: '/practice/addRelationshipManagement',
                    name: 'practiceAddRelationshipManagement',
                    component: () =>
                        import ('../views/admin/practiceQuestions/AddRelationshipManagement.vue'),
                    meta: {
                        title: '添加客户关系管理',
                        role: 1,
                        parentName: ['practice'],
                        hidden: true,
                        level: 2,
                    },
                },
                {
                    path: '/placement/index',
                    name: 'placementIndex',
                    component: () =>
                        import ('../views/admin/practiceQuestions/Placement.vue'),
                    meta: {
                        title: '投放位置',
                        role: 1,
                        parentName: ['practice']
                    },
                },
                {
                    path: '/practice/placementCreate',
                    name: 'practicePlacementCreate',
                    component: () =>
                        import ('../views/admin/practiceQuestions/PlacementCreate.vue'),
                    meta: {
                        title: '创建投放位置模板',
                        role: 1,
                        parentName: ['practice'],
                        hidden: true,
                        level: 2,
                    },
                },
                {
                    path: '/practice/dataCenter',
                    name: 'practiceDataCenter',
                    component: () =>
                        import ('../views/admin/practiceQuestions/DataCenter'),
                    meta: {
                        title: '数据中心',
                        role: 1,
                        parentName: ['practice']
                    },
                },
                // {
                //     path: '/practice/dataCenterCreate',
                //     name: 'practiceDataCenterCreate',
                //     component: () => import('../views/admin/practiceQuestions/DataCenterCreate'),
                //     meta: {
                //         title: '创建数据中心模板',
                //         role: 1,
                //         parentName: ['practice'],
                //         hidden: true,
                //         level: 2,
                //     },
                // },
                {
                    path: '/practice/dataCenterCreate',
                    name: 'practiceDataCenterCreate',
                    component: DataCenterLayout,
                    meta: {
                        title: '创建数据中心模板',
                        role: 1,
                        parentName: ['practice'],
                        hidden: true,
                        level: 2,
                    },
                    children: [{
                            path: '/practice/dataStepOne',
                            name: 'practiceDataStepOne',
                            component: () =>
                                import ('../components/admin/practicalExercises/dataCenter/DataStepOne'),
                            meta: {
                                title: '添加客户信息数据',
                                role: 1,
                                parentName: ['practice'],
                                hidden: true,
                                level: 2,
                            },
                        },
                        {
                            path: '/practice/dataStepTwo',
                            name: 'practiceDataStepTwo',
                            component: () =>
                                import ('../components/admin/practicalExercises/dataCenter/DataStepTwo'),
                            meta: {
                                title: '添加行业大盘数据',
                                role: 1,
                                parentName: ['practice'],
                                hidden: true,
                                level: 2,
                            },
                        },
                        {
                            path: '/practice/dataStepThree',
                            name: 'practiceDataStepThree',
                            component: () =>
                                import ('../components/admin/practicalExercises/dataCenter/DataStepThree'),
                            meta: {
                                title: '添加商品榜单数据',
                                role: 1,
                                parentName: ['practice'],
                                hidden: true,
                                level: 2,
                            },
                        },
                        {
                            path: '/practice/dataStepFour',
                            name: 'practiceDataStepFour',
                            component: () =>
                                import ('../components/admin/practicalExercises/dataCenter/DataStepFour'),
                            meta: {
                                title: '添加客户分析数据',
                                role: 1,
                                parentName: ['practice'],
                                hidden: true,
                                level: 2,
                            },
                        },
                        {
                            path: '/practice/dataStepFive',
                            name: 'practiceDataStepFive',
                            component: () =>
                                import ('../components/admin/practicalExercises/dataCenter/DataStepFive'),
                            meta: {
                                title: '添加卖家分析数据',
                                role: 1,
                                parentName: ['practice'],
                                hidden: true,
                                level: 2,
                            },
                        },
                        {
                            path: '/practice/dataStepSix',
                            name: 'practiceDataStepSix',
                            component: () =>
                                import ('../components/admin/practicalExercises/dataCenter/DataStepSix'),
                            meta: {
                                title: '创建成功',
                                role: 1,
                                parentName: ['practice'],
                                hidden: true,
                                level: 2,
                            },
                        },
                    ]
                },
                {
                    path: '/practice/paperManagement',
                    name: 'practicePaperManagement',
                    component: () =>
                        import ('../views/admin/practiceQuestions/PaperManagement.vue'),
                    meta: {
                        title: '试卷管理',
                        role: 1,
                        parentName: ['practice']
                    },
                },
                {
                    path: '/practice/paperAddManagement',
                    name: 'practiceAddPaperManagement',
                    component: () =>
                        import ('../views/admin/practiceQuestions/AddPaperManagement.vue'),
                    meta: {
                        title: '添加试卷',
                        role: 1,
                        parentName: ['practice', 'practicePaperManagement'],
                        hidden: true,
                        level: 2,
                    }
                },
                {
                    path: '/practice/create',
                    name: 'practiceCreate',
                    component: () =>
                        import ('../views/admin/practiceQuestions/PracticeCreate.vue'),
                    meta: {
                        title: '添加试题',
                        role: 1,
                        parentName: ['practice', 'practiceIndex'],
                        hidden: true,
                        level: 2,
                    },
                },
            ]
        },
        // {
        //     path: '/paper',
        //     name: 'paper',
        //     redirect: '/paper/index',
        //     component: Main,
        //     meta: {
        //         title: '试卷管理',
        //         icon: '&#xe6b3;',
        //         role: 1
        //     },
        //     children: [
        //         {
        //             path: '/paper/index',
        //             name: 'paperIndex',
        //             component: () => import('../views/admin/paperManage/Index.vue'),
        //             meta: {
        //                 title: '试卷管理',
        //                 role: 1,
        //                 parentName: ['paper']
        //             },
        //         },
        //         {
        //             path: '/paper/addPaperTemplate',
        //             name: 'addPaperTemplate',
        //             component: () => import('../views/admin/paperManage/AddPaperTemplate.vue'),
        //             meta: {
        //                 title: '创建试卷模板',
        //                 role: 1,
        //                 parentName: ['paper', 'paperIndex'],
        //                 hidden: true,
        //                 level: 2
        //             }
        //         }
        //     ]
        // },
    ]
}, ]

export const schoolRoutes = [{
        path: '/school',
        name: 'school',
        redirect: '/school/educational/teacher',
        component: SchoolLayout,
        children: [{
                path: '/school/educational',
                name: 'schoolEducational',
                redirect: '/school/educational/teacher',
                component: Main,
                meta: {
                    title: '教务管理',
                    icon: '&#xe6b4;',
                    role: 2
                },
                children: [{
                        path: '/school/educational/teacher',
                        name: 'educationalTeacher',
                        component: () =>
                            import ('../views/school/educationalManage/TeacherManagement.vue'),
                        meta: {
                            title: '教师管理',
                            role: 2,
                            parentName: ['schoolEducational']
                        },
                    },
                    {
                        path: '/school/educational/judges',
                        name: 'educationalJudges',
                        component: () =>
                            import ('../views/school/educationalManage/JudgesManagement.vue'),
                        meta: {
                            title: '评委管理',
                            role: 2,
                            parentName: ['schoolEducational']
                        },
                    },
                ]
            },
            {
                path: '/school/certificate',
                name: 'schoolCertificate',
                redirect: '/school/certificate/index',
                component: Main,
                meta: {
                    title: '证书管理',
                    icon: '&#xe6b8;',
                    role: 2
                },
                children: [{
                        path: '/school/certificate/index',
                        name: 'schoolCertificateIndex',
                        component: () =>
                            import ('../views/teacher/evaluationCenter/Index.vue'),
                        meta: {
                            title: '证书管理',
                            role: 2,
                            parentName: ['schoolCertificate', 'schoolCertificateIndex'],
                            level: 2,
                        },
                    },
                    {
                        path: '/school/certificate/getCertificateList',
                        name: 'schoolCertificateGetCertificateList',
                        component: () =>
                            import ('../views/teacher/evaluationCenter/GetCertificateList.vue'),
                        meta: {
                            title: '已获得证书',
                            role: 2,
                            parentName: ['schoolCertificate', 'schoolCertificateIndex'],
                            hidden: true,
                            level: 2,

                        },
                    },
                    {
                        path: '/school/certificate/noGetCertificateList',
                        name: 'evaluationCenterNoGetCertificateList',
                        component: () =>
                            import ('../views/teacher/evaluationCenter/NoGetCertificateList.vue'),
                        meta: {
                            title: '未获得证书',
                            role: 2,
                            parentName: ['schoolCertificate', 'schoolCertificateIndex'],
                            hidden: true,
                            level: 2,
                        },
                    },
                ],

            },
            {
                path: '/school/report',
                name: 'schoolReport',
                redirect: '/school/report/index',
                component: Main,
                meta: {
                    title: '报告管理',
                    icon: '&#xe6b7;',
                    role: 2
                },
                children: [{
                        path: '/school/report/index',
                        name: 'schoolReportIndex',
                        component: () =>
                            import ('../views/school/reportManagement/Index.vue'),
                        meta: {
                            title: '报告管理',
                            role: 2,
                            parentName: ['schoolReport'],
                            level: 2
                        },
                    },
                    {
                        path: '/school/report/detail',
                        name: 'schoolReportDetail',
                        component: () =>
                            import ('../views/school/reportManagement/ReportDetail.vue'),
                        meta: {
                            title: '报告管理-详情',
                            role: 2,
                            parentName: ['schoolReport', 'schoolReportIndex'],
                            level: 2,
                        },
                    },
                    {
                        path: '/school/report/singleReport',
                        name: 'schoolSingleReport',
                        component: () =>
                            import ('../views/school/reportManagement/SingleReport.vue'),
                        meta: {
                            title: '报告管理-详情',
                            role: 2,
                            parentName: ['schoolReport', 'schoolReportIndex', 'schoolReportDetail'],
                            hidden: true,
                            level: 2,
                            showMenu: false
                        },
                    },
                ]
            },
            {
                path: '/school/data',
                name: 'schoolData',
                redirect: '/school/data/index',
                component: Main,
                meta: {
                    title: '数据中心',
                    icon: '&#xe70e;',
                    role: 2
                },
                children: [{
                        path: '/school/data/index',
                        name: 'schoolDataIndex',
                        component: () =>
                            import ('../views/teacher/dataCenter/Index.vue'),
                        meta: {
                            title: '数据中心',
                            role: 2,
                            parentName: ['schoolData'],
                            hidden: true,
                        }
                    },
                    {
                        path: '/school/data/detail',
                        name: 'schoolDataDetail',
                        component: () =>
                            import ('../views/teacher/dataCenter/Detail.vue'),
                        meta: {
                            title: '班级数据',
                            role: 2,
                            parentName: ['schoolData']
                        }
                    },
                ]
            },
        ]
    },
    {
        path: '/school/certificates',
        name: 'schoolCertificates',
        redirect: '/school/certificates/index',
        component: SchoolLayoutDataCenter,
        children: [{
            path: '/school/certificates',
            name: 'schoolCertificate',
            redirect: '/school/certificates/index',
            component: Main,
            meta: {
                title: '证书管理',
                role: 2
            },
            children: [{
                path: '/school/certificate/viewCertificate',
                name: 'schoolCertificateViewCertificate',
                component: () =>
                    import ('../views/teacher/evaluationCenter/ViewCertificate.vue'),
                meta: {
                    title: '查看证书',
                    role: 2,
                    parentName: ['schoolCertificate', 'schoolCertificateIndex'],
                },
            }, ]
        }, ]
    }
]

export const teacherRoutes = [{
    path: '/teacher',
    name: 'teacher',
    redirect: '/teachingCenter/index',
    component: TeacherLayout,
    children: [{
            path: '/teachingCenter',
            name: 'teachingCenter',
            redirect: '/teachingCenter/index',
            component: TeacherCourseLayout,
            meta: {
                title: '教学中心',
                icon: '&#xe65a;',
                role: 3
            },
            children: [{
                    path: '/teachingCenter/index',
                    name: 'teacherCourseIndex',
                    component: () =>
                        import ('../views/teacher/teachingCenter/teacherIndex.vue'),
                    meta: {
                        title: '课程-首页',
                        role: 3,
                        parentName: ['teachingCenter'],
                        hidden: true,
                        tabName: 'teacherCourseIndex'
                    }
                },
                {
                    path: '/teachingCenter/teacherFeatured',
                    name: 'teacherFeatured',
                    component: () =>
                        import ('../views/teacher/teachingCenter/teacherFeatured.vue'),
                    meta: {
                        title: '课程-首页',
                        role: 3,
                        parentName: ['teachingCenter'],
                        hidden: true,
                        tabName: 'teacherFeatured'
                    }
                },
                {
                    path: '/teachingCenter/examDetail',
                    name: 'teacherExamDetail',
                    component: () =>
                        import ('../views/teacher/teachingCenter/ExamDetail'),
                    meta: {
                        title: '理论试卷详情',
                        role: 3,
                        parentName: ['teachingCenter'],
                        hidden: true,
                        tabName: 'teacherExamDetail'
                    }
                },
                {
                    path: '/teachingCenter/practiceDetail',
                    name: 'teacherPracticeDetail',
                    component: () =>
                        import ('../views/teacher/teachingCenter/LookDetail'),
                    meta: {
                        title: '实操训练详情',
                        role: 3,
                        parentName: ['teachingCenter'],
                        hidden: true,
                        tabName: 'teacherPracticeDetail'
                    }
                },
                {
                    path: '/teachingCenter/teacherMatingDetail',
                    name: 'teacherMatingDetail',
                    component: () =>
                        import ('../views/teacher/teachingCenter/teacherMatingDetail'),
                    meta: {
                        title: '课程-个人资源',
                        role: 3,
                        parentName: ['teachingCenter'],
                        hidden: true,
                        tabName: 'teacherMatingDetail'
                    }
                },
            ]
        },
        {
            path: '/trainingCenter',
            name: 'trainingCenter',
            redirect: '/trainingCenter/examTraining',
            component: Main,
            meta: {
                title: '训练中心',
                icon: '&#xe615;',
                role: 3
            },
            children: [{
                    path: '/trainingCenter/examTraining',
                    name: 'trainingCenterExamTraining',
                    component: () =>
                        import ('../views/teacher/trainingCenter/ExamTraining.vue'),
                    meta: {
                        title: '考试训练',
                        role: 3,
                        parentName: ['trainingCenter'],
                        isActiveName: 'trainingCenterExamTraining'
                    },
                },
                {
                    path: '/trainingCenter/examTrainDetail',
                    name: 'trainingCenterExamTrainDetail',
                    component: () =>
                        import ('../views/teacher/trainingCenter/ExamTrainingDetail'),
                    meta: {
                        title: '试卷详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterExamTraining'],
                        hidden: true,
                        isActiveName: 'trainingCenterExamTraining'
                    },
                },
                {
                    path: '/trainingCenter/examTrainAnswerDetail',
                    name: 'trainingCenterExamAnswerDetail',
                    component: () =>
                        import ('../views/teacher/trainingCenter/ExamAnswerDetail'),
                    meta: {
                        title: '答题详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterExamTraining'],
                        hidden: true,
                        isActiveName: 'trainingCenterExamTraining'
                    },
                },
                {
                    path: '/trainingCenter/examTrainStudentAnswerDetail',
                    name: 'trainingCenterExamStudentAnswerDetail',
                    component: () =>
                        import ('../views/teacher/trainingCenter/ExamStudentAnswerDetail'),
                    meta: {
                        title: '学生答题详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterExamTraining'],
                        hidden: true,
                        isActiveName: 'trainingCenterExamTraining'
                    },
                },
                {
                    path: '/trainingCenter/practicalTraining',
                    name: 'trainingCenterPracticalTraining',
                    component: () =>
                        import ('../views/teacher/trainingCenter/PracticalTraining.vue'),
                    meta: {
                        title: '实操训练',
                        role: 3,
                        parentName: ['trainingCenter'],
                        isActiveName: 'trainingCenterPracticalTraining'
                    },
                },
                {
                    path: '/trainingCenter/practicalTraining/lookDetail',
                    name: 'trainingCenterPracticalTrainingLookDetail',
                    component: () =>
                        import ('../views/teacher/trainingCenter/LookDetail.vue'),
                    meta: {
                        title: '查看详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                        hidden: true,
                        isActiveName: 'trainingCenterPracticalTraining'
                    }
                },
                {
                    path: '/trainingCenter/practicalTraining/answerDetail',
                    name: 'trainingCenterPracticalTrainingAnswerDetail',
                    component: () =>
                        import ('../views/teacher/trainingCenter/AnswerDetail.vue'),
                    meta: {
                        title: '答题详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                        hidden: true,
                        isActiveName: 'trainingCenterPracticalTraining'
                    }
                },
                {
                    path: '/trainingCenter/practicalTraining/answerDetailLevelThree',
                    name: 'trainingCenterPracticalTrainingAnswerDetailLevelThree',
                    component: () =>
                        import ('../views/teacher/trainingCenter/AnswerDetailLevelThree.vue'),
                    meta: {
                        title: '答题详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                        hidden: true,
                        isActiveName: 'trainingCenterPracticalTraining'
                    }
                },
                {
                    path: '/trainingCenter/practicalTraining/onlineStoreDetail',
                    name: 'trainingCenterPracticalTrainingOnlineStoreDetail',
                    component: () =>
                        import ('../views/teacher/trainingCenter/OnlineStoreDetail.vue'),
                    meta: {
                        title: '网店装修-查看详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                        hidden: true,
                        isActiveName: 'trainingCenterPracticalTraining'
                    }
                },
                {
                    path: '/trainingCenter/practicalTraining/answerDetailService',
                    name: 'trainingCenterPracticalTrainingAnswerDetailService',
                    component: () =>
                        import ('../components/teacher/examCenter/examData/StoreCustomer.vue'),
                    meta: {
                        title: '网店客户服务-查看详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                        hidden: true,
                        isActiveName: 'trainingCenterPracticalTraining'
                    }
                },
                {
                    path: '/trainingCenter/practicalTraining/answerDetailServiceDetail',
                    name: 'trainingCenterPracticalTrainingAnswerDetailServiceDetail',
                    component: () =>
                        import ('../components/teacher/examCenter/examData/AnswerDetailServiceDetail.vue'),
                    meta: {
                        title: '网店客户服务-查看详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                        hidden: true,
                        isActiveName: 'trainingCenterPracticalTraining'
                    }
                },
                {
                    path: '/trainingCenter/practicalTraining/lookStudentDetail',
                    name: 'trainingCenterPracticalTrainingLookStudentDetail',
                    component: () =>
                        import ('../views/teacher/trainingCenter/LookStudentDetail.vue'),
                    meta: {
                        title: '商品信息采集与处理-查看详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                        hidden: true,
                        isActiveName: 'trainingCenterPracticalTraining'
                    }
                },
                {
                    path: '/trainingCenter/practicalTraining/shopManageDetail',
                    name: 'trainingCenterPracticalTrainingShopManageDetail',
                    component: () =>
                        import ('../views/teacher/trainingCenter/ShopManageDetail.vue'),
                    meta: {
                        title: '网店管理-查看详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                        hidden: true,
                        isActiveName: 'trainingCenterPracticalTraining'
                    }
                },
                {
                    path: '/trainingCenter/practicalTraining/freightDetail',
                    name: 'examCenterExamDataFreightDetail',
                    component: () =>
                        import ('../components/teacher/examCenter/examData/FreightDetail'),
                    meta: {
                        title: '查看运费详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                        hidden: true,
                        level: 2,
                        isActiveName: 'trainingCenterPracticalTraining'
                    },
                },
                {
                    path: '/trainingCenter/practicalTraining/networkDetail',
                    name: 'examCenterExamDataNetworkDetail',
                    component: () =>
                        import ('../views/teacher/trainingCenter/NetworkPromotion'),
                    meta: {
                        title: '查看网络推广详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                        hidden: true,
                        level: 2,
                        isActiveName: 'trainingCenterPracticalTraining'
                    },
                },
                {
                    path: '/trainingCenter/practicalTraining/eCommerceCollectCleanDetail',
                    name: 'trainingCenterPracticalTrainingECommerceCollectCleanDetail',
                    component: () =>
                        import ('../views/student/train/trainCenter/ECommerceCollectCleanDetail'),
                    meta: {
                        title: '电子商务数据收集与清洗-查看详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                        hidden: true,
                        level: 2,
                        isActiveName: 'trainingCenterPracticalTraining'
                    },
                },
                // 电子商务收集 客户信息收集查看详情
                {
                    path: '/trainingCenter/practicalTraining/eCommerceCollectDetail',
                    name: 'trainingCenterPracticalTrainingECommerceCollectDetail',
                    component: () =>
                        import ('../views/student/train/trainCenter/ECommerceCollectDetail'),
                    meta: {
                        title: '客户信息收集-查看详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                        hidden: true,
                        level: 2,
                        isActiveName: 'trainingCenterPracticalTraining'
                    },
                },
                // 电子商务清洗 查看详情
                {
                    path: '/trainingCenter/practicalTraining/eCommerceCleanDetail',
                    name: 'trainingCenterPracticalTrainingECommerceCleanDetail',
                    component: () =>
                        import ('../views/student/train/trainCenter/ECommerceCleanDetail'),
                    meta: {
                        title: '电子商务数据清洗-查看详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                        hidden: true,
                        level: 2,
                        isActiveName: 'trainingCenterPracticalTraining'
                    },
                },
                // 三级电子商务数据分析与应用 查看答题详情
                {
                    path: '/trainingCenter/practicalTraining/eCommerceAnalysisApplicationDetail',
                    name: 'trainingCenterPracticalTrainingECommerceAnalysisApplicationDetail',
                    component: () =>
                        import ('../views/student/train/trainCenter/ECommerceAnalysisApplicationDetail'),
                    meta: {
                        title: '电子商务数据分析与应用-查看详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                        hidden: true,
                        level: 2,
                        isActiveName: 'trainingCenterPracticalTraining'
                    },
                },
                //网络客户服务
                {
                    path: '/trainingCenter/practicalTraining/cyberCustomerDetail',
                    name: 'strainingCenterPracticalTrainingCyberCustomerDetail',
                    component: () =>
                        import ('../views/student/train/trainCenter/cyberCustomerService/cyberCustomerDetail'),
                    meta: {
                        title: '网络客户服务--查看详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                        hidden: true,
                        isActiveName: 'trainingCenterPracticalTraining'
                    }
                },
                {
                    path: '/trainingCenter/practicalTraining/cyberCustomerService/ManagementDetail',
                    name: 'strainingCenterPracticalTrainingCyberCustomerServiceManagementDetail',
                    component: () =>
                        import ('../views/teacher/trainingCenter/cyberCustomerDetail'),
                    meta: {
                        title: '客户策略与分析--详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                        hidden: true,
                    },
                },
                //网络营销
                {
                    path: '/trainingCenter/practicalTraining/cyberMarketDetail',
                    name: 'strainingCenterPracticalTrainingCyberMarketDetail',
                    component: () =>
                        import ('../views/student/train/trainCenter/cyberMarketing/cyberMarketDetail'),
                    meta: {
                        title: '网络营销--查看详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                        hidden: true,
                        isActiveName: 'trainingCenterPracticalTraining'
                    }
                },
                //网店视觉设计
                {
                    path: '/trainingCenter/practicalTraining/onlineShopVisualDesignDetail',
                    name: 'strainingCenterPracticalTrainingOnlineShopVisualDesignDetail',
                    component: () =>
                        import ('../views/student/train/trainCenter/onlineShopVisualDesign/LookDetail'),
                    meta: {
                        title: '网店视觉设计--查看详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                        hidden: true,
                        isActiveName: 'trainingCenterPracticalTraining'
                    }
                },
                //三级网上交易管理查看详情
                {
                    path: '/trainingCenter/practicalTraining/onlineTradeManage/lookDetail',
                    name: 'strainingCenterPracticalTrainingOnlineTradeManageDesignDetail',
                    component: () =>
                        import ('../views/student/train/trainCenter/onlineTradeManage/LookDetail.vue'),
                    meta: {
                        title: '网上交易管理--答题详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                        hidden: true,
                        isActiveName: 'trainingCenterPracticalTraining'
                    }
                },
                {
                    path: '/trainingCenter/practicalTraining/onlineTradeManage/deliverAddressDetail',
                    name: 'strainingCenterPracticalTrainingOnlineTradeManageDeliverAddressDetail',
                    component: () =>
                        import ('../views/student/train/trainCenter/onlineTradeManage/DeliverAddressDetail.vue'),
                    meta: {
                        title: '网上交易管理-查看详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                        hidden: true,
                        isActiveName: 'trainingCenterPracticalTraining'
                    }
                },
                {
                    path: '/trainingCenter/practicalTraining/onlineTradeManage/distributionDetail',
                    name: 'strainingCenterPracticalTrainingOnlineTradeManageDistributionDetail',
                    component: () =>
                        import ('../views/student/train/trainCenter/onlineTradeManage/DistributionDetail.vue'),
                    meta: {
                        title: '配送管理-查看详情',
                        role: 3,
                        parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                        hidden: true,
                        isActiveName: 'trainingCenterPracticalTraining'
                    }
                },

            ]
        },
        {
            path: '/examCenter',
            name: 'examCenter',
            redirect: '/examCenter/examManagement',
            component: Main,
            meta: {
                title: '考试中心',
                icon: '&#xe62f;',
                role: 3
            },
            children: [{
                    path: '/examCenter/examManagement',
                    name: 'examCenterExamManagement',
                    component: () =>
                        import ('../views/teacher/examCenter/ExamManagement.vue'),
                    meta: {
                        title: '考试管理',
                        role: 3,
                        parentName: ['examCenter'],
                        isActiveName: 'examCenterExamManagement'
                    },
                },
                {
                    path: '/examCenter/create',
                    name: 'examCenterCreate',
                    component: () =>
                        import ('../views/teacher/examCenter/ExamCreate'),
                    meta: {
                        title: '创建考试',
                        role: 3,
                        parentName: ['examCenter', 'examCenterExamManagement'],
                        hidden: true,
                        isActiveName: 'examCenterExamManagement'
                    },
                },
                {
                    path: '/examCenter/examData',
                    name: 'examCenterExamData',
                    component: () =>
                        import ('../views/teacher/examCenter/ExamData.vue'),
                    meta: {
                        title: '考试数据',
                        role: 3,
                        parentName: ['examCenter'],
                        isActiveName: 'examCenterExamData'
                    },
                },
                {
                    path: '/examCenter/examData/student',
                    name: 'examCenterExamDataStudent',
                    component: () =>
                        import ('../views/teacher/examCenter/ExamDataStudent'),
                    meta: {
                        title: '学生数据',
                        role: 3,
                        parentName: ['examCenter', 'examCenterExamData'],
                        hidden: true,
                        isActiveName: 'examCenterExamData'
                    },
                },
                {
                    path: '/examCenter/examData/detail',
                    name: 'examCenterExamDataDetail',
                    component: ExamDataLayout,
                    meta: {
                        title: '考试数据详情',
                        role: 3,
                        parentName: ['examCenter', 'examCenterExamData'],
                        hidden: true,
                        isActiveName: 'examCenterExamData'
                    },
                    children: [{
                            path: '/examCenter/examData/theory',
                            name: 'examCenterExamDataTheory',
                            component: () =>
                                import ('../components/teacher/examCenter/examData/TheoryList'),
                            meta: {
                                title: '理论题',
                                tabName: 'examCenterExamDataTheory',
                                role: 3,
                                parentName: ['examCenter', 'examCenterExamData'],
                                isActiveName: 'examCenterExamData'
                            },
                        },
                        {
                            path: '/examCenter/examData/goodsInfo',
                            name: 'examCenterExamDataGoodsInfo',
                            component: () =>
                                import ('../components/teacher/examCenter/examData/GoodsInfo'),
                            meta: {
                                title: '商品信息采集与处理',
                                tabName: 'examCenterExamDataGoodsInfo',
                                role: 3,
                                parentName: ['examCenter', 'examCenterExamData'],
                                isActiveName: 'examCenterExamData'
                            },
                        },
                        {
                            path: '/examCenter/examData/storeDecorate',
                            name: 'examCenterExamDataStoreDecorate',
                            component: () =>
                                import ('../components/teacher/examCenter/examData/StoreDecorate'),
                            meta: {
                                title: '网店装修',
                                tabName: 'examCenterExamDataStoreDecorate',
                                role: 3,
                                parentName: ['examCenter', 'examCenterExamData'],
                                isActiveName: 'examCenterExamData'
                            },
                        },
                        {
                            path: '/examCenter/examData/storeManage',
                            name: 'examCenterExamDataStoreManage',
                            component: () =>
                                import ('../components/teacher/examCenter/examData/StoreManage'),
                            meta: {
                                title: '网店管理',
                                tabName: 'examCenterExamDataStoreManage',
                                role: 3,
                                parentName: ['examCenter', 'examCenterExamData'],
                                isActiveName: 'examCenterExamData'
                            },
                        },
                        {
                            path: '/examCenter/examData/networkPromote',
                            name: 'examCenterExamDataNetworkPromote',
                            component: () =>
                                import ('../components/teacher/examCenter/examData/NetworkPromote'),
                            meta: {
                                title: '网络推广',
                                tabName: 'examCenterExamDataNetworkPromote',
                                role: 3,
                                parentName: ['examCenter', 'examCenterExamData'],
                                isActiveName: 'examCenterExamData'
                            },
                        },
                        {
                            path: '/examCenter/examData/storeCustomer',
                            name: 'examCenterExamDataStoreCustomer',
                            component: () =>
                                import ('../components/teacher/examCenter/examData/StoreCustomer'),
                            meta: {
                                title: '网店客户服务',
                                tabName: 'examCenterExamDataStoreCustomer',
                                role: 3,
                                parentName: ['examCenter', 'examCenterExamData'],
                                isActiveName: 'examCenterExamData'
                            },
                        },
                        {
                            path: '/examCenter/examData/storeCustomerDetail',
                            name: 'examCenterExamDataStoreCustomerDetail',
                            component: () =>
                                import ('../components/teacher/examCenter/examData/StoreCustomerDetail'),
                            meta: {
                                title: '查看详情',
                                tabName: 'examCenterExamDataStoreCustomer',
                                role: 3,
                                parentName: ['examCenter', 'examCenterExamData'],
                                isActiveName: 'examCenterExamData'
                            },
                        },
                        {
                            path: '/examCenter/examData/eCommerceData',
                            name: 'examCenterExamDataECommerceData',
                            // component: () => import('../components/teacher/examCenter/examData/ECommerceData'),
                            component: () =>
                                import ('../views/student/train/trainCenter/ECommerceCollectCleanDetail'),
                            meta: {
                                title: '电子商务数据收集与清洗',
                                tabName: 'examCenterExamDataECommerceData',
                                role: 3,
                                parentName: ['examCenter', 'examCenterExamData'],
                                isActiveName: 'examCenterExamData'
                            },
                        },
                        {
                            path: '/examCenter/examData/cyberCustomer',
                            name: 'examCenterExamDataCyberCustomer',
                            component: () =>
                                import ('../components/teacher/examCenter/examData/CyberCustomer'),
                            meta: {
                                title: '网络客户服务',
                                tabName: 'examCenterExamDataCyberCustomer',
                                role: 3,
                                parentName: ['examCenter', 'examCenterExamData'],
                                isActiveName: 'examCenterExamData'
                            },
                        },
                        {
                            path: '/examCenter/examData/cyberMarketing',
                            name: 'examCenterExamDataCyberMarketing',
                            // component: () => import('../components/teacher/examCenter/examData/CyberMarketing'),
                            component: () =>
                                import ('../views/student/train/trainCenter/cyberMarketing/cyberMarketDetail'),
                            meta: {
                                title: '网络营销',
                                tabName: 'examCenterExamDataCyberMarketing',
                                role: 3,
                                parentName: ['examCenter', 'examCenterExamData'],
                                isActiveName: 'examCenterExamData'
                            },
                        },
                        {
                            path: '/examCenter/examData/eCommerceAnalysisApplicationDetail',
                            name: 'examCenterExamDataECommerceAnalysisApplicationDetail',
                            component: () =>
                                import ('../views/student/train/trainCenter/ECommerceAnalysisApplicationDetail'),
                            meta: {
                                title: '电子商务数据分析与应用',
                                tabName: 'examCenterExamDataECommerceAnalysisApplicationDetail',
                                role: 3,
                                parentName: ['examCenter', 'examCenterExamData'],
                                isActiveName: 'examCenterExamData'
                            },
                        },
                        {
                            path: '/examCenter/examData/onlineShopVisualDesignDetail',
                            name: 'examCenterExamDataOnlineShopVisualDesignDetail',
                            component: () =>
                                import ('../views/student/train/trainCenter/onlineShopVisualDesign/LookDetail.vue'),
                            meta: {
                                title: '网店视觉设计',
                                tabName: 'examCenterExamDataOnlineShopVisualDesignDetail',
                                role: 3,
                                parentName: ['examCenter', 'examCenterExamData'],
                                isActiveName: 'examCenterExamData'
                            },
                        },
                        {
                            path: '/examCenter/examData/onlineTradeManageDetail',
                            name: 'examCenterExamDataOnlineTradeManageDetail',
                            component: () =>
                                import ('../views/student/train/trainCenter/onlineTradeManage/LookDetail.vue'),
                            meta: {
                                title: '网上交易管理',
                                tabName: 'examCenterExamDataOnlineTradeManageDetail',
                                role: 3,
                                parentName: ['examCenter', 'examCenterExamData'],
                                isActiveName: 'examCenterExamData'
                            },
                        },
                    ]
                },
                //网上交易管理管理答题详情-考试中心
                {
                    path: '/examCenter/examData/onlineTradeManageDetail/deliverAddressDetail',
                    name: 'examCenterExamDataOnlineTradeManageDetailDeliverAddressDetail',
                    component: () =>
                        import ('../views/student/train/trainCenter/onlineTradeManage/DeliverAddressDetail.vue'),
                    meta: {
                        title: '网上交易管理-查看详情',
                        role: 3,
                        hidden: true,
                        parentName: ['examCenter', 'examCenterExamData'],
                        isActiveName: 'examCenterExamData',
                    }
                },
                {
                    path: '/examCenter/examData/distributionDetail',
                    name: 'examCenterExamDataDistributionDetail',
                    component: () =>
                        import ('../views/student/train/trainCenter/onlineTradeManage/DistributionDetail.vue'),
                    meta: {
                        title: '配送管理-查看详情',
                        role: 3,
                        hidden: true,
                        parentName: ['examCenter', 'examCenterExamData'],
                        isActiveName: 'examCenterExamData'
                    }
                },
                {
                    path: '/examCenter/examData/eCommerceCollectDetail',
                    name: 'examCenterExamDataECommerceCollectDetail',
                    component: () =>
                        import ('../views/student/train/trainCenter/ECommerceCollectDetail'),
                    meta: {
                        title: '客户信息收集-查看详情',
                        role: 3,
                        parentName: ['examCenter', 'examCenterExamData'],
                        hidden: true,
                        isActiveName: 'examCenterExamData'
                    },
                },
                {
                    path: '/examCenter/examData/eCommerceCleanDetail',
                    name: 'examCenterExamDataECommerceCleanDetail',
                    component: () =>
                        import ('../views/student/train/trainCenter/ECommerceCleanDetail'),
                    meta: {
                        title: '电子商务数据清洗-查看详情',
                        role: 3,
                        parentName: ['examCenter', 'examCenterExamData'],
                        hidden: true,
                        isActiveName: 'examCenterExamData'
                    },
                },
                {
                    path: '/examCenter/examData/freightDetail',
                    name: 'examCenterExamDataFreightDetail',
                    component: () =>
                        import ('../components/teacher/examCenter/examData/FreightDetail'),
                    meta: {
                        title: '查看运费详情',
                        tabName: 'examCenterExamDataFreightDetail',
                        role: 3,
                        parentName: ['examCenter', 'examCenterExamData'],
                        hidden: true,
                        level: 2,
                        isActiveName: 'examCenterExamData'
                    },
                },
                {
                    path: '/examCenter/trainingData',
                    name: 'examCenterTrainingData',
                    component: () =>
                        import ('../views/teacher/examCenter/TrainingData.vue'),
                    meta: {
                        title: '实训数据',
                        role: 3,
                        parentName: ['examCenter'],
                        isActiveName: 'examCenterTrainingData'
                    },
                },
                {
                    path: '/examCenter/trainingData/student',
                    name: 'examCenterTrainingDataStudent',
                    component: () =>
                        import ('../views/teacher/examCenter/TrainingDataStudent'),
                    meta: {
                        title: '学生数据',
                        role: 3,
                        parentName: ['examCenter', 'examCenterTrainingData'],
                        hidden: true,
                        isActiveName: 'examCenterTrainingData'
                    },
                },
                {
                    path: '/examCenter/trainingData/detail',
                    name: 'examCenterTrainingDataDetail',
                    component: TrainDataLayout,
                    meta: {
                        title: '实训数据详情',
                        role: 3,
                        parentName: ['examCenter', 'examCenterTrainingData'],
                        hidden: true,
                        isActiveName: 'examCenterTrainingData'
                    },
                    children: [{
                            path: '/examCenter/trainingData/theory',
                            name: 'examCenterTrainingDataTheory',
                            component: () =>
                                import ('../components/teacher/examCenter/examData/TheoryList'),
                            meta: {
                                title: '理论题',
                                tabName: 'examCenterTrainingDataTheory',
                                role: 3,
                                parentName: ['examCenter', 'examCenterTrainingData'],
                                isActiveName: 'examCenterTrainingData'
                            },
                        },
                        {
                            path: '/examCenter/trainingData/goodsInfo',
                            name: 'examCenterTrainingDataGoodsInfo',
                            component: () =>
                                import ('../components/teacher/examCenter/examData/GoodsInfo'),
                            meta: {
                                title: '商品信息采集与处理',
                                tabName: 'examCenterTrainingDataGoodsInfo',
                                role: 3,
                                parentName: ['examCenter', 'examCenterTrainingData'],
                                isActiveName: 'examCenterTrainingData'
                            },
                        },
                        {
                            path: '/examCenter/trainingData/storeDecorate',
                            name: 'examCenterTrainingDataStoreDecorate',
                            component: () =>
                                import ('../components/teacher/examCenter/examData/StoreDecorate'),
                            meta: {
                                title: '网店装修',
                                tabName: 'examCenterTrainingDataStoreDecorate',
                                role: 3,
                                parentName: ['examCenter', 'examCenterTrainingData'],
                                isActiveName: 'examCenterTrainingData'
                            },
                        },
                        {
                            path: '/examCenter/trainingData/storeManage',
                            name: 'examCenterTrainingDataStoreManage',
                            component: () =>
                                import ('../components/teacher/examCenter/examData/StoreManage'),
                            meta: {
                                title: '网店管理',
                                tabName: 'examCenterTrainingDataStoreManage',
                                role: 3,
                                parentName: ['examCenter', 'examCenterTrainingData'],
                                isActiveName: 'examCenterTrainingData'
                            },
                        },
                        {
                            path: '/examCenter/trainingData/networkPromote',
                            name: 'examCenterTrainingDataNetworkPromote',
                            component: () =>
                                import ('../components/teacher/examCenter/examData/NetworkPromote'),
                            meta: {
                                title: '网络推广',
                                tabName: 'examCenterTrainingDataNetworkPromote',
                                role: 3,
                                parentName: ['examCenter', 'examCenterTrainingData'],
                                isActiveName: 'examCenterTrainingData'
                            },
                        },
                        {
                            path: '/examCenter/trainingData/storeCustomer',
                            name: 'examCenterTrainingDataStoreCustomer',
                            component: () =>
                                import ('../components/teacher/examCenter/examData/StoreCustomer'),
                            meta: {
                                title: '网店客户服务',
                                tabName: 'examCenterTrainingDataStoreCustomer',
                                role: 3,
                                parentName: ['examCenter', 'examCenterTrainingData'],
                                isActiveName: 'examCenterTrainingData'
                            },
                        },
                        {
                            path: '/examCenter/trainingData/storeCustomerDetail',
                            name: 'examCenterTrainingDataStoreCustomerDetail',
                            component: () =>
                                import ('../components/teacher/examCenter/examData/StoreCustomerDetail'),
                            meta: {
                                title: '查看详情',
                                tabName: 'examCenterTrainingDataStoreCustomer',
                                role: 3,
                                parentName: ['examCenter', 'examCenterTrainingData'],
                                isActiveName: 'examCenterTrainingData'
                            },
                        },
                        {
                            path: '/examCenter/trainingData/eCommerceData',
                            name: 'examCenterTrainingDataECommerceData',
                            // component: () => import('../components/teacher/examCenter/examData/ECommerceData'),
                            component: () =>
                                import ('../views/student/train/trainCenter/ECommerceCollectCleanDetail'),
                            meta: {
                                title: '电子商务数据收集与清洗',
                                tabName: 'examCenterTrainingDataECommerceData',
                                role: 3,
                                parentName: ['examCenter', 'examCenterTrainingData'],
                                isActiveName: 'examCenterTrainingData'
                            },
                        },
                        {
                            path: '/examCenter/trainingData/cyberCustomer',
                            name: 'examCenterTrainingDataCyberCustomer',
                            component: () =>
                                import ('../components/teacher/examCenter/examData/CyberCustomer'),
                            meta: {
                                title: '网络客户服务',
                                tabName: 'examCenterTrainingDataCyberCustomer',
                                role: 3,
                                parentName: ['examCenter', 'examCenterTrainingData'],
                                isActiveName: 'examCenterTrainingData'
                            },
                        },
                        {
                            path: '/examCenter/trainingData/cyberMarketing',
                            name: 'examCenterTrainingDataCyberMarketing',
                            // component: () => import('../components/teacher/examCenter/examData/CyberMarketing'),
                            component: () =>
                                import ('../views/student/train/trainCenter/cyberMarketing/cyberMarketDetail'),
                            meta: {
                                title: '网络营销',
                                tabName: 'examCenterTrainingDataCyberMarketing',
                                role: 3,
                                parentName: ['examCenter', 'examCenterTrainingData'],
                                isActiveName: 'examCenterTrainingData'
                            },
                        },
                        {
                            path: '/examCenter/trainingData/onlineShopVisualDesignDetail',
                            name: 'examCenterTrainingDataOnlineShopVisualDesignDetail',
                            component: () =>
                                import ('../views/student/train/trainCenter/onlineShopVisualDesign/LookDetail.vue'),
                            meta: {
                                title: '网店视觉设计',
                                tabName: 'examCenterTrainingDataOnlineShopVisualDesignDetail',
                                role: 3,
                                parentName: ['examCenter', 'examCenterTrainingData'],
                                isActiveName: 'examCenterTrainingData'
                            },
                        },
                        {
                            path: '/examCenter/trainingData/onlineTradeManageDetail',
                            name: 'examCenterTrainingDataOnlineTradeManageDetail',
                            component: () =>
                                import ('../views/student/train/trainCenter/onlineTradeManage/LookDetail.vue'),
                            meta: {
                                title: '网上交易管理',
                                tabName: 'examCenterTrainingDataOnlineTradeManageDetail',
                                role: 3,
                                parentName: ['examCenter', 'examCenterTrainingData'],
                                isActiveName: 'examCenterTrainingData'
                            },
                        },
                        {
                            path: '/examCenter/trainingData/eCommerceAnalysisApplicationDetail',
                            name: 'examCenterTrainingDataECommerceAnalysisApplicationDetail',
                            component: () =>
                                import ('../views/student/train/trainCenter/ECommerceAnalysisApplicationDetail'),
                            meta: {
                                title: '电子商务数据分析与应用',
                                tabName: 'examCenterTrainingDataECommerceAnalysisApplicationDetail',
                                role: 3,
                                parentName: ['examCenter', 'examCenterTrainingData'],
                                isActiveName: 'examCenterTrainingData'
                            },
                        },
                    ],
                },
                {
                    path: '/examCenter/trainingData/eCommerceCollectDetail',
                    name: 'examCenterTrainingDataECommerceCollectDetail',
                    component: () =>
                        import ('../views/student/train/trainCenter/ECommerceCollectDetail'),
                    meta: {
                        title: '客户信息收集-查看详情',
                        role: 3,
                        parentName: ['examCenter', 'examCenterTrainingData'],
                        hidden: true,
                        isActiveName: 'examCenterTrainingData'
                    },
                },
                {
                    path: '/examCenter/trainingData/eCommerceCleanDetail',
                    name: 'examCenterTrainingDataECommerceCleanDetail',
                    component: () =>
                        import ('../views/student/train/trainCenter/ECommerceCleanDetail'),
                    meta: {
                        title: '电子商务数据清洗-查看详情',
                        role: 3,
                        parentName: ['examCenter', 'examCenterTrainingData'],
                        hidden: true,
                        isActiveName: 'examCenterTrainingData'
                    },
                },

                {
                    path: '/examCenter/trainingData/freightDetail',
                    name: 'examCenterTrainingDataFreightDetail',
                    component: () =>
                        import ('../components/teacher/examCenter/examData/FreightDetail'),
                    meta: {
                        title: '查看运费详情',
                        tabName: 'examCenterTrainingDataFreightDetail',
                        role: 3,
                        parentName: ['examCenter', 'examCenterTrainingData'],
                        level: 2,
                        hidden: true,
                        isActiveName: 'examCenterTrainingData'

                    },
                },
            ]
        },
        {
            path: '/evaluationCenter',
            name: 'evaluationCenter',
            redirect: '/evaluationCenter/scoreManagement',
            component: Main,
            meta: {
                title: '评价中心',
                icon: '&#xe663;',
                role: 3
            },
            children: [{
                    path: '/evaluationCenter/scoreManagement',
                    name: 'evaluationCenterScoreManagement',
                    component: () =>
                        import ('../views/teacher/evaluationCenter/ScoreManagement.vue'),
                    meta: {
                        title: '评分管理',
                        role: 3,
                        parentName: ['evaluationCenter'],
                        isActiveName: 'evaluationCenterScoreManagement'
                    },
                },
                {
                    path: '/evaluationCenter/theoreticalQuestions',
                    name: 'evaluationCenterTheoreticalQuestions',
                    redirect: '/evaluationCenter/theoreticalQuestions/index',
                    component: JudgesTypeLayout,
                    meta: {
                        title: '理论题',
                        role: 3,
                        parentName: ['evaluationCenter', 'evaluationCenterScoreManagement'],
                        hidden: true,
                        isActiveName: 'evaluationCenterScoreManagement'
                    },
                    children: [{
                            path: '/evaluationCenter/theoreticalQuestions/index',
                            name: 'evaluationCenterTheoreticalQuestionsIndex',
                            component: () =>
                                import ('../views/judges/theoreticalQuestions/Index.vue'),
                            meta: {
                                title: '理论题',
                                role: 3,
                                tabName: 'evaluationCenterTheoreticalQuestionsIndex',
                                parentName: ['evaluationCenter', 'evaluationCenterScoreManagement'],
                                isActiveName: 'evaluationCenterScoreManagement'
                            },
                        },
                        {
                            path: '/evaluationCenter/theoreticalQuestions/markTheoryPaper',
                            name: 'evaluationCenterTheoreticalQuestionsMarkTheoryPaper',
                            component: () =>
                                import ('../views/judges/theoreticalQuestions/MarkTheoryPaper.vue'),
                            meta: {
                                title: '批改',
                                role: 3,
                                tabName: 'evaluationCenterTheoreticalQuestionsIndex',
                                parentName: ['evaluationCenter', 'evaluationCenterScoreManagement'],
                                isActiveName: 'evaluationCenterScoreManagement'
                            },
                        },
                        {
                            path: '/evaluationCenter/goodsInfo/index',
                            name: 'evaluationCenterGoodsInfoIndex',
                            component: () =>
                                import ('../views/judges/goodsInfo/Index.vue'),
                            meta: {
                                title: '商品信息采集与处理',
                                role: 3,
                                tabName: 'evaluationCenterGoodsInfoIndex',
                                parentName: ['evaluationCenter', 'evaluationCenterScoreManagement'],
                                isActiveName: 'evaluationCenterScoreManagement'
                            },
                        },
                        {
                            path: '/evaluationCenter/onlineShopDecoration/index',
                            name: 'evaluationCenterOnlineShopDecorationIndex',
                            component: () =>
                                import ('../views/judges/onlineShopDecoration/Index.vue'),
                            meta: {
                                title: '网店装修',
                                role: 3,
                                tabName: 'evaluationCenterOnlineShopDecorationIndex',
                                parentName: ['evaluationCenter', 'evaluationCenterScoreManagement'],
                                isActiveName: 'evaluationCenterScoreManagement'
                            },
                        },
                        {
                            path: '/evaluationCenter/webPromotion/index',
                            name: 'evaluationCenterWebPromotionIndex',
                            component: () =>
                                import ('../views/judges/webPromotion/Index.vue'),
                            meta: {
                                title: '网络推广',
                                role: 3,
                                tabName: 'evaluationCenterWebPromotionIndex',
                                parentName: ['evaluationCenter', 'evaluationCenterScoreManagement'],
                                isActiveName: 'evaluationCenterScoreManagement'
                            },
                        },
                        {
                            path: '/evaluationCenter/cyberCustomer/index',
                            name: 'evaluationCenterCyberCustomerIndex',
                            component: () =>
                                import ('../views/judges/cyberCustomerService/Index.vue'),
                            meta: {
                                title: '网络客户服务',
                                role: 3,
                                tabName: 'evaluationCenterCyberCustomerIndex',
                                parentName: ['evaluationCenter', 'evaluationCenterScoreManagement'],
                                isActiveName: 'evaluationCenterScoreManagement'
                            }
                        },
                        {
                            path: '/evaluationCenter/cyberMarketing/index',
                            name: 'evaluationCenterCyberMarketingIndex',
                            component: () =>
                                import ('../views/judges/cyberMarketing/Index.vue'),
                            meta: {
                                title: '网络营销',
                                role: 3,
                                tabName: 'evaluationCenterCyberMarketingIndex                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     ',
                                parentName: ['evaluationCenter', 'evaluationCenterScoreManagement'],
                                isActiveName: 'evaluationCenterScoreManagement'
                            },
                        },
                        {
                            path: '/evaluationCenter/eCommerceAnalysisApplication/index',
                            name: 'evaluationCenterECommerceAnalysisApplicationIndex',
                            component: () =>
                                import ('../views/judges/eCommerceAnalysisApplication/Index'),
                            meta: {
                                title: '电子商务数据分析与应用',
                                role: 3,
                                tabName: 'evaluationCenterECommerceAnalysisApplicationIndex',
                                parentName: ['evaluationCenter', 'evaluationCenterScoreManagement'],
                                isActiveName: 'evaluationCenterScoreManagement'
                            },
                        },
                        {
                            path: '/evaluationCenter/storeVisualDesign/index',
                            name: 'evaluationCenterStoreVisualDesignIndex',
                            component: () =>
                                import ('../views/judges/storeVisualDesign/Index'),
                            meta: {
                                title: '网店视觉设计',
                                role: 3,
                                tabName: 'evaluationCenterStoreVisualDesignIndex',
                                parentName: ['evaluationCenter', 'evaluationCenterScoreManagement'],
                                isActiveName: 'evaluationCenterScoreManagement'
                            },
                        },
                    ]
                },
                {
                    path: '/evaluationCenter/certificateManagement',
                    name: 'evaluationCenterCertificateManagement',
                    redirect: '/evaluationCenter/certificateManagement/index',
                    component: CertificateLayout,
                    // component: () => import('../views/teacher/evaluationCenter/CertificateManagement.vue'),
                    meta: {
                        title: '证书管理',
                        role: 3,
                        parentName: ['evaluationCenter'],
                        isActiveName: 'evaluationCenterCertificateManagement',
                    },
                    children: [{
                            path: '/evaluationCenter/certificateManagement/index',
                            name: 'evaluationCenterCertificateManagementIndex',
                            component: () =>
                                import ('../views/teacher/evaluationCenter/Index.vue'),
                            meta: {
                                title: '证书管理',
                                role: 3,
                                tabName: 'evaluationCenterCertificateManagementIndex',
                                parentName: ['evaluationCenter', 'evaluationCenterCertificateManagement'],
                                isActiveName: 'evaluationCenterCertificateManagement'
                            },
                        },
                        {
                            path: '/evaluationCenter/certificateManagement/model',
                            name: 'evaluationCenterCertificateManagementModel',
                            component: () =>
                                import ('../views/teacher/evaluationCenter/Model.vue'),
                            meta: {
                                title: '证书模板',
                                role: 3,
                                tabName: 'evaluationCenterCertificateManagementModel',
                                parentName: ['evaluationCenter', 'evaluationCenterCertificateManagement'],
                                isActiveName: 'evaluationCenterCertificateManagement'
                            },
                        },
                    ],
                },
                {
                    path: '/evaluationCenter/getCertificateList',
                    name: 'evaluationCenterGetCertificateList',
                    component: () =>
                        import ('../views/teacher/evaluationCenter/GetCertificateList.vue'),
                    meta: {
                        title: '已获得证书',
                        role: 3,
                        parentName: ['evaluationCenter', 'evaluationCenterCertificateManagement'],
                        hidden: true,
                        isActiveName: 'evaluationCenterCertificateManagement'
                    },
                },
                {
                    path: '/evaluationCenter/noGetCertificateList',
                    name: 'evaluationCenterNoGetCertificateList',
                    component: () =>
                        import ('../views/teacher/evaluationCenter/NoGetCertificateList.vue'),
                    meta: {
                        title: '未获得证书',
                        role: 3,
                        parentName: ['evaluationCenter', 'evaluationCenterCertificateManagement'],
                        hidden: true,
                        isActiveName: 'evaluationCenterCertificateManagement'
                    },
                },
                {
                    path: '/evaluationCenter/viewCertificate',
                    name: 'evaluationCenterViewCertificate',
                    component: () =>
                        import ('../views/teacher/evaluationCenter/ViewCertificate.vue'),
                    meta: {
                        title: '查看证书',
                        role: 3,
                        parentName: ['evaluationCenter', 'evaluationCenterCertificateManagement'],
                        hidden: true,
                        level: 2,
                        isActiveName: 'evaluationCenterCertificateManagement'
                    },
                },
                {
                    path: '/evaluationCenter/generateCertificate',
                    name: 'evaluationCenterGenerateCertificate',
                    component: () =>
                        import ('../views/teacher/evaluationCenter/GenerateCertificate.vue'),
                    meta: {
                        title: '生成证书',
                        role: 3,
                        parentName: ['evaluationCenter', 'evaluationCenterCertificateManagement'],
                        hidden: true,
                        level: 2,
                    },
                },
                {
                    path: '/evaluationCenter/certificateModel',
                    name: 'evaluationCenterCertificateModel',
                    component: () =>
                        import ('../views/teacher/evaluationCenter/CertificateModel.vue'),
                    meta: {
                        title: '添加证书模板',
                        role: 3,
                        parentName: ['evaluationCenter', 'evaluationCenterCertificateManagement'],
                        hidden: true,
                        level: 2,
                        isActiveName: 'evaluationCenterCertificateManagement'
                    },
                },
                {
                    path: '/evaluationCenter/reportManagement',
                    name: 'evaluationCenterReportManagement',
                    component: () =>
                        import ('../views/teacher/evaluationCenter/ReportManagement.vue'),
                    meta: {
                        title: '报告管理',
                        role: 3,
                        parentName: ['evaluationCenter'],
                        isActiveName: 'evaluationCenterReportManagement'
                    },
                },
                {
                    path: '/evaluationCenter/reportManagement/detail',
                    name: 'ReportManagementDetail',
                    component: () =>
                        import ('../components/teacher/reportManage/reportDetail'),
                    meta: {
                        title: '报告管理-详情',
                        role: 3,
                        parentName: ['evaluationCenter', 'evaluationCenterReportManagement'],
                        hidden: true,
                        isActiveName: 'evaluationCenterReportManagement'
                    },
                },
                {
                    path: '/evaluationCenter/reportManagement/singleReport',
                    name: 'ReportManagementSingleReport',
                    component: () =>
                        import ('../views/teacher/evaluationCenter/SingleReport'),
                    meta: {
                        title: '报告管理-详情',
                        role: 3,
                        parentName: ['evaluationCenter'],
                        hidden: true,
                        level: 2,
                        isActiveName: 'evaluationCenterReportManagement'
                    },
                },
            ]
        },
        {
            path: '/dataCenter',
            name: 'dataCenter',
            redirect: '/dataCenter/index',
            component: Main,
            meta: {
                title: '数据中心',
                role: 3,
                icon: '&#xe70e;',
                // showRoute:false,
            },
            children: [{
                    path: '/dataCenter/index',
                    name: 'dataCenterIndex',
                    component: () =>
                        import ('../views/teacher/dataCenter/Index.vue'),
                    meta: {
                        title: '数据中心',
                        role: 3,
                        parentName: ['dataCenter'],
                        hidden: true,
                    }
                },
                {
                    path: '/dataCenter/detail',
                    name: 'dataCenterDetail',
                    component: () =>
                        import ('../views/teacher/dataCenter/Detail.vue'),
                    meta: {
                        title: '班级数据',
                        role: 3,
                        parentName: ['dataCenter']
                    }
                },
            ]
        },
        {
            path: '/educationCenter',
            name: 'educationCenter',
            redirect: '/educationCenter/ClassManagement',
            component: Main,
            meta: {
                title: '教务中心',
                icon: '&#xe66d;',
                role: 3
            },
            children: [{
                    path: '/educationCenter/classManagement',
                    name: 'educationCenterClassManagement',
                    component: () =>
                        import ('../views/teacher/educationCenter/ClassManagement.vue'),
                    meta: {
                        title: '班级管理',
                        role: 3,
                        parentName: ['educationCenter'],
                        isActiveName: 'educationCenterClassManagement'
                    },
                },
                {
                    path: '/educationCenter/studentManagement',
                    name: 'educationCenterStudentManagement',
                    component: () =>
                        import ('../views/teacher/educationCenter/StudentManagement.vue'),
                    meta: {
                        title: '学生管理',
                        role: 3,
                        parentName: ['educationCenter'],
                        isActiveName: 'educationCenterStudentManagement'
                    },
                }
            ]
        },
        {
            path: '/teacher/articleDetail',
            name: 'teacherArticleDetail',
            component: () =>
                import ('../views/teacher/articleDetail.vue'),
            meta: {
                title: '软文详情',
                role: 3,
                tabName: 'teacherArticleDetail',
                hidden: true,
            },
        },
        {
            path: '/teacher/cyberCustomerDetail',
            name: 'teacherCyberCustomerDetail',
            component: () =>
                import ('../views/teacher/cyberCustomerDetail.vue'),
            meta: {
                title: '网络客户服务--查看详情',
                role: 3,
                tabName: 'teacherCyberCustomerDetail',
                hidden: true,
            },
        },
    ]
}]
export const judgesRoutes = [{
    path: '/judges',
    name: 'judges',
    redirect: '/judges/grading/index',
    component: JudgesLayout,
    children: [{
            path: '/judges/grading',
            name: 'judgesGrading',
            redirect: '/judges/grading/index',
            component: Main,
            meta: {
                title: '评分管理',
                role: 4
            },
            children: [{
                    path: '/judges/grading/index',
                    name: 'judgesGradingIndex',
                    component: () =>
                        import ('../views/judges/grading/Index.vue'),
                    meta: {
                        title: '评分管理',
                        role: 4,
                        parentName: ['judgesGrading']
                    }
                },
                {
                    path: '/judges/theoreticalQuestions',
                    name: 'judgesTheoreticalQuestions',
                    redirect: '/judges/theoreticalQuestions/index',
                    component: JudgesTypeLayout,
                    meta: {
                        title: '理论题',
                        role: 4
                    },
                    children: [{
                            path: '/judges/theoreticalQuestions/index',
                            name: 'judgesTheoreticalQuestionsIndex',
                            component: () =>
                                import ('../views/judges/theoreticalQuestions/Index.vue'),
                            meta: {
                                title: '理论题',
                                role: 4,
                                tabName: 'judgesTheoreticalQuestionsIndex',
                                parentName: ['judgesGrading']
                            },
                        },
                        {
                            path: '/judges/theoreticalQuestions/markTheoryPaper',
                            name: 'judgesTheoreticalQuestionsMarkTheoryPaper',
                            component: () =>
                                import ('../views/judges/theoreticalQuestions/MarkTheoryPaper.vue'),
                            meta: {
                                title: '批改',
                                role: 4,
                                tabName: 'judgesTheoreticalQuestionsIndex',
                                parentName: ['judgesGrading', 'judgesTheoreticalQuestionsIndex']
                            },
                        },
                        {
                            path: '/judges/goodsInfo/index',
                            name: 'judgesGoodsInfoIndex',
                            component: () =>
                                import ('../views/judges/goodsInfo/Index.vue'),
                            meta: {
                                title: '商品信息采集与处理',
                                role: 4,
                                tabName: 'judgesGoodsInfoIndex',
                                parentName: ['judgesGrading']
                            },
                        },
                        {
                            path: '/judges/onlineShopDecoration/index',
                            name: 'judgesOnlineShopDecorationIndex',
                            component: () =>
                                import ('../views/judges/onlineShopDecoration/Index.vue'),
                            meta: {
                                title: '网店装修',
                                role: 4,
                                tabName: 'judgesOnlineShopDecorationIndex',
                                parentName: ['judgesGrading']
                            },
                        },
                        {
                            path: '/judges/onlineShopDecoration/pageSet',
                            name: 'judgesOnlineShopDecorationPageSet',
                            component: () =>
                                import ('../views/judges/onlineShopDecoration/UserPageDesign'),
                            meta: {
                                title: '线上店铺设计与装修',
                                role: 4,
                                tabName: 'judgesOnlineShopDecorationPageSet',
                                parentName: ['judgesGrading']
                            },
                        },
                        {
                            path: '/judges/onlineShopDecoration/pageSetOld',
                            name: 'judgesOnlineShopDecorationPageSetOld',
                            component: () =>
                                import ('../views/judges/onlineShopDecoration/PageSet'),
                            meta: {
                                title: '线上店铺设计与装修',
                                role: 4,
                                tabName: 'judgesOnlineShopDecorationPageSet',
                                parentName: ['judgesGrading']
                            },
                        },
                        {
                            path: '/judges/webPromotion/index',
                            name: 'judgesWebPromotionIndex',
                            component: () =>
                                import ('../views/judges/webPromotion/Index.vue'),
                            meta: {
                                title: '网络推广',
                                role: 4,
                                tabName: 'judgesWebPromotionIndex',
                                parentName: ['judgesGrading']
                            },
                        },
                        {
                            path: '/judges/cyberCustomer/index',
                            name: 'judgesCyberCustomerIndex',
                            component: () =>
                                import ('../views/judges/cyberCustomerService/Index.vue'),
                            meta: {
                                title: '网络客户服务',
                                role: 4,
                                tabName: 'judgesCyberCustomerIndex',
                                parentName: ['judgesGrading']
                            },
                        },
                        {
                            path: '/judgesTheerExamManage/examData/cyberCustomer',
                            name: 'judgesTheerExamManageExamDataCyberCustomer',
                            component: () =>
                                import ('../components/teacher/examCenter/examData/jdTheerCyberCustomer'),
                            meta: {
                                title: '网络客户服务',
                                tabName: 'judgesTheerExamManageExamDataCyberCustomer',
                                role: 4,
                                parentName: ['judgesGrading'],
                                hidden: true,
                            },
                        },
                        {
                            path: '/judges/cyberMarketing/index',
                            name: 'judgesCenterCyberMarketingIndex',
                            component: () =>
                                import ('../views/judges/cyberMarketing/Index.vue'),
                            meta: {
                                title: '网络营销',
                                role: 4,
                                tabName: 'judgesCenterCyberMarketingIndex',
                                parentName: ['judgesGrading']
                            },
                        },
                        {
                            path: '/judges/eCommerceAnalysisApplication/index',
                            name: 'judgesCenterECommerceAnalysisApplicationIndex',
                            component: () =>
                                import ('../views/judges/eCommerceAnalysisApplication/Index'),
                            meta: {
                                title: '电子商务数据分析与应用',
                                role: 4,
                                tabName: 'judgesCenterECommerceAnalysisApplicationIndex',
                                parentName: ['judgesGrading']
                            },
                        },
                        {
                            path: '/judges/storeVisualDesign/index',
                            name: 'judgesCenterStoreVisualDesignIndex',
                            component: () =>
                                import ('../views/judges/storeVisualDesign/Index'),
                            meta: {
                                title: '网店视觉设计',
                                role: 4,
                                tabName: 'judgesCenterStoreVisualDesignIndex',
                                parentName: ['judgesGrading']
                            },
                        },
                    ]
                },
            ]
        },
        {
            path: '/judges/pw',
            redirect: '/judges/pwdata',
            name: 'judegesPwData',
            component: JudgesMain,
            meta: {
                title: "考试数据",
                role: 4,
            },
            children: [{
                path: '/judges/pwdata',
                name: 'judgesPwDatas',
                component: () =>
                    import ("../views/evaluation/examManage/ExamData"),
                meta: {
                    title: "考试数据",
                    role: 4,
                    parentName: ['judegesPwData']
                }
            }, {
                path: '/judges/examstudata',
                name: 'judegesStuDatas',
                component: () =>
                    import ("../views/evaluation/examManage/ExamDataStudent"),
                meta: {
                    title: "考生数据",
                    role: 4,
                    parentName: ['judegesPwData'],
                    hidden: true,
                }
            }],
        },
        {
            path: "/judgesManage/judgesData/detail",
            name: "judgesManageExamDataDetail",
            redirect: '/judgesManage/judgesData/theory',
            component: EvaluationExamDataLayout,
            meta: {
                title: "考试数据详情",
                role: 4,
                hidden: true,
            },
            children: [{
                    path: "/judgesManage/judgesData/theory",
                    name: "judgesManageExamDataTheory",
                    component: () =>
                        import (
                            "../components/evaluation/TheoryList"
                        ),
                    meta: {
                        title: "理论题",
                        tabName: "judgesManageExamDataTheory",
                        role: 4,
                        parentName: ["judgesManageExamDataDetail", 'judegesPwData'],
                        hidden: true,
                    },
                },
                {
                    path: "/judgesManage/judgesData/goodsInfo",
                    name: "judgesManageExamDataGoodsInfo",
                    component: () =>
                        import ("../components/evaluation/GoodsInfo"),
                    meta: {
                        title: "产品及服务信息管理",
                        tabName: "judgesManageExamDataGoodsInfo",
                        role: 4,
                        parentName: ["judgesManageExamDataDetail", 'judegesPwData', ],
                        hidden: true,
                    },
                },
                {
                    path: "/stu/examManage/examData/storeManage",
                    name: "stuExamManageExamDataStoreManage",
                    component: () =>
                        import (
                            "../components/evaluation/StoreManage"
                        ),
                    meta: {
                        title: "业务处理",
                        tabName: "stuExamManageExamDataStoreManage",
                        role: 4,
                        parentName: ["judgesManageExamDataDetail", 'judegesPwData'],
                        hidden: true,
                    },
                },
                {
                    path: "/judgesManage/judgesData/storeDecorate",
                    name: "judgesManageExamDataStoreDecorate",
                    component: () =>
                        import (
                            "../components/evaluation/StoreDecorate"
                        ),
                    meta: {
                        title: "线上店铺设计与装修",
                        tabName: "judgesManageExamDataStoreDecorate",
                        role: 4,
                        parentName: ["judgesManageExamDataDetail", 'judegesPwData'],
                        hidden: true,
                    },
                },
                {
                    path: "/judgesManage/judgesData/storeManage",
                    name: "judgesManageExamDataStoreManage",
                    component: () =>
                        import (
                            "../components/evaluation/StoreManage"
                        ),
                    meta: {
                        title: "业务处理",
                        tabName: "judgesManageExamDataStoreManage",
                        role: 4,
                        parentName: ["judgesManageExamDataDetail", 'judegesPwData'],
                        hidden: true,
                    },
                },
                {
                    path: "/judgesManage/judgesData/networkPromote",
                    name: "judgesManageExamDataNetworkPromote",
                    component: () =>
                        import (
                            "../components/evaluation/NetworkPromote"
                        ),
                    meta: {
                        title: "营销推广",
                        tabName: "judgesManageExamDataNetworkPromote",
                        role: 4,
                        parentName: ["judgesManageExamDataDetail", 'judegesPwData'],
                        hidden: true,
                    },

                },

                {
                    path: "/judgesManage/judgesData/storeCustomer",
                    name: "judgesManageExamDataStoreCustomer",
                    component: () =>
                        import (
                            "../components/evaluation/StoreCustomer"
                        ),
                    meta: {
                        title: "客户服务",
                        tabName: "judgesManageExamDataStoreCustomer",
                        role: 4,
                        parentName: ["judgesManageExamDataDetail", 'judegesPwData'],
                        hidden: true,
                    },
                },
                {
                    path: "/judgesManage/judgesData/storeCustomerDetail",
                    name: "judgesManageExamDataStoreCustomerDetail",
                    component: () =>
                        import (
                            "../components/evaluation/StoreCustomerDetail"
                        ),
                    meta: {
                        title: "查看详情",
                        tabName: "judgesManageExamDataStoreCustomer",
                        role: 4,
                        parentName: ["judgesManageExamDataDetail", 'judegesPwData'],
                        hidden: true,
                    },
                },
                {
                    path: "/judgesManage/judgesData/eCommerceData",
                    name: "judgesManageExamDataECommerceData",
                    component: () =>
                        import (
                            "../views/student/train/trainCenter/ECommerceCollectCleanDetail"
                        ),
                    meta: {
                        title: "商务数据分析",
                        tabName: "judgesManageExamDataECommerceData",
                        role: 4,
                        parentName: ["judgesManageExamDataDetail", 'judegesPwData'],
                        hidden: true,
                    },
                },
                {
                    path: '/jd/judgesCenter/examData/eCommerceCollectDetail',
                    name: 'judgesCenterExamDataECommerceCollectDetail',
                    component: () =>
                        import ('../views/student/train/trainCenter/ECommerceCollectDetail'),
                    meta: {
                        title: '客户信息收集-查看详情',
                        role: 4,
                        parentName: ['judgesManageExamDataDetail', 'judegesPwData'],
                        hidden: true
                    },
                },

                {
                    path: '/judgesManage/examData/onlineShopVisualDesignDetail',
                    name: 'judgesManageExamDataOnlineShopVisualDesignDetail',
                    // component: () =>
                    //     import ('../views/student/train/trainCenter/onlineShopVisualDesign/LookDetail.vue'),
                    component: () =>
                        import (
                            "../components/evaluation/StoreDecorate"
                            ),
                    meta: {
                        title: '网店视觉设计',
                        tabName: 'judgesManageExamDataOnlineShopVisualDesignDetail',
                        role: 4,
                        parentName: ['judgesManageExamDataDetail', 'judegesPwData'],
                        hidden: true,
                    },
                },
                {
                    path: '/judgesManage/examData/cyberMarketing',
                    name: 'judgesManageExamDataCyberMarketing',
                    // component: () => import('../components/teacher/examCenter/examData/CyberMarketing'),
                    component: () =>
                        import ('../views/student/train/trainCenter/cyberMarketing/cyberMarketDetail'),
                    meta: {
                        title: '网络营销',
                        tabName: 'judgesManageExamDataCyberMarketing',
                        role: 4,
                        parentName: ['judgesManageExamDataDetail', 'judegesPwData'],
                        hidden: true,
                    },
                },
                {
                    path: '/judgesManage/examData/onlineTradeManageDetail',
                    name: 'judgesManageExamDataOnlineTradeManageDetail',
                    component: () =>
                        import ('../views/student/train/trainCenter/onlineTradeManage/LookDetail.vue'),
                    meta: {
                        title: '网上交易管理',
                        tabName: 'judgesManageExamDataOnlineTradeManageDetail',
                        role: 4,
                        parentName: ['judgesManageExamDataDetail', 'judegesPwData'],
                        hidden: true,
                    },
                },
                {
                    path: '/judgesManage/examData/cyberCustomer',
                    name: 'judgesManageExamDataCyberCustomer',
                    component: () =>
                        import ('../components/teacher/examCenter/examData/CyberCustomer'),
                    meta: {
                        title: '网络客户服务',
                        tabName: 'judgesManageExamDataCyberCustomer',
                        role: 4,
                        parentName: ['judgesManageExamDataDetail', 'judegesPwData'],
                        hidden: true,
                    },
                },
                {
                    path: "/judgesManage/examData/storeCustomer",
                    name: "judgesManageExamDataStoreCustomer",
                    component: () =>
                        import (
                            "../components/evaluation/StoreCustomer"
                        ),
                    meta: {
                        title: "网店客户服务",
                        tabName: "judgesManageExamDataStoreCustomer",
                        role: 4,
                        parentName: ["judgesManageExamDataDetail", 'judegesPwData'],
                        hidden: true,
                    },
                },
                {
                    path: '/judgesManage/examData/eCommerceAnalysisApplicationDetail',
                    name: 'judgesManageExamDataECommerceAnalysisApplicationDetail',
                    component: () =>
                        import ('../views/student/train/trainCenter/ECommerceAnalysisApplicationDetail'),
                    meta: {
                        title: '电子商务数据分析与应用',
                        tabName: 'judgesManageExamDataECommerceAnalysisApplicationDetail',
                        role: 4,
                        parentName: ['judgesManageExamDataDetail', 'judegesPwData'],
                        hidden: true,
                    },
                },
                {
                    path: '/judgesManage/examData/ProductSeriveDetail',
                    name: 'judgesManageExamDataProductSeriveDetail',
                    component: () =>
                        import ('../views/student/train/trainCenter/ProductSeriveDetail'),
                    meta: {
                        title: '产品及服务信息管理',
                        tabName: 'judgesManageExamDataProductSeriveDetail',
                        role: 4,
                        parentName: ['judgesManageExamDataDetail', 'judegesPwData'],
                        hidden: true,
                    },
                },
            ],
        },
        {
            path: '/judges/articleDetail',
            name: 'judgesArticleDetail',
            component: () =>
                import ('../views/student/train/trainCenter/articleDetail.vue'),
            meta: {
                title: '软文详情',
                role: 4,
                tabName: 'judgesArticleDetail',

                hidden: true,
            },
        },
        {
            path: '/judges/articleStandard',
            name: 'judgesArticleStandard',
            component: () =>
                import ('../views/student/train/trainCenter/articleStandard.vue'),
            meta: {
                title: '软文详情标准答案',
                role: 4,
                tabName: 'judgesArticleStandard',

                hidden: true,
            },
        },
        {
            path: '/judges/cyberCustomerDetail',
            name: 'judgesCyberCustomerDetail',
            component: () =>
                import ('../views/teacher/cyberCustomerDetail.vue'),
            meta: {
                title: '网络客户服务--查看详情',
                role: 4,
                tabName: 'judgesCyberCustomerDetail',
                hidden: true,
            },
        },
        {
            path: "/judges/goodsInfoDetail",
            name: "judgesGoodsInfoDetail",
            component: () =>
                import (
                    "../components/evaluation/GoodsInfoDetail"
                ),
            meta: {
                title: "商品信息采集与处理详情",
                tabName: "judgesGoodsInfoDetail",
                role: 4,
                hidden: true,
            },
        },
        {
            path: '/judges/goodsDetail',
            name: 'judgesGoodsDetail',
            component: () =>
                import ('../views/goodsDetail/goodsDetail.vue'),
            meta: {
                title: '商品详情',
                role: 4,
                hidden: true,
                parentName: ['judegesPwData']
            }
        },
        {
            path: '/judges/jdTheerCyberCustomerDetail',
            name: 'jdjudgesTheerCyberCustomerDetail',
            component: () =>
                import ('../views/teacher/jdTheerCyberCustomerDetail.vue'),
            meta: {
                title: '网络客户服务--查看详情',
                role: 4,
                tabName: "judgesGoodsInfoDetail",
                hidden: true,
            },
        },
        {
            path: '/judges/examCenter/examData/onlineTradeManageDetail/deliverAddressDetail',
            name: 'judgesExamCenterExamDataOnlineTradeManageDetailDeliverAddressDetail',
            component: () =>
                import ('../views/student/train/trainCenter/onlineTradeManage/DeliverAddressDetail.vue'),
            meta: {
                title: '网上交易管理-查看详情',
                role: 4,
                hidden: true,
            }
        },
        {
            path: '/judges/examCenter/examData/distributionDetail',
            name: 'judgesExamCenterExamDataDistributionDetail',
            component: () =>
                import ('../views/student/train/trainCenter/onlineTradeManage/DistributionDetail.vue'),
            meta: {
                title: '配送管理-查看详情',
                role: 4,
                hidden: true,
            }
        },
    ]
}]
export const studentRoutes = [{
        path: '/student',
        name: 'student',
        redirect: '/student/course/index',
        component: studentTrainingLayout,
        children: [{
                path: '/student/course',
                name: 'studentCourse',
                redirect: '/student/course/index',
                component: studentCourseLayout,
                meta: {
                    title: '教学中心',
                    icon: '&#xe6af;',
                    role: 5
                },
                children: [{
                        path: '/student/course/index',
                        name: 'studentCourseIndex',
                        component: () =>
                            import ('../views/student/train/course/Index.vue'),
                        meta: {
                            title: '教学中心',
                            role: 5,
                            parentName: ['studentCourse'],
                            level: 2,
                            hidden: true,
                            tabName: 'studentCourseIndex'
                        },
                    },
                    {
                        path: '/student/course/featured',
                        name: 'studentFeatured',
                        component: () =>
                            import ('../views/student/train/course/studentFeatured.vue'),
                        meta: {
                            title: '课程-首页',
                            role: 5,
                            parentName: ['studentCourse'],
                            hidden: true,
                            tabName: 'studentFeatured'
                        }
                    },
                    {
                        path: '/student/course/examDetail',
                        name: 'studentExamDetail',
                        component: () =>
                            import ('../views/student/train/course/ExamDetail.vue'),
                        meta: {
                            title: '理论试卷详情',
                            role: 5,
                            parentName: ['studentCourse'],
                            hidden: true,
                            tabName: 'studentExamDetail'
                        }
                    },
                    {
                        path: '/student/course/practiceDetail',
                        name: 'studentPracticeDetail',
                        component: () =>
                            import ('../views/student/train/course/LookDetail.vue'),
                        meta: {
                            title: '实操训练详情',
                            role: 5,
                            parentName: ['studentCourse'],
                            hidden: true,
                            tabName: 'studentPracticeDetail'
                        }
                    },
                    {
                        path: '/student/course/MatingDetail',
                        name: 'studentMatingDetail',
                        component: () =>
                            import ('../views/student/train/course/studentMatingDetail.vue'),
                        meta: {
                            title: '课程-个人资源',
                            role: 5,
                            parentName: ['studentCourse'],
                            hidden: true,
                            tabName: 'studentMatingDetail'
                        }
                    },
                ]
            },
            {
                path: '/student/trainCenter',
                name: 'studentTrainCenter',
                redirect: '/student/trainCenter/index',
                component: Main,
                meta: {
                    title: '训练中心',
                    icon: '&#xe6b5;',
                    role: 5
                },
                children: [{
                        path: '/student/trainCenter/index',
                        name: 'studentTrainCenterIndex',
                        component: () =>
                            import ('../views/student/train/trainCenter/Index.vue'),
                        meta: {
                            title: '考试训练',
                            role: 5,
                            parentName: ['studentTrainCenter']
                        },
                    },
                    {
                        path: '/student/trainCenter/startTrainExam',
                        name: 'studentTrainCenterStartTrainExam',
                        component: () =>
                            import ('../views/student/train/trainCenter/StartTrainExam.vue'),
                        meta: {
                            title: '考试训练',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterIndex'],
                            hidden: true
                        },
                    },
                    {
                        path: '/student/trainCenter/lookAnswerDetail',
                        name: 'studentTrainCenterLookAnswerDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/LookAnswerDetail.vue'),
                        meta: {
                            title: '答题详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterIndex'],
                            hidden: true
                        },
                    },
                    {
                        path: '/student/trainCenter/lookAnswerDetail/paperDetail',
                        name: 'studentTrainCenterLookAnswerDetailPaperDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/PaperDetail.vue'),
                        meta: {
                            title: '查看详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterIndex'],
                            hidden: true
                        },
                    },
                    {
                        path: '/student/trainCenter/practice',
                        name: 'studentTrainCenterPractice',
                        component: () =>
                            import ('../views/student/train/trainCenter/Practice.vue'),
                        meta: {
                            title: '实操训练',
                            role: 5,
                            parentName: ['studentTrainCenter'],
                        }
                    },
                    {
                        path: '/student/trainCenter/goodsInfo/startTraining',
                        name: 'studentTrainCenterGoodsInfoStartTraining',
                        component: () =>
                            import ('../views/student/exam/goodsInfo/Index.vue'),
                        meta: {
                            title: '开始训练-商品信息采集与处理',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true
                        }
                    },
                    {
                        path: '/student/trainCenter/goodsInfo/starExam',
                        name: 'studentTrainCenterGoodsInfoStarExam',
                        component: GoodsInfoLayout,
                        meta: {
                            title: '商品信息采集与处理',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/trainCenter/goodsInfo/hotGoods',
                                name: 'studentTrainCenterGoodsInfoHotGoods',
                                component: () =>
                                    import ('../views/student/exam/goodsInfo/HotGoods.vue'),
                                meta: {
                                    title: '热门商品',
                                    tabName: 'studentTrainCenterGoodsInfoHotGoods',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/goodsInfo/goodsText',
                                name: 'studentTrainCenterGoodsInfoGoodsText',
                                component: () =>
                                    import ('../views/student/exam/goodsInfo/GoodsText.vue'),
                                meta: {
                                    title: '商品文字信息撰写',
                                    tabName: 'studentTrainCenterGoodsInfoGoodsText',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/goodsInfo/hotKeyword',
                                name: 'studentTrainCenterGoodsInfoHotKeyword',
                                component: () =>
                                    import ('../views/student/exam/goodsInfo/HotKeyword.vue'),
                                meta: {
                                    title: '热门关键词',
                                    tabName: 'studentTrainCenterGoodsInfoHotKeyword',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                        ]
                    },
                    {
                        path: '/student/trainCenter/goodsInfo/selectClass',
                        name: 'studentTrainCenterGoodsInfoSelectClass',
                        component: () =>
                            import ('../views/student/exam/goodsInfo/SelectClass.vue'),
                        meta: {
                            title: '选择分类',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true
                        },
                    },
                    {
                        path: '/student/trainCenter/goodsInfo/addGoods',
                        name: 'studentTrainCenterGoodsInfoAddGoods',
                        component: () =>
                            import ('../views/student/exam/goodsInfo/GoodsAdd.vue'),
                        meta: {
                            title: '添加商品',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true
                        },
                    },
                    {
                        path: '/student/trainCenter/goodsInfo/goodsShoot',
                        name: 'studentTrainCenterGoodsInfoGoodsShoot',
                        component: () =>
                            import ('../views/student/exam/goodsInfo/GoodsShoot.vue'),
                        meta: {
                            title: '商品拍摄与处理',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true
                        },
                    },
                    {
                        path: '/student/trainCenter/goodsInfo/goodsVideoShoot',
                        name: 'studentTrainCenterGoodsInfoGoodsVideoShoot',
                        component: () =>
                            import ('../views/student/exam/goodsInfo/GoodsVideoShoot.vue'),
                        meta: {
                            title: '商品视频拍摄与处理',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true
                        },
                    },

                    {
                        path: '/student/trainCenter/startTraining',
                        name: 'studentTrainCenterStartTraining',
                        component: () =>
                            import ('../views/student/exam/onlineShopManagement/Index.vue'),
                        meta: {
                            title: '网店管理-开始训练',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }

                    },
                    {
                        path: '/student/trainCenter/onlineShopManagement/starExam',
                        name: 'studentTrainCenterOnlineShopManagementStarExam',
                        component: GoodsShopLayout,
                        meta: {
                            title: '网店管理',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/trainCenter/onlineShopManagement/freightTemplate',
                                name: 'studentTrainCenterOnlineShopManagementFreightTemplate',
                                component: () =>
                                    import ('../views/student/exam/onlineShopManagement/FreightTemplate.vue'),
                                meta: {
                                    title: '运单模板',
                                    tabName: 'studentTrainCenterOnlineShopManagementFreightTemplate',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            }, {
                                path: '/student/trainCenter/onlineShopManagement/goodsIndex',
                                name: 'studentTrainCenterOnlineShopManagementsGoodsIndex',
                                component: () =>
                                    import ('../views/student/exam/onlineShopManagement/GoodsIndex.vue'),
                                meta: {
                                    title: '在售商品',
                                    tabName: 'studentTrainCenterOnlineShopManagementsGoodsIndex',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/onlineShopManagement/hotKeyword',
                                name: 'studentTrainCenterOnlineShopManagementHotKeyword',
                                component: () =>
                                    import ('../views/student/exam/onlineShopManagement/HotKeyword.vue'),
                                meta: {
                                    title: '热门关键词',
                                    tabName: 'studentTrainCenterOnlineShopManagementHotKeyword',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },

                        ]
                    },

                    {
                        path: '/student/trainCenter/onlineShopManagement/studentGoodsCategory',
                        name: 'studentTrainCenterOnlineShopManagementStudentGoodsCategory',
                        component: () =>
                            import ('../views/student/exam/onlineShopManagement/StudentGoodsCategory.vue'),
                        meta: {
                            title: '选择分类',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                    },
                    {
                        path: '/student/trainCenter/onlineShopManagement/StudentAddGoods',
                        name: 'studentTrainCenterOnlineShopManagementStudentAddGoods',
                        component: () =>
                            import ('../views/student/exam/onlineShopManagement/StudentAddGoods.vue'),
                        meta: {
                            title: '添加商品',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                    },
                    {
                        path: '/student/trainCenter/onlineShopManagement/studentFreight',
                        name: 'studentTrainCenterOnlineShopManagementStudentFreight',
                        component: () =>
                            import ('../views/student/exam/onlineShopManagement/StudentFreight.vue'),
                        meta: {
                            title: '添加运单模板',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                    },
                    {
                        path: '/student/trainCenter/onlineShopManagement/starExam',
                        name: 'studentTrainCenterOnlineShopManagementStarExam',
                        component: OrderLayout,
                        meta: {
                            title: '网店管理',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/trainCenter/onlineShopManagement/allOrder',
                                name: 'studentTrainCenterOnlineShopManagementsAllOrder',
                                component: () =>
                                    import ('../views/student/exam/onlineShopManagement/AllOrder.vue'),
                                meta: {
                                    title: '所有订单',
                                    tabName: 'studentTrainCenterOnlineShopManagementsAllOrder',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],

                                },
                            },
                            {
                                path: '/student/trainCenter/onlineShopManagement/delivered',
                                name: 'studentTrainCenterOnlineShopManagementDelivered',
                                component: () =>
                                    import ('../views/student/exam/onlineShopManagement/Delivered.vue'),
                                meta: {
                                    title: '待发货',
                                    tabName: 'studentTrainCenterOnlineShopManagementDelivered',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/onlineShopManagement/deliverGoods',
                                name: 'studentTrainCenterOnlineShopManagementDeliverGoods',
                                component: () =>
                                    import ('../views/student/exam/onlineShopManagement/DeliverGoods.vue'),
                                meta: {
                                    title: '已发货',
                                    tabName: 'studentTrainCenterOnlineShopManagementDeliverGoods',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/onlineShopManagement/salesOrder',
                                name: 'studentTrainCenterOnlineShopManagementSalesOrder',
                                component: () =>
                                    import ('../views/student/exam/onlineShopManagement/SalesOrder.vue'),
                                meta: {
                                    title: '售后订单',
                                    tabName: 'studentTrainCenterOnlineShopManagementSalesOrder',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                        ]
                    },
                    // 网店装修
                    {
                        path: '/student/trainCenter/startTraining/onlineStoreFitment',
                        name: 'studentTrainCenterStartTrainingOnlineStoreFitment',
                        component: () =>
                            import ('../views/student/train/trainCenter/OnlineStoreFitment.vue'),
                        meta: {
                            title: '开始训练',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    // 数据手机与清洗
                    {
                        path: '/student/trainCenter/startTraining/ECommerceDataCollectionAndCleaning',
                        name: 'studentTrainCenterStartTrainingECommerceDataCollectionAndCleaning',
                        component: () =>
                            import ('../views/student/exam/ECommerceDataCollectionAndCleaning/Index.vue'),
                        meta: {
                            title: '开始训练',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    {
                        path: '/student/trainCenter/ECommerceDataCollect/starExam',
                        name: 'studentTrainCenterECommerceDataCollectStarExam',
                        component: ECommerceCollectCleanLayout,
                        meta: {
                            title: '电子商务数据收集',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/trainCenter/ECommerceDataCollect/customerInfoCollect',
                                name: 'studentTrainCenterECommerceDataCollectCustomerInfoCollect',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataCollectionAndCleaning/CustomerInfoCollect'),
                                meta: {
                                    title: '客户信息收集',
                                    tabName: 'studentTrainCenterECommerceDataCollectCustomerInfoCollect',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                    nobar: true
                                },
                            },
                            {
                                path: '/student/trainCenter/ECommerceDataCollect/customerInfo',
                                name: 'studentTrainCenterECommerceDataCollectCustomerInfo',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataCollectionAndCleaning/CustomerInfo'),
                                meta: {
                                    title: '客户信息',
                                    tabName: 'studentTrainCenterECommerceDataCollectCustomerInfo',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                    nobar: true
                                },
                            },
                            {
                                path: '/student/trainCenter/ECommerceDataCollect/productList',
                                name: 'studentTrainCenterECommerceDataCollectProductList',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataCollectionAndCleaning/ProductList'),
                                meta: {
                                    title: '商品榜单',
                                    tabName: 'studentTrainCenterECommerceDataCollectProductList',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                    nobar: true
                                },
                            },
                        ]
                    },
                    {
                        path: '/student/trainCenter/ECommerceDataCollect/customerInfoDetail',
                        name: 'studentTrainCenterECommerceDataCollectCustomerInfoDetail',
                        component: () =>
                            import ('../views/student/exam/ECommerceDataCollectionAndCleaning/CustomerInfoDetail'),
                        meta: {
                            title: '客户信息详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true
                        },
                    },
                    {
                        path: '/student/trainCenter/ECommerceDataCollect/productDetail',
                        name: 'studentTrainCenterECommerceDataCollectProductDetail',
                        component: () =>
                            import ('../views/student/exam/ECommerceDataCollectionAndCleaning/ProductDetail'),
                        meta: {
                            title: '榜单详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true
                        },
                    },


                    {
                        path: '/student/trainCenter/ECommerceDataCollect/fans',
                        name: 'studentTrainCenterECommerceDataCollectFans',
                        component: ECommerceFansLayout,
                        meta: {
                            title: '电子商务数据清洗',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/trainCenter/ECommerceDataCollect/fansAdd',
                                name: 'studentTrainCenterECommerceDataCollectFansAdd',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataCollectionAndCleaning/FansAdd'),
                                meta: {
                                    title: '新增粉丝',
                                    tabName: 'studentTrainCenterECommerceDataCollectFansAdd',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/ECommerceDataCollect/fansDeal',
                                name: 'studentTrainCenterECommerceDataCollectFansDeal',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataCollectionAndCleaning/FansDeal'),
                                meta: {
                                    title: '成交粉丝',
                                    tabName: 'studentTrainCenterECommerceDataCollectFansDeal',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/ECommerceDataCollect/fansAll',
                                name: 'studentTrainCenterECommerceDataCollectFansAll',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataCollectionAndCleaning/FansAll'),
                                meta: {
                                    title: '全部粉丝',
                                    tabName: 'studentTrainCenterECommerceDataCollectFansAll',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                        ]
                    },
                    {
                        path: '/student/trainCenter/startTraining/homeDetailCustomMake',
                        name: 'studentTrainCenterStartTrainingHomeDetailCustomMake',
                        component: () =>
                            import ('../views/student/exam/storeDecoration/HomeDetailCustomMake.vue'),
                        meta: {
                            title: '开始训练-网络装修',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true
                        }
                    },
                    {
                        path: '/student/trainCenter/startTraining/settledJD',
                        name: 'studentTrainCenterStartTrainingSettledJD',
                        component: () =>
                            import ('../views/student/exam/storeDecoration/SettledJD.vue'),
                        meta: {
                            title: '开始训练-网络装修',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true
                        }
                    },
                    {
                        path: '/student/trainCenter/startTraining/storeSignAndSet',
                        name: 'studentTrainCenterStartTrainingStoreSignAndSet',
                        component: () =>
                            import ('../views/student/exam/storeDecoration/StoreSignAndSet.vue'),
                        meta: {
                            title: '开始训练-网络装修',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true
                        }
                    },
                    // 网店推广
                    {
                        path: '/student/trainCenter/startTraining/networkPromotion',
                        name: 'studentTrainCenterStartTrainingNetworkPromotion',
                        component: () =>
                            import ('../views/student/train/trainCenter/NetworkPromotion.vue'),
                        meta: {
                            title: '开始训练',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                    },
                    {
                        path: '/student/trainCenter/startTraining/softPromotion',
                        name: 'studentTrainCenterStartTrainingSoftPromotion',
                        redirect: "/student/trainCenter/startTraining/softPromotionIndex",
                        component: softPromotionLayout,
                        meta: {
                            title: '软文推广主页',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingNetworkPromotion'],
                            hidden: true,
                            type: 0,
                        },
                        children: [{
                                path: '/student/trainCenter/startTraining/softPromotionIndex',
                                name: 'studentTrainCenterStartTrainingSoftPromotionIndex',
                                component: () =>
                                    import ('../views/student/train/trainCenter/networkPromotion/softArticle.vue'),
                                meta: {
                                    title: '软文推广主页',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingNetworkPromotion'],
                                    tabName: 'studentTrainCenterStartTrainingSoftPromotionIndex',
                                    type: 0,
                                },
                            },
                            {
                                path: '/student/trainCenter/startTraining/customAnalysis',
                                name: 'studentTrainCenterStartTrainingCustomAnalysis',
                                component: () =>
                                    import ('../views/student/train/trainCenter/networkPromotion/cutomAnalysis.vue'),
                                meta: {
                                    title: '用户分析',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingNetworkPromotion'],
                                    tabName: 'studentTrainCenterStartTrainingCustomAnalysis',
                                    type: 0,
                                },
                            },
                            {
                                path: '/student/trainCenter/startTraining/shortVideoAnalysis',
                                name: 'studentTrainCenterStartTrainingShortVideoAnalysis',
                                component: () =>
                                    import ('../views/student/train/trainCenter/networkPromotion/shortVideoAnalysis.vue'),
                                meta: {
                                    title: '短视频推广',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingNetworkPromotion'],
                                    tabName: 'studentTrainCenterStartTrainingShortVideoAnalysis',
                                    type: 0,
                                },
                            },
                            {
                                path: '/student/trainCenter/startTraining/dataAnalysis',
                                name: 'studentTrainCenterStartTrainingDataAnalysis',
                                component: () =>
                                    import ('../views/student/train/trainCenter/networkPromotion/dataAnalysis.vue'),
                                meta: {
                                    title: '数据分析',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingNetworkPromotion'],
                                    tabName: 'studentTrainCenterStartTrainingDataAnalysis',
                                    type: 0,
                                },
                            },
                        ]
                    },
                    {
                        path: '/student/trainCenter/startTraining/createArticle',
                        name: 'studentTrainCenterStartTrainingCreateArticle',
                        component: () =>
                            import ('../views/student/train/trainCenter/networkPromotion/createArticle.vue'),
                        meta: {
                            title: '软文创作',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingNetworkPromotion'],
                            hidden: true,
                            type: 0,
                        },
                    },
                    {
                        path: '/student/articleDetail',
                        name: 'studentArticleDetail',
                        component: () =>
                            import ('../views/teacher/articleDetail.vue'),
                        meta: {
                            title: '软文详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingNetworkPromotion'],
                            hidden: true,
                        },
                    },
                    {
                        path: '/student/trainCenter/startTraining/createLive',
                        name: 'studentTrainCenterStartTrainingCreateLive',
                        component: () =>
                            import ('../views/student/train/trainCenter/networkPromotion/createLive.vue'),
                        meta: {
                            title: '创建直播间',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingNetworkPromotion'],
                            hidden: true,
                            type: 0,
                        },
                    },
                    {
                        path: '/student/trainCenter/startTraining/createGoods',
                        name: 'studentTrainCenterStartTrainingCreateGoods',
                        component: () =>
                            import ('../views/student/train/trainCenter/networkPromotion/createGoods.vue'),
                        meta: {
                            title: '创建商品',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingNetworkPromotion'],
                            hidden: true,
                            type: 0,
                        },
                    },
                    {
                        path: '/student/trainCenter/startTraining/liveControl',
                        name: 'studentTrainCenterStartTrainingLiveControl',
                        component: () =>
                            import ('../views/student/train/trainCenter/networkPromotion/liveControl.vue'),
                        meta: {
                            title: '直播控制室',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingNetworkPromotion'],
                            hidden: true,
                            type: 0,
                        },
                    },
                    {
                        path: '/student/trainCenter/startTraining/livePromotion',
                        name: 'studentTrainCenterStartTrainingLivePromotion',
                        redirect: "/student/trainCenter/startTraining/livePromotionIndex",
                        component: livePromotionLayout,
                        meta: {
                            title: '直播推广主页',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingNetworkPromotion'],
                            hidden: true,
                            type: 0,
                        },
                        children: [{
                                path: '/student/trainCenter/startTraining/livePromotionIndex',
                                name: 'studentTrainCenterStartTrainingLivePromotionIndex',
                                component: () =>
                                    import ('../views/student/train/trainCenter/networkPromotion/livePromotionIndex.vue'),
                                meta: {
                                    title: '直播推广主页',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingNetworkPromotion'],
                                    tabName: 'studentTrainCenterStartTrainingLivePromotionIndex',
                                    type: 0,
                                },
                            },
                            {
                                path: '/student/trainCenter/startTraining/goodsLibrary',
                                name: 'studentTrainCenterStartTrainingGoodsLibrary',
                                component: () =>
                                    import ('../views/student/train/trainCenter/networkPromotion/goodsLibrary.vue'),
                                meta: {
                                    title: '商品库',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingNetworkPromotion'],
                                    tabName: 'studentTrainCenterStartTrainingGoodsLibrary',
                                    type: 0,
                                },
                            },
                        ]
                    },
                    {
                        path: '/student/trainCenter/startTraining/goodsManage',
                        name: 'studentTrainCenterStartTrainingGoodsManage',
                        redirect: "/student/trainCenter/startTraining/goodsManageIndex",
                        component: goodsManageLayout,
                        meta: {
                            title: '商品管理主页',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingNetworkPromotion'],
                            hidden: true,
                            type: 0,
                        },
                        children: [{
                                path: '/student/trainCenter/startTraining/goodsManageIndex',
                                name: 'studentTrainCenterStartTrainingGoodsManageIndex',
                                component: () =>
                                    import ('../views/student/train/trainCenter/networkPromotion/goodsManageIndex.vue'),
                                meta: {
                                    title: '商品管理主页',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingNetworkPromotion'],
                                    tabName: 'studentTrainCenterStartTrainingGoodsManageIndex',
                                    type: 0,
                                },
                            },
                            {
                                path: '/student/trainCenter/startTraining/lotteryIndex',
                                name: 'studentTrainCenterStartTrainingLotteryIndex',
                                component: () =>
                                    import ('../views/student/train/trainCenter/networkPromotion/lotteryIndex.vue'),
                                meta: {
                                    title: '抽奖池主页',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingNetworkPromotion'],
                                    tabName: 'studentTrainCenterStartTrainingLotteryIndex',
                                    type: 0,
                                },
                            },
                        ]
                    },
                    // 客服
                    {
                        path: '/student/trainCenter/startTraining/onlineShopCustomerService',
                        name: 'studentTrainCenterStartTrainingOnlineShopCustomerService',
                        component: () =>
                            import ('../views/student/exam/onlineShopCustomerService/Index.vue'),
                        meta: {
                            title: '开始训练',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    {
                        path: '/student/trainCenter/answerDetail',
                        name: 'studentTrainCenterAnswerDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/AnswerDetail.vue'),
                        meta: {
                            title: '答题详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    // 网店装修查看详情
                    {
                        path: '/student/trainCenter/onlineStoreDetail',
                        name: 'studentTrainCenterOnlineStoreDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/OnlineStoreDetail.vue'),
                        meta: {
                            title: '查看详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    // 电子商务收集清洗查看详情
                    {
                        path: '/student/trainCenter/eCommerceCollectCleanDetail',
                        name: 'studentTrainCenterECommerceCollectCleanDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/ECommerceCollectCleanDetail'),
                        meta: {
                            title: '查看详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    // 电子商务收集查看详情
                    {
                        path: '/student/trainCenter/eCommerceCollectDetail',
                        name: 'studentTrainCenterECommerceCollectDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/ECommerceCollectDetail'),
                        meta: {
                            title: '客户信息收集详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    // 电子商务清洗查看详情
                    {
                        path: '/student/trainCenter/eCommerceCleanDetail',
                        name: 'studentTrainCenterECommerceCleanDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/ECommerceCleanDetail'),
                        meta: {
                            title: '电子商务清洗数据查看详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    // 三级电子商务数据分析与应用查看详情
                    {
                        path: '/student/trainCenter/eCommerceAnalysisApplicationDetail',
                        name: 'studentTrainCenterECommerceAnalysisApplicationDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/ECommerceAnalysisApplicationDetail'),
                        meta: {
                            title: '查看详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    // 查看客户详情
                    {
                        path: '/student/trainCenter/answerDetailService',
                        name: 'studentTrainCenterAnswerDetailService',
                        component: () =>
                            import ('../components/teacher/examCenter/examData/StoreCustomer.vue'),
                        meta: {
                            title: '查看详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    // 查看机器人详情
                    {
                        path: '/student/trainCenter/answerDetailServiceDetail',
                        name: 'studentTrainCenterAnswerDetailServiceDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/AnswerDetailServiceDetail.vue'),
                        meta: {
                            title: '查看详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    //网店管理
                    {
                        path: '/student/trainCenter/lookDetail',
                        name: 'studentTrainCenterLookDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/LookDetail.vue'),
                        meta: {
                            title: '网店管理-答题详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    {
                        path: '/student/trainCenter/freightDetail',
                        name: 'studentTrainCenterFreightDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/FreightDetail.vue'),
                        meta: {
                            title: '网店管理-查看详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                            level: 2
                        }
                    },
                    //商品信息采集与处理
                    {
                        path: '/student/trainCenter/goodsInfo/lookDetail',
                        name: 'studentTrainCenterGoodsInfoLookDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/goodsInfo/LookDetail.vue'),
                        meta: {
                            title: '商品信息采集与处理--查看详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    //网络推广
                    {
                        path: '/student/trainCenter/networkDetail',
                        name: 'studentTrainCenterNetworkDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/networkPromotion/networkDetail'),
                        meta: {
                            title: '网络推广--查看详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    //网络营销
                    {
                        path: '/student/trainCenter/startTraining/cyberMarketing',
                        name: 'studentTrainCenterStartTrainingCyberMarketing',
                        component: () =>
                            import ('../views/student/train/trainCenter/CyberMarketing.vue'),
                        meta: {
                            title: '网络营销',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                    },
                    //网络客户服务
                    {
                        path: '/student/trainCenter/startTraining/cyberCustomerService',
                        name: 'studentTrainCenterStartTrainingCyberCustomerService',
                        component: () =>
                            import ('../views/student/train/trainCenter/CyberCustomerService.vue'),
                        meta: {
                            title: '网络客户服务',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                    },
                    //网店视觉设计
                    {
                        path: '/student/trainCenter/onlineShopVisualDesign/lookDetail',
                        name: 'studentTrainCenterOnlineShopVisualDesignDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/onlineShopVisualDesign/LookDetail.vue'),
                        meta: {
                            title: '网店视觉设计--查看详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    //网上交易管理
                    {
                        path: '/student/trainCenter/onlineTradeManage/lookDetail',
                        name: 'studentTrainCenterOnlineTradeManageDesignDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/onlineTradeManage/LookDetail.vue'),
                        meta: {
                            title: '网上交易管理--答题详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    {
                        path: '/student/trainCenter/onlineTradeManage/deliverAddressDetail',
                        name: 'studentTrainCenterOnlineTradeManageDeliverAddressDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/onlineTradeManage/DeliverAddressDetail.vue'),
                        meta: {
                            title: '网上交易管理-查看详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                            level: 2
                        }
                    },
                    {
                        path: '/student/trainCenter/onlineTradeManage/distributionDetail',
                        name: 'studentTrainCenterOnlineTradeManageDistributionDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/onlineTradeManage/DistributionDetail.vue'),
                        meta: {
                            title: '配送管理-查看详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                            level: 2
                        }
                    },
                    {
                        path: '/student/trainCenter/cyberCustomerService',
                        name: 'studentTrainCenterCyberCustomerService',
                        redirect: '/student/trainCenter/startTraining/cyberCustomerService/index',
                        component: CyberCustomerServiceLayout,
                        meta: {
                            title: '网络客服',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingCyberCustomerService'],
                            hidden: true,
                            type: 0,
                        },
                        children: [{
                                path: '/student/trainCenter/startTraining/cyberCustomerService/index',
                                name: 'studentTrainCenterStartTrainingCyberCustomerServiceIndex',
                                component: () =>
                                    import ('../views/student/train/trainCenter/cyberCustomerService/Index.vue'),
                                meta: {
                                    title: '客户策略与分析',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingCyberCustomerService'],
                                    hidden: true,
                                    type: 0,
                                    tabName: 'studentTrainCenterStartTrainingCyberCustomerServiceIndex'
                                },
                            },
                            {
                                path: '/student/trainCenter/startTraining/cyberCustomerService/realTimeMonitor',
                                name: 'studentTrainCenterStartTrainingCyberCustomerRealTimeMonitor',
                                component: () =>
                                    import ('../views/student/train/trainCenter/cyberCustomerService/realTimeMonitor.vue'),
                                meta: {
                                    title: '客户实时监控',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingCyberCustomerService'],
                                    hidden: true,
                                    type: 0,
                                    tabName: 'studentTrainCenterStartTrainingCyberCustomerRealTimeMonitor'
                                },
                            },
                            {
                                path: '/student/trainCenter/startTraining/cyberCustomerService/qualificationQuery',
                                name: 'studentTrainCenterStartTrainingCyberCustomerQualificationQuery',
                                component: () =>
                                    import ('../views/student/train/trainCenter/cyberCustomerService/qualificationQuery.vue'),
                                meta: {
                                    title: '客户咨询查询',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingCyberCustomerService'],
                                    hidden: true,
                                    type: 0,
                                    tabName: 'studentTrainCenterStartTrainingCyberCustomerQualificationQuery'
                                },
                            },
                            {
                                path: '/student/trainCenter/startTraining/cyberCustomerService/afterSale',
                                name: 'studentTrainCenterStartTrainingCyberCustomerAfterSale',
                                component: () =>
                                    import ('../views/student/train/trainCenter/cyberCustomerService/AfterSale.vue'),
                                meta: {
                                    title: '自主售后',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingCyberCustomerService'],
                                    hidden: true,
                                    type: 0,
                                    tabName: 'studentTrainCenterStartTrainingCyberCustomerAfterSale'
                                },
                            },
                            {
                                path: '/student/trainCenter/startTraining/cyberCustomerService/productManagement',
                                name: 'studentTrainCenterStartTrainingCyberCustomerProductManagement',
                                component: () =>
                                    import ('../views/student/train/trainCenter/cyberCustomerService/productManagement.vue'),
                                meta: {
                                    title: '在售商品管理',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingCyberCustomerService'],
                                    hidden: true,
                                    type: 0,
                                    tabName: 'studentTrainCenterStartTrainingCyberCustomerProductManagement'
                                },
                            },
                            {
                                path: '/student/trainCenter/startTraining/cyberCustomerService/hotProduct',
                                name: 'studentTrainCenterStartTrainingCyberCustomerHotProduct',
                                component: () =>
                                    import ('../views/student/train/trainCenter/cyberCustomerService/hotProduct.vue'),
                                meta: {
                                    title: '热门商品',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingCyberCustomerService'],
                                    hidden: true,
                                    type: 0,
                                    tabName: 'studentTrainCenterStartTrainingCyberCustomerHotProduct'
                                },
                            },
                        ]
                    },
                    {
                        path: '/student/trainCenter/startTraining/cyberCustomerService/createManagement',
                        name: 'studentTrainCenterStartTrainingCyberCustomerServiceCreateManagement',
                        component: () =>
                            import ('../views/student/train/trainCenter/cyberCustomerService/createManagement.vue'),
                        meta: {
                            title: '客户策略与分析--创建',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingCyberCustomerService'],
                            hidden: true,
                            type: 0,
                            tabName: 'studentTrainCenterStartTrainingCyberCustomerServiceCreateManagement'
                        },
                    },
                    {
                        path: '/student/trainCenter/startTraining/cyberCustomerService/ManagementDetail',
                        name: 'studentTrainCenterStartTrainingCyberCustomerServiceManagementDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/cyberCustomerService/ManagementDetail.vue'),
                        meta: {
                            title: '客户策略与分析--详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingCyberCustomerService'],
                            hidden: true,
                            type: 0,
                            tabName: 'studentTrainCenterStartTrainingCyberCustomerServiceManagementDetail'
                        },
                    },
                    //网络客户服务
                    {
                        path: '/student/trainCenter/cyberCustomerDetail',
                        name: 'studentTrainCenterCyberCustomerDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/cyberCustomerService/cyberCustomerDetail'),
                        meta: {
                            title: '网络客户服务--查看详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },

                    //网络营销
                    {
                        path: '/student/trainCenter/cyberMarketDetail',
                        name: 'studentTrainCenterCyberMarketDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/cyberMarketing/cyberMarketDetail'),
                        meta: {
                            title: '网络营销--查看详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },

                    // 三级网络营销
                    {
                        path: '/student/trainCenter/startTraining/internetMarketing',
                        name: 'studentTrainCenterStartTrainingInternetMarketing',
                        component: () =>
                            import ('../views/student/exam/internetMarketing/Index'),
                        meta: {
                            title: '开始训练',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    //三级社交电商
                    {
                        path: '/student/trainCenter/internetMarketing/socialECommerce',
                        name: 'studentTrainCenterInternetMarketingSocialECommerce',
                        component: SocialECommerceLayout,
                        meta: {
                            title: '社交电商',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/trainCenter/internetMarketing/socialECommerce/softText',
                                name: 'studentTrainCenterInternetMarketingSocialECommerceSoftText',
                                component: () =>
                                    import ('../views/student/exam/internetMarketing/socialECommerce/SoftText'),
                                meta: {
                                    title: '社交电商',
                                    tabName: 'studentTrainCenterInternetMarketingSocialECommerceSoftText',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/internetMarketing/socialECommerce/goodsManage',
                                name: 'studentTrainCenterInternetMarketingSocialECommerceGoodsManage',
                                component: () =>
                                    import ('../views/student/exam/internetMarketing/socialECommerce/GoodsManage'),
                                meta: {
                                    title: '在售商品管理',
                                    tabName: 'studentTrainCenterInternetMarketingSocialECommerceGoodsManage',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                        ]
                    },
                    {
                        path: '/student/trainCenter/internetMarketing/socialECommerce/softText/create',
                        name: 'studentTrainCenterInternetMarketingSocialECommerceSoftTextCreate',
                        component: () =>
                            import ('../views/student/exam/internetMarketing/socialECommerce/softText/Create'),
                        meta: {
                            title: '新的创作',
                            tabName: 'studentTrainCenterInternetMarketingSocialECommerceSoftTextCreate',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                    },
                    {
                        path: '/student/trainCenter/internetMarketing/socialECommerce/softText/detail',
                        name: 'studentTrainCenterInternetMarketingSocialECommerceSoftTextDetail',
                        component: () =>
                            import ('../views/student/exam/internetMarketing/socialECommerce/softText/Detail'),
                        meta: {
                            title: '查看',
                            tabName: 'studentTrainCenterInternetMarketingSocialECommerceSoftTextDetail',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                    },
                    //三级网上交易管理
                    {
                        path: '/student/trainCenter/startTraining/onlineTrading',
                        name: 'studentTrainCenterStartTraining/0nlineTrading',
                        component: () =>
                            import ('../views/student/exam/onlineTradeManage/Index'),
                        meta: {
                            title: '网上交易管理-开始训练',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }

                    },
                    {
                        path: '/student/trainCenter/startTraining/starExam',
                        name: 'studentTrainCenterStartTrainingStarExam',
                        component: OnlineTradingLayout,
                        meta: {
                            title: '网上交易管理',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/trainCenter/startTraining/deliveryaddress',
                                name: 'studentTrainCenterStartTrainingDeliveryAddress',
                                component: () =>
                                    import ('../views/student/exam/onlineTradeManage/DeliveryAddress'),
                                meta: {
                                    title: '发货地址',
                                    tabName: 'studentTrainCenterStartTrainingDeliveryAddress',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/startTraining/studentsellinggoods',
                                name: 'studentTrainCenterStartTrainingStudentSellingGoods',
                                component: () =>
                                    import ('../views/student/exam/onlineTradeManage/StudentSellingGoods'),
                                meta: {
                                    title: '在售商品管理',
                                    tabName: 'studentExamOnlineTradeManageStudentSellingGoods',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/startTraining/studentcustomertran',
                                name: 'studentTrainCenterStartTrainingStudentCustomerTran',
                                component: () =>
                                    import ('../views/student/exam/onlineTradeManage/StudentCustomerTran'),
                                meta: {
                                    title: '成交客户分析',
                                    tabName: 'studentTrainCenterStartTrainingStudentCustomerTran',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            //配送管理
                            {
                                path: '/student/trainCenter/startTraining/studentspareparts',
                                name: 'studentTrainCenterStartTrainingStudentSpareParts',
                                component: () =>
                                    import ('../views/student/exam/onlineTradeManage/StudentSpareParts'),
                                meta: {
                                    title: '备件库退货地址管理',
                                    tabName: 'studentTrainCenterStartTrainingStudentSpareParts',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/startTraining/list',
                                name: 'studentTrainCenterStartTrainingList',
                                component: () =>
                                    import ('../views/student/exam/onlineTradeManage/List'),
                                meta: {
                                    title: '备件库退货地址管理列表',
                                    tabName: 'studentTrainCenterStartTrainingStudentSpareParts',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/startTraining/studentaftersales',
                                name: 'studentTrainCenterStartTrainingStudentAfterSales',
                                component: () =>
                                    import ('../views/student/exam/onlineTradeManage/StudentAfterSales'),
                                meta: {
                                    title: '自主售后退货地址管理',
                                    tabName: 'studentTrainCenterStartTrainingStudentAfterSales',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/startTraining/studenttemplatemodel',
                                name: 'studentTrainCenterStartTrainingStudentTemplateModel',
                                component: () =>
                                    import ('../views/student/exam/onlineTradeManage/StudentTemplateModel'),
                                meta: {
                                    title: '运费模板',
                                    tabName: 'studentTrainCenterStartTrainingStudentTemplateModel',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                    nobar: true
                                },
                            },
                            {
                                path: '/student/trainCenter/startTraining/studentFreight',
                                name: 'studentTrainCenterStartTrainingStudentFreight',
                                component: () =>
                                    import ('../views/student/exam/onlineTradeManage/StudentFreight'),
                                meta: {
                                    title: '添加运单模板',
                                    tabName: 'studentExamOnlineTradeManageStudentTemplateModel',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            }
                        ]
                    },
                    {
                        path: '/student/trainCenter/startTraining/studentdeliveryaddress',
                        name: 'studentTrainCenterStartTrainingStudentDeliveryAddress',
                        component: () =>
                            import ('../views/student/exam/onlineTradeManage/StudentDeliveryAddress'),
                        meta: {
                            title: '新增发货地址',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                    },
                    {
                        path: '/student/trainCenter/startTraining/studentaddaftersales',
                        name: 'studentTrainCenterStartTrainingStudentAddAfterSales',
                        component: () =>
                            import ('../views/student/exam/onlineTradeManage/studentAddAfterSales'),
                        meta: {
                            title: '添加售后商品',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                    },
                    //三级 网店视觉设计
                    {
                        path: '/student/trainCenter/onlineShopVisualDesign/index',
                        name: 'studentTrainCenterOnlineShopVisualDesignIndex',
                        component: () =>
                            import ('../views/student/exam/onlineShopVisualDesign/Index'),
                        meta: {
                            title: '开始训练',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true
                        },
                    },
                    {
                        path: '/student/trainCenter/onlineShopVisualDesign/overall',
                        name: 'studentTrainCenterOnlineShopVisualDesignOverall',
                        component: () =>
                            import ('../views/student/exam/onlineShopVisualDesign/Overall.vue'),
                        meta: {
                            title: '网店视觉设计',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true
                        },
                    },
                    // 三级网店商品定价管理
                    {
                        path: '/student/trainCenter/onlineShopProductPricing/starExam',
                        name: 'studentTrainCenterOnlineShopProductPricingStarExam',
                        component: OnlineShopProductPricingLayout,
                        meta: {
                            title: '网店商品定价管理',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/trainCenter/onlineShopProductPricing/index',
                                name: 'studentTrainCenterOnlineShopProductPricingIndex',
                                component: () =>
                                    import ('../views/student/exam/internetMarketing/onlineShopProductPricing/Index'),
                                meta: {
                                    title: '网店商品定价管理',
                                    tabName: 'studentTrainCenterOnlineShopProductPricingIndex',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/onlineShopProductPricing/hotProduct',
                                name: 'studentTrainCenterOnlineShopProductPricingHotProduct',
                                component: () =>
                                    import ('../views/student/exam/internetMarketing/onlineShopProductPricing/HotProduct'),
                                meta: {
                                    title: '热门商品',
                                    tabName: 'studentTrainCenterOnlineShopProductPricingHotProduct',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                        ]
                    },

                    // 三级电子商务
                    {
                        path: '/student/trainCenter/startTraining/ECommerceDataAnalysisAndApplication',
                        name: 'studentTrainCenterStartTrainingECommerceDataAnalysisAndApplication',
                        component: () =>
                            import ('../views/student/exam/ECommerceDataAnalysisAndApplication/Index'),
                        meta: {
                            title: '开始训练',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    // 电子商务的考试界面
                    {
                        path: '/student/trainCenter/ECommerceDataAnalysisAndApplication/starExam',
                        name: 'studentTrainCenterECommerceDataAnalysisAndApplicationStarExam',
                        component: ECommerceAnalysisApplyLayout,
                        meta: {
                            title: '电子商务数据分析与应用',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/trainCenter/ECommerceDataAnalysisAndApplication/collectionAdnProcess',
                                name: 'studentTrainCenterECommerceDataAnalysisAndApplicationCollectionAdnProcess',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataAnalysisAndApplication/CollectionAdnProcess'),
                                meta: {
                                    title: '电子商务数据采集与处理',
                                    tabName: 'studentTrainCenterECommerceDataAnalysisAndApplicationCollectionAdnProcess',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/ECommerceDataAnalysisAndApplication/basicDataAnalysis',
                                name: 'studentTrainCenterECommerceDataAnalysisAndApplicationBasicDataAnalysis',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataAnalysisAndApplication/BasicDataAnalysis'),
                                meta: {
                                    title: '电子商务基础数据分析',
                                    tabName: 'studentTrainCenterECommerceDataAnalysisAndApplicationBasicDataAnalysis',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/ECommerceDataAnalysisAndApplication/reportProduct',
                                name: 'studentTrainCenterECommerceDataAnalysisAndApplicationReportProduct',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataAnalysisAndApplication/ReportProduct'),
                                meta: {
                                    title: '电子商务数据报告制作',
                                    tabName: 'studentTrainCenterECommerceDataAnalysisAndApplicationReportProduct',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                        ]
                    },
                    // 电子商务的数据中心
                    {
                        path: '/student/trainCenter/ECommerceDataAnalysisAndApplication/dataCenter',
                        name: 'studentTrainCenterECommerceDataAnalysisAndApplicationDataCenter',
                        component: EcommerceDataCenterLayout,
                        meta: {
                            title: '数据中心',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/trainCenter/ECommerceDataAnalysisAndApplication/customerInfo',
                                name: 'studentTrainCenterECommerceDataAnalysisAndApplicationCustomerInfo',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataAnalysisAndApplication/CustomerInfo'),
                                meta: {
                                    title: '客户信息',
                                    tabName: 'studentTrainCenterECommerceDataAnalysisAndApplicationCustomerInfo',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/ECommerceDataAnalysisAndApplication/industryMarket',
                                name: 'studentTrainCenterECommerceDataAnalysisAndApplicationIndustryMarket',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataAnalysisAndApplication/IndustryMarket'),
                                meta: {
                                    title: '行业大盘',
                                    tabName: 'studentTrainCenterECommerceDataAnalysisAndApplicationIndustryMarket',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/ECommerceDataAnalysisAndApplication/commodityList',
                                name: 'studentTrainCenterECommerceDataAnalysisAndApplicationCommodityList',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataAnalysisAndApplication/CommodityList'),
                                meta: {
                                    title: '商品榜单',
                                    tabName: 'studentTrainCenterECommerceDataAnalysisAndApplicationCommodityList',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/ECommerceDataAnalysisAndApplication/customerAnalysis',
                                name: 'studentTrainCenterECommerceDataAnalysisAndApplicationCustomerAnalysis',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataAnalysisAndApplication/CustomerAnalysis'),
                                meta: {
                                    title: '客户分析',
                                    tabName: 'studentTrainCenterECommerceDataAnalysisAndApplicationCustomerAnalysis',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/ECommerceDataAnalysisAndApplication/sellersAnalysis',
                                name: 'studentTrainCenterECommerceDataAnalysisAndApplicationSellersAnalysis',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataAnalysisAndApplication/SellersAnalysis'),
                                meta: {
                                    title: '卖家分析',
                                    tabName: 'studentTrainCenterECommerceDataAnalysisAndApplicationSellersAnalysis',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                        ]
                    },

                    {
                        path: '/student/trainCenter/ECommerceDataAnalysisAndApplication/productDetail',
                        name: 'studentTrainCenterECommerceDataAnalysisAndApplicationProductDetail',
                        component: () =>
                            import ('../views/student/exam/ECommerceDataAnalysisAndApplication/ProductDetail'),
                        meta: {
                            title: '榜单详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true
                        },
                    },
                ]
            }
        ]
    },
    {
        path: '/student/exam',
        name: 'studentExam',
        component: () =>
            import ('../views/student/exam/Exam.vue'),
        meta: {
            title: '考试界面',
            role: 5,
        }
    },
    // 三级跨境
    {
        path: '/student/examing',
        name: 'studentExaming',
        redirect: '/student/examing/theoryTest/index',
        component: studentExamLayout,
        children: [{
                path: '/student/examing/theoryTest',
                name: 'studentExamingTheoryTest',
                redirect: '/student/examing/theoryTest/index',
                component: Main,
                meta: {
                    title: '理论考试',
                    role: 5
                },
                children: [{
                    path: '/student/examing/theoryTest/index',
                    name: 'studentExamingTheoryTestIndex',
                    component: () =>
                        import ('../views/student/exam/theoryTest/Index.vue'),
                    meta: {
                        title: '理论考试',
                        role: 5,
                        parentName: ['studentExamingTheoryTest'],
                    },
                }]
            },
            {
                path: '/student/wait',
                name: 'studentWait',
                component: () =>
                    import ("../components/student/waiterExam"),
                meta: {
                    title: '等待考试开始',
                    role: 5,
                }
            },
            // 产品服务文字采编
            {
                path: '/student/examing/goodsInfo',
                name: 'studentExamingGoodsInfo',
                redirect: '/student/examing/goodsInfo/index',
                component: Main,
                meta: {
                    title: '产品及服务信息管理',
                    role: 5
                },
                children: [{
                        path: '/student/examing/goodsInfo/index',
                        name: 'studentExamingGoodsInfoIndex',
                        component: () =>
                            import ('../views/student/exam/goodsInfo/Index.vue'),
                        meta: {
                            title: '产品及服务信息管理',
                            role: 5,
                            parentName: ['studentExamingGoodsInfo'],
                        },
                    },
                    {
                        path: '/student/examing/goodsInfo/starExam',
                        name: 'studentExamingGoodsInfoStarExam',
                        component: GoodsInfoLayout,
                        meta: {
                            title: '商品信息采集与处理',
                            role: 5,
                            parentName: ['studentExamingGoodsInfo'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/examing/goodsInfo/hotGoods',
                                name: 'studentExamingGoodsInfoHotGoods',
                                component: () =>
                                    import ('../views/student/exam/goodsInfo/HotGoods.vue'),
                                meta: {
                                    title: '热门商品',
                                    tabName: 'studentExamingGoodsInfoHotGoods',
                                    role: 5,
                                    parentName: ['studentExamingGoodsInfo'],
                                    nobar: true,
                                },
                            },
                            {
                                path: '/student/examing/goodsInfo/goodsText',
                                name: 'studentExamingGoodsInfoGoodsText',
                                component: () =>
                                    import ('../views/student/exam/goodsInfo/GoodsText.vue'),
                                meta: {
                                    title: '文字资料采编',
                                    tabName: 'studentExamingGoodsInfoGoodsText',
                                    role: 5,
                                    parentName: ['studentExamingGoodsInfo'],
                                    nobar: true,
                                },
                            },
                            // {
                            //     path: '/student/examing/goodsInfo/hotKeyword',
                            //     name: 'studentExamingGoodsInfoHotKeyword',
                            //     component: () =>
                            //         import ('../views/student/exam/goodsInfo/HotKeyword.vue'),
                            //     meta: {
                            //         title: '热门关键词',
                            //         tabName: 'studentExamingGoodsInfoHotKeyword',
                            //         role: 5,
                            //         parentName: ['studentExamingGoodsInfo'],
                            //     },
                            // },
                        ]
                    },
                    {
                        path: '/student/examing/goodsInfo/selectClass',
                        name: 'studentExamingGoodsInfoSelectClass',
                        component: () =>
                            import ('../views/student/exam/goodsInfo/SelectClass.vue'),
                        meta: {
                            title: '选择分类',
                            role: 5,
                            parentName: ['studentExamingGoodsInfo'],
                        },
                    },
                    {
                        path: '/student/examing/goodsInfo/addGoods',
                        name: 'studentExamingGoodsInfoAddGoods',
                        component: () =>
                            import ('../views/student/exam/goodsInfo/GoodsAdd.vue'),
                        meta: {
                            title: '添加商品',
                            role: 5,
                            parentName: ['studentExamingGoodsInfo'],
                        },
                    },
                    {
                        path: '/student/examing/goodsInfo/goodsShoot',
                        name: 'studentExamingGoodsInfoGoodsShoot',
                        component: () =>
                            import ('../views/student/exam/goodsInfo/GoodsShoot.vue'),
                        meta: {
                            title: '商品拍摄与处理',
                            role: 5,
                            parentName: ['studentExamingGoodsInfo'],
                        },
                    },
                    {
                        path: '/student/examing/goodsInfo/goodsVideoShoot',
                        name: 'studentExamingGoodsInfoGoodsVideoShoot',
                        component: () =>
                            import ('../views/student/exam/goodsInfo/GoodsVideoShoot.vue'),
                        meta: {
                            title: '商品视频拍摄与处理',
                            role: 5,
                            parentName: ['studentExamingGoodsInfo'],
                        },
                    },
                ]
            },
            // 产品及服务信息管理
            {
                path: '/student/exam/productSerive',
                name: 'studentExamProductSerive',
                redirect: '/student/exam/productSerive/index',
                component: Main,
                meta: {
                    title: '产品及服务信息管理',
                    role: 5
                },
                children: [
                    {
                        path: '/student/exam/productSerive/index',
                        name: 'studentExamProductSeriveIndex',
                        component: () =>
                            import ('../views/student/exam/productSerive/Index'),
                        meta: {
                            title: '开始考试',
                            role: 5,
                            parentName: ['studentExamProductSerive'],
                        },
                    },
                    {
                        path: '/student/exam/productSerive/list',
                        name: 'studentExamProductSeriveList',
                        component: () =>
                            import ('../views/student/exam/productSerive/List'),
                        meta: {
                            title: '产品及服务信息管理',
                            role: 5,
                            parentName: ['studentExamProductSerive'],
                            nobar: true,
                        },
                    },
                    {
                        path: '/student/exam/productSerive/operate',
                        name: 'studentExamProductSeriveOperate',
                        component: () =>
                            import ('../views/student/exam/productSerive/Operate'),
                        meta: {
                            title: '产品及服务信息管理',
                            role: 5,
                            parentName: ['studentExamProductSerive'],
                            nobar: true,
                        },
                    },
                    {
                        path: '/student/exam/productSerive/hotGoods',
                        name: 'studentExamProductSeriveHotGoods',
                        component: () =>
                            import ('../views/student/exam/productSerive/HotGoods'),
                        meta: {
                            title: '产品及服务信息管理',
                            role: 5,
                            parentName: ['studentExamProductSerive'],
                            nobar: true,
                        },
                    },
                ]
            },
            // 网店视觉设计
            {
                path: '/student/exam/onlineShopVisualDesign',
                name: 'studentExamOnlineShopVisualDesign',
                redirect: '/student/exam/onlineShopVisualDesign/index',
                component: Main,
                meta: {
                    title: '线上店铺设计与装修',
                    role: 5
                },
                children: [{
                        path: '/student/exam/onlineShopVisualDesign/index',
                        name: 'studentExamOnlineShopVisualDesignIndex',
                        component: () =>
                            import ('../views/student/exam/onlineShopVisualDesign/Index'),
                        meta: {
                            title: '开始考试',
                            role: 5,
                            parentName: ['studentExamOnlineShopVisualDesign'],
                        },
                    },
                    // {
                    //     path: '/student/examing/onlineShopVisualDesign/overall',
                    //     name: 'studentExamOnlineShopVisualDesignOverall',
                    //     component: () =>
                    //         import ('../views/student/exam/onlineShopVisualDesign/Overall.vue'),
                    //     meta: {
                    //         title: '网店视觉设计',
                    //         role: 5,
                    //         parentName: ['studentExamOnlineShopVisualDesign'],
                    //     },
                    // },
                    {
                        path: '/student/examing/onlineShopVisualDesign/pageSet',
                        name: 'studentExamingOnlineShopVisualDesignPageSet',
                        // component: ShopOpenPage,
                        component: () => import ('../views/student/exam/storeDecoration/UserPageDesign'),
                        meta: {
                            title: '用户页面设计',
                            role: 5,
                            parentName: ['studentExamOnlineShopVisualDesign'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/examing/onlineShopVisualDesign/pageDZ',
                                name: 'studentExamingOnlineShopVisualDesignPageDZ',
                                component: () =>
                                    import ('../views/student/exam/storeDecoration/PageSetDZ'),
                                meta: {
                                    // title: '店招',
                                    title: '用户页面设计',
                                    tabName: 'studentExamingOnlineShopVisualDesignPageDZ',
                                    role: 5,
                                    parentName: ['studentExamOnlineShopVisualDesign'],
                                    nobar: true
                                },
                            },
                            {
                                path: '/student/examing/onlineShopVisualDesign/pageSetBanner',
                                name: 'studentExamingOnlineShopVisualDesignPageSetBanner',
                                component: () =>
                                    import ('../views/student/exam/storeDecoration/PageSetBanner'),
                                meta: {
                                    title: '电脑海报',
                                    tabName: 'studentExamingOnlineShopVisualDesignPageSetBanner',
                                    role: 5,
                                    parentName: ['studentExamOnlineShopVisualDesign'],
                                    nobar: true
                                },
                            },
                            {
                                path: '/student/examing/onlineShopVisualDesign/pageSetClass',
                                name: 'studentExamingOnlineShopVisualDesignPageSetClass',
                                component: () =>
                                    import ('../views/student/exam/storeDecoration/PageSetClass'),
                                meta: {
                                    title: '店铺分类',
                                    tabName: 'studentExamingOnlineShopVisualDesignPageSetClass',
                                    role: 5,
                                    parentName: ['studentExamOnlineShopVisualDesign'],
                                    nobar: true
                                },
                            },
                            {
                                path: '/student/examing/onlineShopVisualDesign/pageSetGood',
                                name: 'studentExamingOnlineShopVisualDesignPageSetGood',
                                component: () =>
                                    import ('../views/student/exam/storeDecoration/PageSetGood'),
                                meta: {
                                    title: '商品列表',
                                    tabName: 'studentExamingOnlineShopVisualDesignPageSetGood',
                                    role: 5,
                                    parentName: ['studentExamOnlineShopVisualDesign'],
                                    nobar: true
                                },
                            },
                        ]
                    },
                    {
                        path: '/student/examing/onlineShopVisualDesign/pageSetUpGood',
                        name: 'studentExamingOnlineShopVisualDesignPageSetUpGood',
                        component: () =>
                            import ('../views/student/exam/storeDecoration/PageSetUpGood'),
                        meta: {
                            title: '上传商品',
                            tabName: 'studentExamingOnlineShopVisualDesignPageSetUpGood',
                            role: 5,
                            parentName: ['studentExamOnlineShopVisualDesign'],
                            nobar: true
                        },
                    },
                ]
            },
            // 线上店铺设计与装修
            {
                path: '/student/examing/onlineShopDecoration',
                name: 'studentExamingOnlineShopDecoration',
                redirect: '/student/examing/onlineShopDecoration/index',
                component: Main,
                meta: {
                    title: '线上店铺设计与装修',
                    role: 5
                },
                children: [{
                        path: '/student/examing/onlineShopDecoration/index',
                        name: 'studentExamingOnlineShopDecorationIndex',
                        component: () =>
                            import ('../views/student/train/trainCenter/OnlineStoreFitment.vue'),
                        meta: {
                            title: '线上店铺设计与装修',
                            role: 5,
                            parentName: ['studentExamingOnlineShopDecoration'],
                        },
                    },
                    {
                        path: '/student/examing/onlineShopDecoration/homeDetailCustomMake',
                        name: 'studentExamingOnlineShopDecorationHomeDetailCustomMake',
                        component: () =>
                            import ('../views/student/exam/storeDecoration/HomeDetailCustomMake.vue'),
                        meta: {
                            title: '网店装修-开始考试',
                            role: 5,
                            parentName: ['studentExamingOnlineShopDecoration'],
                        },
                    },
                    {
                        path: '/student/examing/onlineShopDecoration/settledJD',
                        name: 'studentExamingOnlineShopDecorationSettledJD',
                        component: () =>
                            import ('../views/student/exam/storeDecoration/SettledJD.vue'),
                        meta: {
                            title: '网店装修-开始考试',
                            role: 5,
                            parentName: ['studentExamingOnlineShopDecoration'],
                            nobar: true,
                        },
                    },
                    {
                        path: '/student/examing/onlineShopDecoration/storeSignAndSet',
                        name: 'studentExamingOnlineShopDecorationStoreSignAndSet',
                        component: () =>
                            import ('../views/student/exam/storeDecoration/StoreSignAndSet.vue'),
                        meta: {
                            title: '网店装修-开始考试',
                            role: 5,
                            parentName: ['studentExamingOnlineShopDecoration'],
                            nobar: true
                        },
                    },
                    {
                        path: '/student/examing/onlineShopDecoration/pageSet',
                        name: 'studentExamingOnlineShopDecorationPageSet',
                        component: ShopOpenPage,
                        meta: {
                            title: '页面制作',
                            role: 5,
                            parentName: ['studentExamingOnlineShopDecoration'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/examing/onlineShopDecoration/pageDZ',
                                name: 'studentExamingOnlineShopDecorationPageDZ',
                                component: () =>
                                    import ('../views/student/exam/storeDecoration/PageSetDZ'),
                                meta: {
                                    title: '店招',
                                    tabName: 'studentExamingOnlineShopDecorationPageDZ',
                                    role: 5,
                                    parentName: ['studentExamingOnlineShopDecoration'],
                                    nobar: true,
                                },
                            },
                            {
                                path: '/student/examing/onlineShopDecoration/pageSetBanner',
                                name: 'studentExamingOnlineShopDecorationPageSetBanner',
                                component: () =>
                                    import ('../views/student/exam/storeDecoration/PageSetBanner.vue'),
                                meta: {
                                    title: '电脑海报',
                                    tabName: 'studentExamingOnlineShopDecorationPageSetBanner',
                                    role: 5,
                                    parentName: ['studentExamingOnlineShopDecoration'],
                                    nobar: true,
                                },
                            },
                        ]
                    },
                ]
            },
            // 营销推广
            {
                path: '/student/examing/webPromotion',
                name: 'studentExamingWebPromotion',
                redirect: '/student/examing/webPromotion/index',
                component: Main,
                meta: {
                    title: '营销推广',
                    role: 5
                },
                children: [{
                    path: '/student/examing/webPromotion/index',
                    name: 'studentExamingOnlineWebPromotionIndex',
                    component: () =>
                        import ('../views/student/exam/webPromotion/Index.vue'),
                    meta: {
                        title: '营销推广',
                        role: 5,
                        parentName: ['studentExamingWebPromotion'],
                    },
                }]
            },
            // 产品及服务信息管理
            // {
            //     path: '/student/exam/productSerive',
            //     name: 'studentExamProductSerive',
            //     redirect: '/student/exam/productSerive/index',
            //     component: Main,
            //     meta: {
            //         title: '产品及服务信息管理',
            //         role: 5
            //     },
            //     children: [
            //         {
            //             path: '/student/exam/productSerive/index',
            //             name: 'studentExamProductSeriveIndex',
            //             component: () =>
            //                 import ('../views/student/exam/productSerive/Index'),
            //             meta: {
            //                 title: '开始考试',
            //                 role: 5,
            //                 parentName: ['studentExamProductSerive'],
            //             },
            //         },
            //         {
            //             path: '/student/exam/productSerive/list',
            //             name: 'studentExamProductSeriveList',
            //             component: () =>
            //                 import ('../views/student/exam/productSerive/List'),
            //             meta: {
            //                 title: '产品及服务信息管理',
            //                 role: 5,
            //                 parentName: ['studentExamProductSerive'],
            //                 nobar: true,
            //             },
            //         },
            //         {
            //             path: '/student/exam/productSerive/operate',
            //             name: 'studentExamProductSeriveOperate',
            //             component: () =>
            //                 import ('../views/student/exam/productSerive/Operate'),
            //             meta: {
            //                 title: '产品及服务信息管理',
            //                 role: 5,
            //                 parentName: ['studentExamProductSerive'],
            //                 nobar: true,
            //             },
            //         },
            //         {
            //             path: '/student/exam/productSerive/hotGoods',
            //             name: 'studentExamProductSeriveHotGoods',
            //             component: () =>
            //                 import ('../views/student/exam/productSerive/HotGoods'),
            //             meta: {
            //                 title: '产品及服务信息管理',
            //                 role: 5,
            //                 parentName: ['studentExamProductSerive'],
            //                 nobar: true,
            //             },
            //         },
            //     ]
            // },
            // 网店视觉设计线上店铺设计与装修
            // {
            //     path: '/student/exam/onlineShopVisualDesign',
            //     name: 'studentExamOnlineShopVisualDesign',
            //     redirect: '/student/exam/onlineShopVisualDesign/index',
            //     component: Main,
            //     meta: {
            //         title: '线上店铺设计与装修',
            //         role: 5
            //     },
            //     children: [{
            //             path: '/student/exam/onlineShopVisualDesign/index',
            //             name: 'studentExamOnlineShopVisualDesignIndex',
            //             component: () =>
            //                 import ('../views/student/exam/onlineShopVisualDesign/Index'),
            //             meta: {
            //                 title: '开始考试',
            //                 role: 5,
            //                 parentName: ['studentExamOnlineShopVisualDesign'],
            //             },
            //         },
            //         // {
            //         //     path: '/student/examing/onlineShopVisualDesign/overall',
            //         //     name: 'studentExamOnlineShopVisualDesignOverall',
            //         //     component: () =>
            //         //         import ('../views/student/exam/onlineShopVisualDesign/Overall.vue'),
            //         //     meta: {
            //         //         title: '网店视觉设计',
            //         //         role: 5,
            //         //         parentName: ['studentExamOnlineShopVisualDesign'],
            //         //     },
            //         // },
            //         {
            //             path: '/student/examing/onlineShopVisualDesign/pageSet',
            //             name: 'studentExamingOnlineShopVisualDesignPageSet',
            //             // component: ShopOpenPage,
            //             component: () => import ('../views/student/exam/storeDecoration/UserPageDesign'),
            //             meta: {
            //                 title: '用户页面设计',
            //                 role: 5,
            //                 parentName: ['studentExamOnlineShopVisualDesign'],
            //                 hidden: true,
            //             },
            //             children: [{
            //                     path: '/student/examing/onlineShopVisualDesign/pageDZ',
            //                     name: 'studentExamingOnlineShopVisualDesignPageDZ',
            //                     component: () =>
            //                         import ('../views/student/exam/storeDecoration/PageSetDZ'),
            //                     meta: {
            //                         // title: '店招',
            //                         title: '用户页面设计',
            //                         tabName: 'studentExamingOnlineShopVisualDesignPageDZ',
            //                         role: 5,
            //                         parentName: ['studentExamOnlineShopVisualDesign'],
            //                         nobar: true
            //                     },
            //                 },
            //                 {
            //                     path: '/student/examing/onlineShopVisualDesign/pageSetBanner',
            //                     name: 'studentExamingOnlineShopVisualDesignPageSetBanner',
            //                     component: () =>
            //                         import ('../views/student/exam/storeDecoration/PageSetBanner'),
            //                     meta: {
            //                         title: '电脑海报',
            //                         tabName: 'studentExamingOnlineShopVisualDesignPageSetBanner',
            //                         role: 5,
            //                         parentName: ['studentExamOnlineShopVisualDesign'],
            //                         nobar: true
            //                     },
            //                 },
            //                 {
            //                     path: '/student/examing/onlineShopVisualDesign/pageSetClass',
            //                     name: 'studentExamingOnlineShopVisualDesignPageSetClass',
            //                     component: () =>
            //                         import ('../views/student/exam/storeDecoration/PageSetClass'),
            //                     meta: {
            //                         title: '店铺分类',
            //                         tabName: 'studentExamingOnlineShopVisualDesignPageSetClass',
            //                         role: 5,
            //                         parentName: ['studentExamOnlineShopVisualDesign'],
            //                         nobar: true
            //                     },
            //                 },
            //                 {
            //                     path: '/student/examing/onlineShopVisualDesign/pageSetGood',
            //                     name: 'studentExamingOnlineShopVisualDesignPageSetGood',
            //                     component: () =>
            //                         import ('../views/student/exam/storeDecoration/PageSetGood'),
            //                     meta: {
            //                         title: '商品列表',
            //                         tabName: 'studentExamingOnlineShopVisualDesignPageSetGood',
            //                         role: 5,
            //                         parentName: ['studentExamOnlineShopVisualDesign'],
            //                         nobar: true
            //                     },
            //                 },
            //             ]
            //         },
            //         {
            //             path: '/student/examing/onlineShopVisualDesign/pageSetUpGood',
            //             name: 'studentExamingOnlineShopVisualDesignPageSetUpGood',
            //             component: () =>
            //                 import ('../views/student/exam/storeDecoration/PageSetUpGood'),
            //             meta: {
            //                 title: '上传商品',
            //                 tabName: 'studentExamingOnlineShopVisualDesignPageSetUpGood',
            //                 role: 5,
            //                 parentName: ['studentExamOnlineShopVisualDesign'],
            //                 nobar: true
            //             },
            //         },
            //     ]
            // },
            {
                path: '/student/exam/internetMarketing',
                name: 'studentExamInternetMarketing',
                redirect: '/student/exam/internetMarketing/index',
                component: Main,
                meta: {
                    title: '营销推广',
                    role: 5
                },
                children: [{
                        path: '/student/exam/internetMarketing/index',
                        name: 'studentExamInternetMarketingIndex',
                        component: () =>
                            import ('../views/student/exam/internetMarketing/Index'),
                        meta: {
                            title: '开始考试',
                            role: 5,
                            parentName: ['studentExamInternetMarketing'],
                        },
                    },
                    {
                        path: '/student/exam/internetMarketing/socialECommerce',
                        name: 'studentExamInternetMarketingSocialECommerce',
                        component: SocialECommerceLayout,
                        meta: {
                            title: '社交电商',
                            role: 5,
                            parentName: ['studentExamInternetMarketing'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/exam/internetMarketing/socialECommerce/softText',
                                name: 'studentExamInternetMarketingSocialECommerceSoftText',
                                component: () =>
                                    import ('../views/student/exam/internetMarketing/socialECommerce/SoftText'),
                                meta: {
                                    title: '社交电商',
                                    tabName: 'studentExamInternetMarketingSocialECommerceSoftText',
                                    role: 5,
                                    parentName: ['studentExamInternetMarketing'],
                                    nobar: true
                                },
                            },
                            {
                                path: '/student/exam/internetMarketing/socialECommerce/goodsManage',
                                name: 'studentExamInternetMarketingSocialECommerceGoodsManage',
                                component: () =>
                                    import ('../views/student/exam/internetMarketing/socialECommerce/GoodsManage'),
                                meta: {
                                    title: '在售商品管理',
                                    tabName: 'studentExamInternetMarketingSocialECommerceGoodsManage',
                                    role: 5,
                                    parentName: ['studentExamInternetMarketing'],
                                    nobar: true
                                },
                            },
                        ]
                    },
                    {
                        path: '/student/exam/internetMarketing/socialECommerce/softText/create',
                        name: 'studentExamInternetMarketingSocialECommerceSoftTextCreate',
                        component: () =>
                            import ('../views/student/exam/internetMarketing/socialECommerce/softText/Create'),
                        meta: {
                            title: '新的创作',
                            tabName: 'studentExamInternetMarketingSocialECommerceSoftTextCreate',
                            role: 5,
                            parentName: ['studentExamInternetMarketing'],
                            hidden: true,
                            nobar: true
                        },
                    },
                    {
                        path: '/student/exam/internetMarketing/socialECommerce/softText/detail',
                        name: 'studentExamInternetMarketingSocialECommerceSoftTextDetail',
                        component: () =>
                            import ('../views/student/exam/internetMarketing/socialECommerce/softText/Detail'),
                        meta: {
                            title: '查看',
                            tabName: 'studentExamInternetMarketingSocialECommerceSoftTextDetail',
                            role: 5,
                            parentName: ['studentExamInternetMarketing'],
                            hidden: true,
                        },
                    },
                    {
                        path: '/student/exam/internetMarketing/onlineShopProductPricing',
                        name: 'studentExamInternetMarketingOnlineShopProductPricing',
                        component: OnlineShopProductPricingLayout,
                        meta: {
                            title: '网店商品定价管理',
                            role: 5,
                            parentName: ['studentExamInternetMarketing'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/exam/internetMarketing/onlineShopProductPricing/index',
                                name: 'studentExamInternetMarketingOnlineShopProductPricingIndex',
                                component: () =>
                                    import ('../views/student/exam/internetMarketing/onlineShopProductPricing/Index'),
                                meta: {
                                    title: '网店商品定价管理',
                                    tabName: 'studentExamInternetMarketingOnlineShopProductPricingIndex',
                                    role: 5,
                                    parentName: ['studentExamInternetMarketing'],
                                },
                            },
                            {
                                path: '/student/exam/internetMarketing/onlineShopProductPricing/hotProduct',
                                name: 'studentExamInternetMarketingOnlineShopProductPricingHotProduct',
                                component: () =>
                                    import ('../views/student/exam/internetMarketing/onlineShopProductPricing/HotProduct'),
                                meta: {
                                    title: '热门商品',
                                    tabName: 'studentExamInternetMarketingOnlineShopProductPricingHotProduct',
                                    role: 5,
                                    parentName: ['studentExamInternetMarketing'],
                                },
                            },
                        ]
                    },
                ]
            },
             // 业务处理
             {
                path: '/student/examing/onlineShopManagement',
                name: 'studentExamingOnlineShopManagement',
                redirect: '/student/examing/onlineShopManagement/index',
                component: Main,
                meta: {
                    title: '业务处理',
                    role: 5
                },
                children: [{
                        path: '/student/examing/onlineShopManagement/index',
                        name: 'studentExamingOnlineShopManagementIndex',
                        component: () =>
                            import ('../views/student/exam/onlineShopManagement/Index.vue'),
                        meta: {
                            title: '业务处理',
                            role: 5,
                            parentName: ['studentExamingOnlineShopManagement'],
                        },
                    },

                    // 商品
                    {
                        path: '/student/examing/onlineShopManagement/starExam',
                        name: 'studentExamingOnlineShopManagementStarExam',
                        component: GoodsShopLayout,
                        meta: {
                            title: '网店管理',
                            role: 5,
                            parentName: ['studentExamingOnlineShopManagement'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/examing/onlineShopManagement/freightTemplate',
                                name: 'studentExamingOnlineShopManagementFreightTemplate',
                                component: () =>
                                    import ('../views/student/exam/onlineShopManagement/FreightTemplate.vue'),
                                meta: {
                                    title: '运单模板',
                                    tabName: 'studentExamingOnlineShopManagementFreightTemplate',
                                    role: 5,
                                    parentName: ['studentExamingOnlineShopManagement'],
                                    nobar: true
                                },
                            }, {
                                path: '/student/examing/onlineShopManagement/goodsIndex',
                                name: 'studentExamingOnlineShopManagementsGoodsIndex',
                                component: () =>
                                    import ('../views/student/exam/onlineShopManagement/GoodsIndex.vue'),
                                meta: {
                                    title: '在售商品',
                                    tabName: 'studentExamingOnlineShopManagementsGoodsIndex',
                                    role: 5,
                                    parentName: ['studentExamingOnlineShopManagement'],
                                    nobar: true,
                                },
                            },
                            {
                                path: '/student/examing/onlineShopManagement/hotKeyword',
                                name: 'studentExamingOnlineShopManagementHotKeyword',
                                component: () =>
                                    import ('../views/student/exam/onlineShopManagement/HotKeyword.vue'),
                                meta: {
                                    title: '热门关键词',
                                    tabName: 'studentExamingOnlineShopManagementHotKeyword',
                                    role: 5,
                                    parentName: ['studentExamingOnlineShopManagement'],
                                    nobar: true,
                                },
                            },

                        ]
                    },

                    {
                        path: '/student/examing/onlineShopManagement/studentGoodsCategory',
                        name: 'studentExamingOnlineShopManagementStudentGoodsCategory',
                        component: () =>
                            import ('../views/student/exam/onlineShopManagement/StudentGoodsCategory.vue'),
                        meta: {
                            title: '选择分类',
                            role: 5,
                            parentName: ['studentExamingOnlineShopManagement'],
                            nobar: true,
                        },
                    },
                    {
                        path: '/student/examing/onlineShopManagement/StudentAddGoods',
                        name: 'studentExamingOnlineShopManagementStudentAddGoods',
                        component: () =>
                            import ('../views/student/exam/onlineShopManagement/StudentAddGoods.vue'),
                        meta: {
                            title: '添加商品',
                            role: 5,
                            parentName: ['studentExamingOnlineShopManagement'],
                            nobar: true,
                        },
                    },
                    {
                        path: '/student/examing/onlineShopManagement/studentFreight',
                        name: 'studentExamingOnlineShopManagementStudentFreight',
                        component: () =>
                            import ('../views/student/exam/onlineShopManagement/StudentFreight.vue'),
                        meta: {
                            title: '添加运单模板',
                            role: 5,
                            parentName: ['studentExamingOnlineShopManagement'],
                            nobar: true,
                        },
                    },

                    // 订单
                    {
                        path: '/student/examing/onlineShopManagement/starExam',
                        name: 'studentExamingOnlineShopManagementStarExams',
                        component: OrderLayout,
                        meta: {
                            title: '网店管理',
                            role: 5,
                            parentName: ['studentExamingOnlineShopManagement'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/examing/onlineShopManagement/allOrder',
                                name: 'studentExamingOnlineShopManagementsAllOrder',
                                component: () =>
                                    import ('../views/student/exam/onlineShopManagement/AllOrder.vue'),
                                meta: {
                                    title: '订单管理',
                                    tabName: 'studentExamingOnlineShopManagementsAllOrder',
                                    role: 5,
                                    parentName: ['studentExamingOnlineShopManagement'],
                                    nobar: true
                                },
                            },
                            {
                                path: '/student/examing/onlineShopManagement/evaluateMange',
                                name: 'studentExamingOnlineShopManagementsEvaluateMange',
                                component: () =>
                                    import ('../views/student/exam/onlineShopManagement/EvaluateMange.vue'),
                                meta: {
                                    title: '评价管理',
                                    tabName: 'studentExamingOnlineShopManagementsEvaluateMange',
                                    role: 5,
                                    parentName: ['studentExamingOnlineShopManagement'],
                                    nobar: true
                                },
                            },
                            {
                                path: '/student/examing/onlineShopManagement/delivered',
                                name: 'studentExamingOnlineShopManagementDelivered',
                                component: () =>
                                    import ('../views/student/exam/onlineShopManagement/Delivered.vue'),
                                meta: {
                                    title: '待发货',
                                    tabName: 'studentExamingOnlineShopManagementDelivered',
                                    role: 5,
                                    parentName: ['studentExamingOnlineShopManagement'],
                                },
                            },
                            {
                                path: '/student/examing/onlineShopManagement/deliverGoods',
                                name: 'studentExamingOnlineShopManagementDeliverGoods',
                                component: () =>
                                    import ('../views/student/exam/onlineShopManagement/DeliverGoods.vue'),
                                meta: {
                                    title: '已发货',
                                    tabName: 'studentExamingOnlineShopManagementDeliverGoods',
                                    role: 5,
                                    parentName: ['studentExamingOnlineShopManagement'],
                                },
                            },
                            {
                                path: '/student/examing/onlineShopManagement/salesOrder',
                                name: 'studentExamingOnlineShopManagementSalesOrder',
                                component: () =>
                                    import ('../views/student/exam/onlineShopManagement/SalesOrder.vue'),
                                meta: {
                                    title: '售后订单',
                                    tabName: 'studentExamingOnlineShopManagementSalesOrder',
                                    role: 5,
                                    parentName: ['studentExamingOnlineShopManagement'],
                                },
                            },
                        ]
                    }

                ]
            },
            {
                path: '/student/examing/softPromotion',
                name: 'studentExamSoftPromotion',
                redirect: "/student/examing/softPromotionIndex",
                component: softPromotionLayout,
                meta: {
                    title: '电商平台活动实施',
                    role: 5,
                    parentName: ['studentExamingWebPromotion'],
                    hidden: true,
                    type: 1,
                },
                children: [{
                        path: '/student/examing/softPromotionIndex',
                        name: 'studentExamSoftPromotionIndex',
                        component: () =>
                            import ('../views/student/train/trainCenter/networkPromotion/softArticle.vue'),
                        meta: {
                            title: '电商平台活动实施',
                            role: 5,
                            parentName: ['studentExamingWebPromotion', 'studentExamingOnlineWebPromotionIndex'],
                            tabName: 'studentExamSoftPromotionIndex',
                            type: 1,
                            nobar: true,
                        },
                    },
                    {
                        path: '/student/examing/customAnalysis',
                        name: 'studentExamCustomAnalysis',
                        component: () =>
                            import ('../views/student/train/trainCenter/networkPromotion/cutomAnalysis.vue'),
                        meta: {
                            title: '用户分析',
                            role: 5,
                            parentName: ['studentExamingWebPromotion', 'studentExamingOnlineWebPromotionIndex'],
                            tabName: 'studentExamCustomAnalysis',
                            type: 1,
                        },
                    },
                    {
                        path: '/student/examing/shortVideoAnalysis',
                        name: 'studentExamShortVideoAnalysis',
                        component: () =>
                            import ('../views/student/train/trainCenter/networkPromotion/shortVideoAnalysis.vue'),
                        meta: {
                            title: '短视频推广',
                            role: 5,
                            parentName: ['studentExamingWebPromotion', 'studentExamingOnlineWebPromotionIndex'],
                            tabName: 'studentExamShortVideoAnalysis',
                            type: 1,
                        },
                    },
                    {
                        path: '/student/examing/dataAnalysis',
                        name: 'studentExamDataAnalysis',
                        component: () =>
                            import ('../views/student/train/trainCenter/networkPromotion/dataAnalysis.vue'),
                        meta: {
                            title: '数据分析',
                            role: 5,
                            parentName: ['studentExamingWebPromotion', 'studentExamingOnlineWebPromotionIndex'],
                            tabName: 'studentExamDataAnalysis',
                            type: 1,
                        },
                    },
                ]
            },
            {
                path: '/student/examCenter/createArticle',
                name: 'studentExamCenterCreateArticle',
                component: () =>
                    import ('../views/student/train/trainCenter/networkPromotion/createArticle.vue'),
                meta: {
                    title: '软文创作',
                    role: 5,
                    parentName: ['studentExamingWebPromotion', 'studentExamingOnlineWebPromotionIndex'],
                    hidden: true
                },
            },
            {
                path: '/student/trainCenter/startTraining/createArticle_two',
                name: 'studentTrainCenterStartTrainingCreateArticle_two',
                component: () =>
                    import ('../views/student/train/trainCenter/networkPromotion/createArticle_two.vue'),
                meta: {
                    title: '软文创作',
                    role: 5,
                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice', 'studentTrainCenterStartTrainingNetworkPromotion'],
                    hidden: true,
                    type: 0,
                    nobar: true,
                },
            },
            {
                path: '/student/examCenter/articleDetail',
                name: 'studentExamCenterArticleDetail',
                component: () =>
                    import ('../views/student/train/trainCenter/networkPromotion/articleDetail.vue'),
                meta: {
                    title: '软文详情',
                    role: 5,
                    parentName: ['studentExamingWebPromotion', 'studentExamingOnlineWebPromotionIndex'],
                    hidden: true
                },
            },
            {
                path: '/student/examCenter/createLive',
                name: 'studentExamCenterCreateLive',
                component: () =>
                    import ('../views/student/train/trainCenter/networkPromotion/createLive.vue'),
                meta: {
                    title: '创建直播间',
                    role: 5,
                    parentName: ['studentExamingWebPromotion', 'studentExamingOnlineWebPromotionIndex'],
                    hidden: true,
                    nobar: true
                },
            },
            {
                path: '/student/examCenter/createGoods',
                name: 'studentExamCenterCreateGoods',
                component: () =>
                    import ('../views/student/train/trainCenter/networkPromotion/createGoods.vue'),
                meta: {
                    title: '创建商品',
                    role: 5,
                    parentName: ['studentExamingWebPromotion', 'studentExamingOnlineWebPromotionIndex'],
                    hidden: true,
                    nobar: true
                },
            },
            {
                path: '/student/examCenter/liveControl',
                name: 'studentExamCenterLiveControl',
                component: () =>
                    import ('../views/student/train/trainCenter/networkPromotion/liveControl.vue'),
                meta: {
                    title: '直播控制室',
                    role: 5,
                    parentName: ['studentExamingWebPromotion', 'studentExamingOnlineWebPromotionIndex'],
                    hidden: true,
                    nobar:true
                },
            },
            {
                path: '/student/examCenter/livePromotion',
                name: 'studentExamCenterLivePromotion',
                redirect: "/student/examCenter/livePromotionIndex",
                component: livePromotionLayout,
                meta: {
                    title: '直播推广主页',
                    role: 5,
                    parentName: ['studentExamingWebPromotion', 'studentExamingOnlineWebPromotionIndex'],
                    hidden: true,
                    type: 1,
                },
                children: [{
                        path: '/student/examCenter/livePromotionIndex',
                        name: 'studentExamCenterLivePromotionIndex',
                        component: () =>
                            import ('../views/student/train/trainCenter/networkPromotion/livePromotionIndex.vue'),
                        meta: {
                            title: '直播推广主页',
                            role: 5,
                            parentName: ['studentExamingWebPromotion', 'studentExamingOnlineWebPromotionIndex'],
                            tabName: 'studentExamCenterLivePromotionIndex',
                            type: 1,
                            nobar: true
                        },
                    },
                    {
                        path: '/student/examCenter/goodsLibrary',
                        name: 'studentExamCenterGoodsLibrary',
                        component: () =>
                            import ('../views/student/train/trainCenter/networkPromotion/goodsLibrary.vue'),
                        meta: {
                            title: '商品库',
                            role: 5,
                            parentName: ['studentExamingWebPromotion', 'studentExamingOnlineWebPromotionIndex'],
                            tabName: 'studentExamCenterGoodsLibrary',
                            type: 1,
                            nobar: true
                        },
                    },
                ]
            },
            {
                path: '/student/examCenter/goodsManage',
                name: 'studentExamCenterGoodsManage',
                redirect: "/student/examCenter/goodsManageIndex",
                component: goodsManageLayout,
                meta: {
                    title: '商品管理主页',
                    role: 5,
                    parentName: ['studentExamingWebPromotion', 'studentExamingOnlineWebPromotionIndex'],
                    hidden: true,
                    type: 1,
                },
                children: [{
                        path: '/student/examCenter/goodsManageIndex',
                        name: 'studentExamCenterGoodsManageIndex',
                        component: () =>
                            import ('../views/student/train/trainCenter/networkPromotion/goodsManageIndex.vue'),
                        meta: {
                            title: '商品管理主页',
                            role: 5,
                            parentName: ['studentExamingWebPromotion', 'studentExamingOnlineWebPromotionIndex'],
                            tabName: 'studentExamCenterGoodsManageIndex',
                            type: 1,
                            nobar:true
                        },
                    },
                    {
                        path: '/student/examCenter/lotteryIndex',
                        name: 'studentExamCenterLotteryIndex',
                        component: () =>
                            import ('../views/student/train/trainCenter/networkPromotion/lotteryIndex.vue'),
                        meta: {
                            title: '抽奖池主页',
                            role: 5,
                            parentName: ['studentExamingWebPromotion', 'studentExamingOnlineWebPromotionIndex'],
                            tabName: 'studentExamCenterLotteryIndex',
                            type: 1,
                            nobar:true
                        },
                    },
                ]
            },
            // 客户服务
            {
                path: '/student/examing/onlineShopCustomerService',
                name: 'studentExamingOnlineShopCustomerService',
                redirect: '/student/examing/onlineShopCustomerService/index',
                component: Main,
                meta: {
                    title: '客户服务',
                    role: 5
                },
                children: [{
                    path: '/student/examing/onlineShopCustomerService/index',
                    name: 'studentExamingOnlineShopCustomerServiceIndex',
                    component: () =>
                        import ('../views/student/exam/onlineShopCustomerService/Index.vue'),
                    meta: {
                        title: '客户服务',
                        role: 5,
                        parentName: ['studentExamingOnlineShopCustomerService'],
                    },
                }]
            },
            // 商务数据分析
            {
                path: '/student/examing/ECommerceDataCollectionAndCleaning',
                name: 'studentExamingECommerceDataCollectionAndCleaning',
                redirect: '/student/examing/ECommerceDataCollectionAndCleaning/index',
                component: Main,
                meta: {
                    title: '商务数据分析',
                    role: 5
                },
                children: [{
                        path: '/student/examing/ECommerceDataCollectionAndCleaning/index',
                        name: 'studentExamingECommerceDataCollectionAndCleaningIndex',
                        component: () =>
                            import ('../views/student/exam/ECommerceDataCollectionAndCleaning/Index.vue'),
                        meta: {
                            title: '商务数据分析',
                            role: 5,
                            parentName: ['studentExamingECommerceDataCollectionAndCleaning'],
                        },
                    },
                    {
                        path: '/student/examing/ECommerceCollectClean/starExam',
                        name: 'studentExamingECommerceCollectCleanStarExam',
                        component: ECommerceCollectCleanLayout,
                        meta: {
                            title: '电子商务数据收集',
                            role: 5,
                            parentName: ['studentExamingECommerceDataCollectionAndCleaning'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/examing/ECommerceCollectClean/customerInfoCollect',
                                name: 'studentExamingECommerceCollectCleanCustomerInfoCollect',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataCollectionAndCleaning/CustomerInfoCollect'),
                                meta: {
                                    title: '客户信息收集',
                                    tabName: 'studentExamingECommerceCollectCleanCustomerInfoCollect',
                                    role: 5,
                                    parentName: ['studentExamingECommerceDataCollectionAndCleaning'],
                                    nobar: true,
                                },
                            },
                            {
                                path: '/student/examing/ECommerceCollectClean/customerInfo',
                                name: 'studentExamingECommerceCollectCleanCustomerInfo',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataCollectionAndCleaning/CustomerInfo'),
                                meta: {
                                    title: '客户信息',
                                    tabName: 'studentExamingECommerceCollectCleanCustomerInfo',
                                    role: 5,
                                    parentName: ['studentExamingECommerceDataCollectionAndCleaning'],
                                    nobar: true,
                                },
                            },
                            {
                                path: '/student/examing/ECommerceCollectClean/productList',
                                name: 'studentExamingECommerceCollectCleanProductList',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataCollectionAndCleaning/ProductList'),
                                meta: {
                                    title: '商品榜单',
                                    tabName: 'studentExamingECommerceCollectCleanProductList',
                                    role: 5,
                                    parentName: ['studentExamingECommerceDataCollectionAndCleaning'],
                                    nobar: true
                                },
                            },
                        ]
                    },
                    {
                        path: '/student/examing/ECommerceCollectClean/customerInfoDetail',
                        name: 'studentExamingECommerceCollectCleanCustomerInfoDetail',
                        component: () =>
                            import ('../views/student/exam/ECommerceDataCollectionAndCleaning/CustomerInfoDetail'),
                        meta: {
                            title: '客户信息详情',
                            role: 5,
                            parentName: ['studentExamingECommerceDataCollectionAndCleaning'],
                            nobar: true,
                        },
                    },
                    {
                        path: '/student/examing/ECommerceCollectClean/productDetail',
                        name: 'studentExamingECommerceCollectCleanProductDetail',
                        component: () =>
                            import ('../views/student/exam/ECommerceDataCollectionAndCleaning/ProductDetail'),
                        meta: {
                            title: '榜单详情',
                            role: 5,
                            parentName: ['studentExamingECommerceDataCollectionAndCleaning'],
                            nobar: true,
                        },
                    },
                    {
                        path: '/student/examing/ECommerceCollectClean/fans',
                        name: 'studentExamingECommerceCollectCleanFans',
                        component: ECommerceFansLayout,
                        meta: {
                            title: '电子商务数据清洗',
                            role: 5,
                            parentName: ['studentExamingECommerceDataCollectionAndCleaning'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/examing/ECommerceCollectClean/fansAdd',
                                name: 'studentExamingECommerceCollectCleanFansAdd',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataCollectionAndCleaning/FansAdd'),
                                meta: {
                                    title: '新增粉丝',
                                    tabName: 'studentExamingECommerceCollectCleanFansAdd',
                                    role: 5,
                                    parentName: ['studentExamingECommerceDataCollectionAndCleaning'],
                                    nobar: true,
                                },
                            },
                            {
                                path: '/student/examing/ECommerceCollectClean/fansDeal',
                                name: 'studentExamingECommerceCollectCleanFansDeal',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataCollectionAndCleaning/FansDeal'),
                                meta: {
                                    title: '成交粉丝',
                                    tabName: 'studentExamingECommerceCollectCleanFansDeal',
                                    role: 5,
                                    parentName: ['studentExamingECommerceDataCollectionAndCleaning'],
                                    nobar: true,
                                },
                            },
                            {
                                path: '/student/examing/ECommerceCollectClean/fansAll',
                                name: 'studentExamingECommerceCollectCleanFansAll',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataCollectionAndCleaning/FansAll'),
                                meta: {
                                    title: '全部粉丝',
                                    tabName: 'studentExamingECommerceCollectCleanFansAll',
                                    role: 5,
                                    parentName: ['studentExamingECommerceDataCollectionAndCleaning'],
                                    nobar: true,
                                },
                            },
                        ]
                    },
                ]
            },
            // 电子商务三级
            // 网络营销

            // 三级-网上交易管理
            {
                path: '/student/exam/onlineTradeManage',
                name: 'studentExamOnlineTradeManage',
                redirect: '/student/exam/onlineTradeManage/index',
                component: Main,
                meta: {
                    title: '业务处理',
                    role: 5
                },
                children: [{
                        path: '/student/exam/onlineTradeManage/index',
                        name: 'studentExamOnlineTradeManageIndex',
                        component: () =>
                            import ('../views/student/exam/onlineTradeManage/Index'),
                        meta: {
                            title: '开始考试',
                            role: 5,
                            parentName: ['studentExamOnlineTradeManage'],
                        },
                    },
                    {
                        path: '/student/exam/onlineTradeManage/starExam',
                        name: 'studentExamOnlineTradeManageStarExam',
                        component: OnlineTradingLayout,
                        meta: {
                            title: '网上交易管理',
                            role: 5,
                            parentName: ['studentExamOnlineTradeManage'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/exam/onlineTradeManage/deliveryaddress',
                                name: 'studentExamOnlineTradeManageDeliveryAddress',
                                component: () =>
                                    import ('../views/student/exam/onlineTradeManage/DeliveryAddress'),
                                meta: {
                                    title: '发货地址',
                                    tabName: 'studentExamOnlineTradeManageDeliveryAddress',
                                    role: 5,
                                    parentName: ['studentExamOnlineTradeManage'],
                                    nobar: true,
                                },
                            },
                            {
                                path: '/student/exam/onlineTradeManage/studentsellinggoods',
                                name: 'studentExamOnlineTradeManageStudentSellingGoods',
                                component: () =>
                                    import ('../views/student/exam/onlineTradeManage/StudentSellingGoods'),
                                meta: {
                                    title: '在售商品管理',
                                    tabName: 'studentExamOnlineTradeManageStudentSellingGoods',
                                    role: 5,
                                    parentName: ['studentExamOnlineTradeManage'],
                                    nobar: true,
                                },
                            },
                            {
                                path: '/student/exam/onlineTradeManage/studentcustomertran',
                                name: 'studentExamOnlineTradeManageStudentCustomerTran',
                                component: () =>
                                    import ('../views/student/exam/onlineTradeManage/StudentCustomerTran'),
                                meta: {
                                    title: '成交客户分析',
                                    tabName: 'studentExamOnlineTradeManageStudentCustomerTran',
                                    role: 5,
                                    parentName: ['studentExamOnlineTradeManage'],
                                    nobar: true,
                                },
                            },
                            //配送管理
                            {
                                path: '/student/exam/onlineTradeManage/studentspareparts',
                                name: 'studentExamOnlineTradeManageStudentSpareParts',
                                component: () =>
                                    import ('../views/student/exam/onlineTradeManage/StudentSpareParts'),
                                meta: {
                                    title: '备件库退货地址管理',
                                    tabName: 'studentExamOnlineTradeManageStudentSpareParts',
                                    role: 5,
                                    parentName: ['studentExamOnlineTradeManage'],
                                    nobar: true,
                                },
                            },
                            {
                                path: '/student/exam/onlineTradeManage/list',
                                name: 'studentExamOnlineTradeManageStudentSparePartsList',
                                component: () =>
                                    import ('../views/student/exam/onlineTradeManage/List'),
                                meta: {
                                    title: '备件库退货地址管理列表',
                                    tabName: 'studentExamOnlineTradeManageStudentSparePartsList',
                                    role: 5,
                                    parentName: ['studentExamOnlineTradeManage'],
                                    nobar: true,
                                },
                            },
                            {
                                path: '/student/exam/onlineTradeManage/studentaftersales',
                                name: 'studentExamOnlineTradeManageStudentAfterSales',
                                component: () =>
                                    import ('../views/student/exam/onlineTradeManage/StudentAfterSales'),
                                meta: {
                                    title: '自主售后退货地址管理',
                                    tabName: 'studentExamOnlineTradeManageStudentAfterSales',
                                    role: 5,
                                    parentName: ['studentExamOnlineTradeManage'],
                                    nobar: true,
                                },
                            },
                            {
                                path: '/student/exam/onlineTradeManage/studenttemplatemodel',
                                name: 'studentExamOnlineTradeManageStudentTemplateModel',
                                component: () =>
                                    import ('../views/student/exam/onlineTradeManage/StudentTemplateModel'),
                                meta: {
                                    title: '运费模板',
                                    tabName: 'studentExamOnlineTradeManageStudentTemplateModel',
                                    role: 5,
                                    parentName: ['studentExamOnlineTradeManage'],
                                    nobar: true,
                                },
                            },
                            {
                                path: '/student/exam/onlineTradeManage/studentFreight',
                                name: 'studentExamOnlineTradeManageStudentFreight',
                                component: () =>
                                    import ('../views/student/exam/onlineTradeManage/StudentFreight'),
                                meta: {
                                    title: '添加运单模板',
                                    tabName: 'studentExamOnlineTradeManageStudentTemplateModel',
                                    role: 5,
                                    parentName: ['studentExamOnlineTradeManage'],
                                    nobar: true,
                                },
                            },
                        ]
                    },
                    {
                        path: '/student/exam/onlineTradeManage/addstudentaftersales',
                        name: 'studentExamOnlineTradeManageAddStudentAfterSales',
                        component: () =>
                            import ('../views/student/exam/onlineTradeManage/AddStudentAfterSales'),
                        meta: {
                            title: '自主售后退货地址管理',
                            tabName: 'studentExamOnlineTradeManageStudentAfterSales',
                            role: 5,
                            parentName: ['studentExamOnlineTradeManage'],
                            nobar: true,
                        },
                    },

                    {
                        path: '/student/exam/onlineTradeManage/studentdeliveryaddress',
                        name: 'studentExamOnlineTradeManageStudentDeliveryAddress',
                        component: () =>
                            import ('../views/student/exam/onlineTradeManage/StudentDeliveryAddress'),
                        meta: {
                            title: '新增发货地址',
                            role: 5,
                            parentName: ['studentExamOnlineTradeManage'],
                            nobar: true,
                        },
                    },
                    {
                        path: '/student/exam/onlineTradeManage/studentaddaftersales',
                        name: 'studentExamOnlineTradeManageStudentAddAfterSales',
                        component: () =>
                            import ('../views/student/exam/onlineTradeManage/studentAddAfterSales'),
                        meta: {
                            title: '添加售后商品',
                            role: 5,
                            parentName: ['studentExamOnlineTradeManage'],
                            nobar: true,
                        },
                    },
                ]
            },
            {
                path: '/student/exam/internetCustomerService/index',
                name: 'studentExamCyberCustomerService',
                component: () =>
                    import ('../views/student/train/trainCenter/CyberCustomerService.vue'),
                meta: {
                    title: '网络客户服务',
                    role: 5,
                    parentName: ['studentExamInternetCustomerService'],
                    type: 1,
                    hidden: true,
                },
            },
            // 网络客户服务
            {
                path: '/student/exam/cyberCustomerService',
                name: 'studentExamInternetCustomerService',
                redirect: '/student/exam/internetCustomerService/index',
                component: CyberCustomerServiceLayout,
                meta: {
                    title: '客户服务',
                    role: 5,
                    type: 1,
                },
                children: [{
                        path: '/student/exam/cyberCustomerService/index',
                        name: 'studentExamCyberCustomerServiceIndex',
                        component: () =>
                            import ('../views/student/train/trainCenter/cyberCustomerService/Index.vue'),
                        meta: {
                            title: '客户策略与分析',
                            role: 5,
                            parentName: ['studentExamInternetCustomerService'],
                            hidden: true,
                            type: 1,
                            nobar: true,
                            tabName: 'studentExamCyberCustomerServiceIndex'
                        },
                    },
                    {
                        path: '/student/exam/cyberCustomerService/realTimeMonitor',
                        name: 'studentExamCyberCustomerRealTimeMonitor',
                        component: () =>
                            import ('../views/student/train/trainCenter/cyberCustomerService/realTimeMonitor.vue'),
                        meta: {
                            title: '客户实时监控',
                            role: 5,
                            parentName: ['studentExamInternetCustomerService'],
                            hidden: true,
                            type: 1,
                            nobar: true,
                            tabName: 'studentExamCyberCustomerRealTimeMonitor'
                        },
                    },
                    {
                        path: '/student/exam/cyberCustomerService/qualificationQuery',
                        name: 'studentExamCyberCustomerQualificationQuery',
                        component: () =>
                            import ('../views/student/train/trainCenter/cyberCustomerService/qualificationQuery.vue'),
                        meta: {
                            title: '客户咨询查询',
                            role: 5,
                            parentName: ['studentExamInternetCustomerService'],
                            hidden: true,
                            type: 1,
                            nobar: true,
                            tabName: 'studentExamCyberCustomerQualificationQuery'
                        },
                    },
                    {
                        path: '/student/exam/cyberCustomerService/afterSale',
                        name: 'studentExamCyberCustomerAfterSale',
                        component: () =>
                            import ('../views/student/train/trainCenter/cyberCustomerService/AfterSale.vue'),
                        meta: {
                            title: '自主售后',
                            role: 5,
                            parentName: ['studentExamInternetCustomerService'],
                            hidden: true,
                            type: 1,
                            nobar: true,
                            tabName: 'studentExamCyberCustomerAfterSale'
                        },
                    },
                    {
                        path: '/student/exam/cyberCustomerService/productManagement',
                        name: 'studentExamCyberCustomerProductManagement',
                        component: () =>
                            import ('../views/student/train/trainCenter/cyberCustomerService/productManagement.vue'),
                        meta: {
                            title: '在售商品管理',
                            role: 5,
                            parentName: ['studentExamInternetCustomerService'],
                            hidden: true,
                            type: 1,
                            nobar: true,
                            tabName: 'studentExamCyberCustomerProductManagement'
                        },
                    },
                    {
                        path: '/student/exam/cyberCustomerService/hotProduct',
                        name: 'studentExamCyberCustomerHotProduct',
                        component: () =>
                            import ('../views/student/train/trainCenter/cyberCustomerService/hotProduct.vue'),
                        meta: {
                            title: '热门商品',
                            role: 5,
                            parentName: ['studentExamInternetCustomerService'],
                            hidden: true,
                            type: 1,
                            nobar: true,
                            tabName: 'studentExamCyberCustomerHotProduct'
                        },
                    },
                ]
            },
            {
                path: '/student/exam/cyberCustomerService/createManagement',
                name: 'studentExamCyberCustomerServiceCreateManagement',
                component: () =>
                    import ('../views/student/train/trainCenter/cyberCustomerService/createManagement.vue'),
                meta: {
                    title: '客户策略与分析--创建',
                    role: 5,
                    parentName: ['studentExamInternetCustomerService'],
                    hidden: true,
                    type: 1,
                    tabName: 'studentExamCyberCustomerServiceCreateManagement',
                    nobar:true
                },
            },
            {
                path: '/student/exam/cyberCustomerService/ManagementDetail',
                name: 'studentExamCyberCustomerServiceManagementDetail',
                component: () =>
                    import ('../views/student/train/trainCenter/cyberCustomerService/ManagementDetail.vue'),
                meta: {
                    title: '客户策略与分析--详情',
                    role: 5,
                    parentName: ['studentExamInternetCustomerService'],
                    hidden: true,
                    type: 1,
                    nobar:true,
                    tabName: 'studentExamCyberCustomerServiceManagementDetail'
                },
            },
            // 电子商务数据分析与应用
            {
                path: '/student/exam/ECommerceDataAnalysisAndApplication',
                name: 'studentExamECommerceDataAnalysisAndApplication',
                redirect: '/student/exam/ECommerceDataAnalysisAndApplication/index',
                component: Main,
                meta: {
                    title: '商务数据分析',
                    role: 5
                },
                children: [{
                        path: '/student/exam/ECommerceDataAnalysisAndApplication/index',
                        name: 'studentExamECommerceDataAnalysisAndApplicationIndex',
                        component: () =>
                            import ('../views/student/exam/ECommerceDataAnalysisAndApplication/Index'),
                        meta: {
                            title: '开始考试',
                            role: 5,
                            parentName: ['studentExamECommerceDataAnalysisAndApplication'],
                        },
                    },
                    {
                        path: '/student/exam/ECommerceDataAnalysisAndApplication/starExam',
                        name: 'studentExamECommerceDataAnalysisAndApplicationStarExam',
                        component: ECommerceAnalysisApplyLayout,
                        meta: {
                            title: '电子商务数据分析与应用',
                            role: 5,
                            parentName: ['studentExamECommerceDataAnalysisAndApplication'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/exam/ECommerceDataAnalysisAndApplication/collectionAdnProcess',
                                name: 'studentExamECommerceDataAnalysisAndApplicationCollectionAdnProcess',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataAnalysisAndApplication/CollectionAdnProcess'),
                                meta: {
                                    title: '电子商务数据采集与处理',
                                    tabName: 'studentExamECommerceDataAnalysisAndApplicationCollectionAdnProcess',
                                    nobar: true,
                                    role: 5,
                                    parentName: ['studentExamECommerceDataAnalysisAndApplication'],
                                },
                            },
                            {
                                path: '/student/exam/ECommerceDataAnalysisAndApplication/basicDataAnalysis',
                                name: 'studentExamECommerceDataAnalysisAndApplicationBasicDataAnalysis',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataAnalysisAndApplication/BasicDataAnalysis'),
                                meta: {
                                    title: '电子商务基础数据分析',
                                    tabName: 'studentExamECommerceDataAnalysisAndApplicationBasicDataAnalysis',
                                    role: 5,
                                    parentName: ['studentExamECommerceDataAnalysisAndApplication'],
                                    nobar: true
                                },
                            },
                            {
                                path: '/student/exam/ECommerceDataAnalysisAndApplication/reportProduct',
                                name: 'studentExamECommerceDataAnalysisAndApplicationReportProduct',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataAnalysisAndApplication/ReportProduct'),
                                meta: {
                                    title: '电子商务数据报告制作',
                                    nobar: true,
                                    tabName: 'studentExamECommerceDataAnalysisAndApplicationReportProduct',
                                    role: 5,
                                    parentName: ['studentExamECommerceDataAnalysisAndApplication'],
                                },
                            },
                        ]
                    },
                    {
                        path: '/student/exam/ECommerceDataAnalysisAndApplication/dataCenter',
                        name: 'studentExamECommerceDataAnalysisAndApplicationDataCenter',
                        component: EcommerceDataCenterLayout,
                        meta: {
                            title: '数据中心',
                            role: 5,
                            parentName: ['studentExamECommerceDataAnalysisAndApplication'],
                            hidden: true,
                        },
                        children: [{
                                path: '/student/exam/ECommerceDataAnalysisAndApplication/customerInfo',
                                name: 'studentExamECommerceDataAnalysisAndApplicationCustomerInfo',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataAnalysisAndApplication/CustomerInfo'),
                                meta: {
                                    title: '客户信息',
                                    tabName: 'studentExamECommerceDataAnalysisAndApplicationCustomerInfo',
                                    role: 5,
                                    parentName: ['studentExamECommerceDataAnalysisAndApplication'],
                                    nobar: true
                                },
                            },
                            {
                                path: '/student/exam/ECommerceDataAnalysisAndApplication/industryMarket',
                                name: 'studentExamECommerceDataAnalysisAndApplicationIndustryMarket',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataAnalysisAndApplication/IndustryMarket'),
                                meta: {
                                    title: '行业大盘',
                                    tabName: 'studentExamECommerceDataAnalysisAndApplicationIndustryMarket',
                                    role: 5,
                                    nobar: true,
                                    parentName: ['studentExamECommerceDataAnalysisAndApplication'],
                                },
                            },
                            {
                                path: '/student/exam/ECommerceDataAnalysisAndApplication/commodityList',
                                name: 'studentExamECommerceDataAnalysisAndApplicationCommodityList',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataAnalysisAndApplication/CommodityList'),
                                meta: {
                                    title: '商品榜单',
                                    tabName: 'studentExamECommerceDataAnalysisAndApplicationCommodityList',
                                    nobar: true,
                                    role: 5,
                                    parentName: ['studentExamECommerceDataAnalysisAndApplication'],
                                },
                            },
                            {
                                path: '/student/exam/ECommerceDataAnalysisAndApplication/customerAnalysis',
                                name: 'studentExamECommerceDataAnalysisAndApplicationCustomerAnalysis',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataAnalysisAndApplication/CustomerAnalysis'),
                                meta: {
                                    title: '客户分析',
                                    tabName: 'studentExamECommerceDataAnalysisAndApplicationCustomerAnalysis',
                                    nobar: true,
                                    role: 5,
                                    parentName: ['studentExamECommerceDataAnalysisAndApplication'],
                                },
                            },
                            {
                                path: '/student/exam/ECommerceDataAnalysisAndApplication/sellersAnalysis',
                                name: 'studentExamECommerceDataAnalysisAndApplicationSellersAnalysis',
                                component: () =>
                                    import ('../views/student/exam/ECommerceDataAnalysisAndApplication/SellersAnalysis'),
                                meta: {
                                    title: '卖家分析',
                                    tabName: 'studentExamECommerceDataAnalysisAndApplicationSellersAnalysis',
                                    nobar: true,
                                    role: 5,
                                    parentName: ['studentExamECommerceDataAnalysisAndApplication'],
                                },
                            },
                        ]
                    },
                    {
                        path: '/student/exam/ECommerceDataAnalysisAndApplication/customerInfoDetail',
                        name: 'studentExamECommerceDataAnalysisAndApplicationCustomerInfoDetail',
                        component: () =>
                            import ('../views/student/exam/ECommerceDataCollectionAndCleaning/CustomerInfoDetail'),
                        meta: {
                            title: '客户信息详情',
                            nobar: true,
                            role: 5,
                            parentName: ['studentExamECommerceDataAnalysisAndApplication'],
                        },
                    },
                    {
                        path: '/student/exam/ECommerceDataAnalysisAndApplication/productDetail',
                        name: 'studentExamECommerceDataAnalysisAndApplicationProductDetail',
                        component: () =>
                            import ('../views/student/exam/ECommerceDataAnalysisAndApplication/ProductDetail'),
                        meta: {
                            nobar: true,
                            title: '榜单详情',
                            role: 5,
                            parentName: ['studentExamECommerceDataAnalysisAndApplication'],
                        },
                    },
                ]
            },


        ]
    },
    {
        path: '/student/infographicPromotion',
        name: 'studentInfographicPromotion',
        redirect: '/student/infographicPromotion/index',
        component: InfographicPromotionLayout,
        children: [{
                path: '/student/infographicPromotion/index',
                name: 'studentInfographicPromotionIndex',
                redirect: '/student/infographicPromotion/list',
                component: Main,
                children: [{
                        path: '/student/infographicPromotion/list',
                        name: 'studentInfographicPromotionList',
                        component: () =>
                            import ('../views/student/exam/infographicPromotion/Index'),
                        meta: {
                            title: '信息流推广',
                            role: 5,
                        }
                    },
                    {
                        path: '/student/infographicPromotion/create',
                        name: 'studentInfographicPromotionCreate',
                        redirect: '/student/infographicPromotion/stepOne',
                        component: InfographicPromotionStepLayout,
                        children: [{
                                path: '/student/infographicPromotion/stepOne',
                                name: 'infoStepOne',
                                component: () =>
                                    import ('../views/student/exam/infographicPromotion/StepOne'),
                                meta: {
                                    title: '创建计划-推广类型',
                                    role: 5,
                                }
                            },
                            {
                                path: '/student/infographicPromotion/stepTwo',
                                name: 'infoStepTwo',
                                component: () =>
                                    import ('../views/student/exam/infographicPromotion/StepTwo'),
                                meta: {
                                    title: '创建计划-计划设置',
                                    role: 5,
                                }
                            },
                            {
                                path: '/student/infographicPromotion/stepThree',
                                name: 'infoStepThree',
                                component: () =>
                                    import ('../views/student/exam/infographicPromotion/StepThree'),
                                meta: {
                                    title: '创建单元',
                                    role: 5,
                                }
                            },
                            {
                                path: '/student/infographicPromotion/stepFour',
                                name: 'infoStepFour',
                                component: () =>
                                    import ('../views/student/exam/infographicPromotion/StepFour'),
                                meta: {
                                    title: '完成推广',
                                    role: 5,
                                }
                            },
                        ]
                    },
                ]
            },

        ]
    },
    {
        path: '/student/infographicPromotion/dataAnalysis',
        name: 'studentInfographicPromotionDataAnalysis',
        component: () =>
            import ('../views/student/exam/infographicPromotion/DataAnalysis'),
        meta: {
            title: '数据分析',
            role: 5,

        }
    },
    //三级-移动营销与运营（京东直投）
    {
        path: '/student/JDDirectInvestment',
        name: 'studentJDDirectInvestment',
        redirect: '/student/JDDirectInvestment/index',
        component: JDDirectInvestmentLayout,
        children: [{
            path: '/student/JDDirectInvestment/index',
            name: 'studentJDDirectInvestmentIndex',
            redirect: '/student/JDDirectInvestment/list',
            component: Main,
            children: [{
                    path: '/student/JDDirectInvestment/list',
                    name: 'studentJDDirectInvestmentList',
                    component: () =>
                        import ('../views/student/exam/JDDirectInvestment/Index'),
                    meta: {
                        title: '京东直投',
                        role: 5,
                    }
                },
                {
                    path: '/student/JDDirectInvestment/create',
                    name: 'studentJDDirectInvestmentCreate',
                    redirect: '/student/JDDirectInvestment/stepOne',
                    component: JDDirectInvestmentStepLayout,
                    children: [{
                        path: '/student/JDDirectInvestment/stepOne',
                        name: 'JDDirectInvestmentStepOne',
                        component: () =>
                            import ('../views/student/exam/JDDirectInvestment/StepOne'),
                        meta: {
                            title: '创建计划',
                            role: 5,
                        }
                    }]
                },
            ]
        }]
    },
    {
        path: '/student/operationPromotion/dataAnalysis',
        name: 'operationPromotionDataAnalysis',
        component: () =>
            import ('../views/student/train/trainCenter/cyberMarketing/dataAnalysis'),
        meta: {
            title: '数据分析',
            role: 5,
            tabName: 'operationPromotionDataAnalysis',
            hidden: true,
        },
    },
    {
        path: '/student/operationPromotion',
        redirect: '/student/operationPromotion/index',
        component: operationPromotionLayout,
        children: [{
                path: '/student/operationPromotion/index',
                name: 'operationPromotionManage',
                component: Main,
                children: [{
                        path: '/student/operationPromotion/index',
                        name: 'operationPromotionIndex',
                        // component: () =>
                        //     import ('../views/student/train/trainCenter/cyberMarketing/Index'),
                        component: () => import("../views/student/exam/searchAds/Index"),
                        meta: {
                            title: '搜索广告',
                            role: 5,
                            tabName: 'operationPromotionIndex',
                            hidden: true,
                        },
                    }
                ]
            },
            {
                path: '/student/operationPromotion/searchAds',
                name: 'studentCreatePlan',
                component: studentCreatePlanLayout,
                children: [{
                        path: '/student/operationPromotion/createPlanStepOne',
                        name: 'operationPromotionCreatePlanStepOne',
                        component: () =>
                            import ('@/components/student/operationPromotion/shopDrainage/promotionPlan/CreatePlanStepOne.vue'),
                        meta: {
                            title: '创建计划',
                            role: 5,
                            tabName: 'operationPromotionCreatePlanStepOne',
                            hidden: true,
                            parentName: ['operationPromotionIndex'],
                        },
                    },
                    {
                        path: '/student/operationPromotion/createPlanStepTwo',
                        name: 'operationPromotionCreatePlanStepTwo',
                        component: () =>
                            import ('@/components/student/operationPromotion/shopDrainage/promotionPlan/CreatePlanStepTwo.vue'),
                        meta: {
                            title: '创建计划',
                            role: 5,
                            tabName: 'operationPromotionCreatePlanStepTwo',
                            hidden: true,
                            parentName: ['operationPromotionIndex'],
                        },
                    },
                    {
                        path: '/student/operationPromotion/createPlanStepThree',
                        name: 'operationPromotionCreatePlanStepThree',
                        component: () =>
                            import ('@/components/student/operationPromotion/shopDrainage/promotionPlan/CreatePlanStepThree.vue'),
                        meta: {
                            title: '创建计划',
                            role: 5,
                            tabName: 'operationPromotionCreatePlanStepThree',
                            hidden: true,
                            parentName: ['operationPromotionIndex'],
                        },
                    },
                    {
                        path: '/student/operationPromotion/planStepSucceed',
                        name: 'operationPromotionCreatePlanStepSucceed',
                        component: () =>
                            import ('@/components/student/operationPromotion/shopDrainage/promotionPlan/CreatePlanStepFour.vue'),
                        meta: {
                            title: '创建成功',
                            role: 5,
                            tabName: 'operationPromotionCreatePlanStepThree',
                            hidden: true,
                            parentName: ['operationPromotionIndex'],
                        },
                    },
                ]
            }
        ]
    },
    //三级采购管理
    {
        path: '/student/procurement',
        redirect: '/student/procurement/index',
        component: TrainAdminLayout,
        children: [{
            path: '/student/procurement/index',
            name: 'studentProcurementManages',
            component: Main,
            children: [{
                    path: '/student/procurement/index',
                    name: 'studentProcurementIndex',
                    component: () =>
                        import ('../views/student/exam/onlineTradeManage/ShopSelection'),
                    meta: {
                        role: 5,
                        title: '商品采购'
                    },
                },
                {
                    path: '/student/procurement/purchasedetail',
                    name: 'studentProcurementPurchaseDetail',
                    component: () =>
                        import ('../views/student/exam/onlineTradeManage/PurchaseDetail'),
                    meta: {
                        title: '商品采购——商品详情'
                    },
                },
                {
                    path: '/student/procurement/goodsmanage',
                    name: 'studentProcurementGoodsManage',
                    component: () =>
                        import ('../views/student/exam/onlineTradeManage/GoodsManage'),
                    meta: {
                        role: 5,
                        title: '商品管理'
                    },
                },
                {
                    path: '/student/procurement/industrymarket',
                    name: 'studentProcurementIndustryMarkets',
                    component: dataAnalysisLayout,
                    children: [{
                            path: '/student/procurement/industrymarket',
                            name: 'studentProcurementIndustryMarket',
                            component: () =>
                                import ('../views/student/exam/onlineTradeManage/IndustryMarket'),
                            meta: {
                                role: 5,
                                tabName: 'studentProcurementIndustryMarket',
                                title: '行业数据'

                            }
                        },
                        {
                            path: '/student/procurement/commoditylist',
                            name: 'studentPromotionCommodityListIndex',
                            component: () =>
                                import ('../views/student/exam/onlineTradeManage/CommodityList'),
                            meta: {
                                role: 5,
                                tabName: 'studentPromotionCommodityListIndex',
                                title: '商品榜单'
                            }
                        },
                        {
                            path: '/student/procurement/brandDetail',
                            name: 'studentProcurementBrandDetail',
                            component: () =>
                                import ('../views/student/exam/onlineTradeManage/BrandDetail'),
                            meta: {
                                role: 5,
                                title: '商品榜单——品牌详情'
                            }
                        },
                        {
                            path: '/student/procurement/treaddetail',
                            name: 'studentPromotionCommodityListTreadDetail',
                            component: () =>
                                import ('../views/student/exam/onlineTradeManage/TreadDetail'),
                            meta: {
                                role: 5,
                                title: '商品榜单——商品详情'
                            }
                        },
                    ]
                },
            ]
        }, ]
    },

    {
        path: '/student/trainCenter/startTraining/procurement',
        redirect: '/student/trainCenter/startTraining/index',
        component: TrainAdminLayout,
        children: [{
            path: '/student/trainCenter/startTraining/index',
            name: 'studentProcurementManages',
            component: Main,
            children: [{
                    path: '/student/trainCenter/startTraining/index',
                    name: 'studentTrainCenterStartTrainingIndex',
                    component: () =>
                        import ('../views/student/exam/onlineTradeManage/ShopSelection'),
                    meta: {
                        role: 5,
                        title: '商品采购'
                    },
                },
                {
                    path: '/student/trainCenter/startTraining/purchasedetail',
                    name: 'studentTrainCenterStartTrainingPurchaseDetail',
                    component: () =>
                        import ('../views/student/exam/onlineTradeManage/PurchaseDetail'),
                    meta: {
                        title: '商品采购——商品详情'
                    },
                },
                {
                    path: '/student/trainCenter/startTraining/goodsmanage',
                    name: 'studentTrainCenterStartTrainingGoodsManage',
                    component: () =>
                        import ('../views/student/exam/onlineTradeManage/GoodsManage'),
                    meta: {
                        role: 5,
                        title: '商品管理'
                    },
                },
                {
                    path: '/student/trainCenter/startTraining/industrymarket',
                    name: 'studentTrainCenterStartTrainingIndustryMarkets',
                    component: dataAnalysisLayout,
                    children: [{
                            path: '/student/trainCenter/startTraining/industrymarket',
                            name: 'studentTrainCenterStartTrainingIndustryMarket',
                            component: () =>
                                import ('../views/student/exam/onlineTradeManage/IndustryMarket'),
                            meta: {
                                role: 5,
                                tabName: 'studentTrainCenterStartTrainingIndustryMarket',
                                title: '行业数据'
                            }
                        },
                        {
                            path: '/student/trainCenter/startTraining/commoditylist',
                            name: 'studentTrainCenterStartTrainingCommodityListIndex',
                            component: () =>
                                import ('../views/student/exam/onlineTradeManage/CommodityList'),
                            meta: {
                                role: 5,
                                tabName: 'studentTrainCenterStartTrainingCommodityListIndex',
                                title: '商品榜单'
                            }
                        },
                        {
                            path: '/student/trainCenter/startTraining/brandDetail',
                            name: 'studentTrainCenterStartTrainingBrandDetail',
                            component: () =>
                                import ('../views/student/exam/onlineTradeManage/BrandDetail'),
                            meta: {
                                role: 5,
                                title: '商品榜单——品牌详情'
                            }
                        },
                        {
                            path: '/student/trainCenter/startTraining/treaddetail',
                            name: 'studentTrainCenterStartTrainingTreadDetail',
                            component: () =>
                                import ('../views/student/exam/onlineTradeManage/TreadDetail'),
                            meta: {
                                role: 5,
                                title: '商品榜单——商品详情'
                            }
                        },
                    ]
                },
            ]
        }, ]
    },

    {
        path: "/student/evaluation/examing",
        name: "studentEvaluationExaming",
        redirect: "/student/evaluation/examing/theoryTest/index",
        component: EvaluationStudentExamLayout,
        children: [{
                path: "/student/theory/waiting",
                name: 'theoryWaiting',
                component: () =>
                    import ("../components/student/waiterExam"),
                meta: {
                    title: '等待开始考试',
                    role: 5,
                }
            },
            {
                path: "/student/evaluation/examing/theoryTest",
                name: "studentEvaluationExamingTheoryTest",
                redirect: "/student/evaluation/examing/theoryTest/index",
                component: Main,
                meta: {
                    title: "理论考试",
                    role: 5,
                },
                children: [{
                    path: "/student/evaluation/examing/theoryTest/index",
                    name: "studentEvaluationExamingTheoryTestIndex",
                    component: () =>
                        import ("../views/student/exam/evaluation/TheoryIndex.vue"),
                    meta: {
                        title: "理论考试",
                        role: 5,
                        parentName: ["studentEvaluationExamingTheoryTest"],
                    },
                }],
            },
        ]
    }

]
export const evaluationRoutes = [{
        path: "/evaluation",
        name: "evaluation",
        redirect: "/evaluation/approval",
        component: EvaluationLayout,
        children: [{
                path: "/examRoomManage",
                name: "examRoomManage",
                redirect: "/evaluation/approval",
                component: Main,
                meta: {
                    title: "考场管理",
                    role: 6,
                },
                children: [{
                        path: "/evaluation/approval",
                        name: "evaluationApproval",
                        component: () =>
                            import ("../views/evaluation/examRoomManage/Approval.vue"),
                        meta: {
                            title: "考场审批",
                            role: 6,
                            parentName: ["examRoomManage"],
                        },
                    },
                    {
                        path: "/evaluation/index",
                        name: "evaluationIndex",
                        component: () =>
                            import ("../views/evaluation/examRoomManage/Index.vue"),
                        meta: {
                            title: "考场管理",
                            role: 6,
                            parentName: ["examRoomManage"],
                        },
                    },
                ],
            },
            {
                path: "/examPaperManage",
                name: "examPaperManage",
                redirect: "/examPaperManage/index",
                component: Main,
                meta: {
                    title: "试卷管理",
                    role: 6,
                },
                children: [{
                        path: "/examPaperManage/index",
                        name: "examPaperManageIndex",
                        component: () =>
                            import ("../views/evaluation/examPaperManage/Index.vue"),
                        meta: {
                            title: "试卷管理",
                            role: 6,
                            parentName: ["examPaperManage"],
                        },
                    },
                    // {
                    //     path: "/examPaperManage/composition",
                    //     name: "examPaperManageComposition",
                    //     component: () => import("../views/evaluation/examPaperManage/composition.vue"),
                    //     meta: {
                    //         title: "综合试卷管理",
                    //         role: 6,
                    //         parentName: ["examPaperManage"]
                    //     },
                    // },
                    {
                        path: "/examPaperManage/theoryManage",
                        name: "theoryManage",
                        component: () =>
                            import ("../views/evaluation/examPaperManage/TheoryManage.vue"),
                        meta: {
                            title: "理论试题管理",
                            role: 6,
                            parentName: ["examPaperManage"]
                        },
                    },
                    {
                        path: "/examPaperManage/randomPaper",
                        name: "randomPaper",
                        component: () =>
                            import ("../views/evaluation/examPaperManage/RandomPaper.vue"),
                        meta: {
                            title: "创建规则组卷",
                            role: 6,
                            parentName: ["examPaperManage", "examPaperManageIndex"],
                            hidden: true,
                            level: 2,
                        },
                    },
                    {
                        path: "/examPaperManage/artificialPaper",
                        name: "artificialPaper",
                        component: () =>
                            import ("../views/evaluation/examPaperManage/artificialPaper.vue"),
                        meta: {
                            title: "手动创建试卷",
                            role: 6,
                            parentName: ["examPaperManage", "examPaperManageIndex"],
                            hidden: true,
                            level: 2,
                        },
                    },
                    {
                        path: "/examPaperManage/TheoryPaperDetail",
                        name: "TheoryPaperDetail",
                        component: () =>
                            import ("../views/evaluation/examPaperManage/TheoryPaperDetail.vue"),
                        meta: {
                            title: "理论试卷详情",
                            role: 6,
                            parentName: ["examPaperManage", "examPaperManageIndex"],
                            hidden: true,
                            level: 2,
                        },
                    },
                    {
                        path: "/examPaperManage/ActualPaperDetail",
                        name: "ActualPaperDetail",
                        component: () =>
                            import ("../views/evaluation/examPaperManage/ActualPaperDetail.vue"),
                        meta: {
                            title: "实操试卷详情",
                            role: 6,
                            parentName: ["examPaperManage", "examPaperManageIndex"],
                            hidden: true,
                            level: 2,
                        },
                    },
                    {
                        path: "/examPaperManage/actualPaper",
                        name: "actualPaper",
                        component: () =>
                            import ("../views/evaluation/examPaperManage/ActualPaper.vue"),
                        meta: {
                            title: "实操题组卷",
                            role: 6,
                            parentName: ["examPaperManage", "examPaperManageIndex"],
                            hidden: true,
                            level: 2,
                        },
                    },
                    {
                        path: "/examPaperManage/operationPaper",
                        name: "operationPaper",
                        component: () =>
                            import ("../views/evaluation/examPaperManage/OperationPaper.vue"),
                        meta: {
                            title: "实操题试题",
                            role: 6,
                            parentName: ["examPaperManage"],
                        },
                    },
                    {
                        path: "/examPaperManage/operationPaperDetail",
                        name: "operationPaperDetail",
                        component: () =>
                            import ("../views/evaluation/examPaperManage/OperationPaperDetail.vue"),
                        meta: {
                            title: "实操题试题详情",
                            role: 6,
                            parentName: ["examPaperManage"],
                            hidden: true,
                            level: 2,
                        },
                    },
                ],
            },
            {
                path: "/candidatesManage",
                name: "candidatesManage",
                redirect: "/candidatesManage/index",
                component: Main,
                meta: {
                    title: "考生管理",
                    role: 6,
                },
                children: [{
                        path: "/candidatesManage/Index",
                        name: "candidatesManageComposition",
                        component: () =>
                            import ("../views/evaluation/candidatesManage/Index.vue"),
                        meta: {
                            title: "考生管理",
                            role: 6,
                            parentName: ["candidatesManage"],
                        },
                    },
                    {
                        path: "/candidatesManage/classify",
                        name: "candidatesManageClassify",
                        component: () =>
                            import ("../views/evaluation/candidatesManage/Classify.vue"),
                        meta: {
                            title: "考生分类",
                            role: 6,
                            parentName: ["candidatesManage"],
                        },
                    },
                ],
            },
            {
                path: "/judgeManage",
                name: "judgeManage",
                redirect: "/judgeManage/index",
                component: Main,
                meta: {
                    title: "评委管理",
                    role: 6,
                },
                children: [{
                    path: "/judgeManage/index",
                    name: "judgeManageIndex",
                    component: () =>
                        import ("../views/evaluation/judgeManage/Index.vue"),
                    meta: {
                        title: "评委管理",
                        role: 6,
                        parentName: ["judgeManage"],
                    },
                }, ],
            },
            //鉴定中心的证书先隐藏
            // {
            //     path: "/certificateManage",
            //     name: "certificateManage",
            //     redirect: "/certificateManage/index",
            //     component: Main,
            //     meta: {
            //         title: "证书管理",
            //         role: 6,
            //     },
            //     children: [{
            //             path: "/certificateManage/Index",
            //             name: "certificateManageIndex",
            //             component: () =>
            //                 import ("../views/evaluation/certificateManage/Index.vue"),
            //             meta: {
            //                 title: "证书管理",
            //                 role: 6,
            //                 parentName: ["certificateManage"],
            //             },
            //         },
            //         {
            //             path: "/certificateManage/template",
            //             name: "certificateManageTemplate",
            //             component: () =>
            //                 import ("../views/evaluation/certificateManage/Template.vue"),
            //             meta: {
            //                 title: "证书模板",
            //                 role: 6,
            //                 parentName: ["certificateManage"],
            //             },
            //         },
            //         {
            //             path: "/certificateManage/createTemplate",
            //             name: "certificateManageCreateTemplate",
            //             component: () =>
            //                 import (
            //                     "../views/evaluation/certificateManage/CreateTemplate.vue"
            //                 ),
            //             meta: {
            //                 title: "创建证书模板",
            //                 role: 6,
            //                 parentName: ["certificateManage"],
            //                 level: 2,
            //                 hiddenMenu: true,
            //                 hidden: true,
            //             },
            //         },
            //         {
            //             path: "/certificateManage/detail",
            //             name: "certificateManageDetail",
            //             component: () =>
            //                 import ("../views/evaluation/certificateManage/certificateDetail.vue"),
            //             meta: {
            //                 title: "证书详情",
            //                 role: 6,
            //                 parentName: ["certificateManage",'certificateManageIndex'],
            //                 hidden: true,
            //             },
            //         },
            //         {
            //             path: "/certificateManage/viewCertification",
            //             name: "certificateManageViewCertification",
            //             component: () =>
            //                 import (
            //                     "../views/evaluation/certificateManage/singleCertification.vue"
            //                     ),
            //             meta: {
            //                 title: "查看证书",
            //                 role: 6,
            //                 parentName: ["certificateManage"],
            //                 level: 2,
            //                 hiddenMenu: true,
            //                 hidden: true,
            //             },
            //         },
            //         {
            //             path: "/certificateManage/generateCertification",
            //             name: "certificateManageGenerateCertification",
            //             component: () =>
            //                 import (
            //                     "../views/evaluation/certificateManage/GenerateCertificate.vue"
            //                     ),
            //             meta: {
            //                 title: "生成证书",
            //                 role: 6,
            //                 parentName: ["certificateManage"],
            //                 level: 2,
            //                 hiddenMenu: true,
            //                 hidden: true,
            //             },
            //         },
            //     ],
            // },
            {
                path: '/dataBoard',
                name: 'dataBoard',
                component: () =>
                    import ('../views/evaluation/dataBoard/Index.vue'),
                meta: {
                    title: "数据看板",
                    role: 6,
                },
            },
            {
                path: "/examManage",
                name: "examManage",
                redirect: "/examManage/create",
                component: Main,
                meta: {
                    title: "考试管理",
                    role: 6,
                },
                children: [{
                        path: "/examManage/create",
                        name: "examManageCreate",
                        component: () =>
                            import ("../views/evaluation/examManage/CreateExam.vue"),
                        meta: {
                            title: "创建考试",
                            role: 6,
                            parentName: ["examManage"],
                        },
                    },
                    {
                        path: "/examManage/createExamination",
                        name: "createExamination",
                        component: () =>
                            import ("../views/evaluation/examManage/CreateExamination.vue"),
                        meta: {
                            title: "创建考试",
                            role: 6,
                            parentName: ["examManage"],
                            level: 2,
                            hidden: true,
                        },
                    },
                    {
                        path: "/examManage/examData",
                        name: "examManageExamData",
                        component: () =>
                            import ("../views/evaluation/examManage/ExamData.vue"),
                        meta: {
                            title: "考试数据",
                            role: 6,
                            parentName: ["examManage"],
                        },
                    },
                    {
                        path: "/examManage/examDataStudent",
                        name: "examManageExamDataStudent",
                        component: () =>
                            import ("../views/evaluation/examManage/ExamDataStudent.vue"),
                        meta: {
                            title: "学生数据",
                            role: 6,
                            parentName: ["examManage", 'examManageExamData'],
                            hidden: true,
                        },
                    },
                ],
            },
            {
                path: "/examManage/examData/detail",
                name: "examManageExamDataDetail",
                redirect: '/examManage/examData/theory',
                component: EvaluationExamDataLayout,
                meta: {
                    title: "考试数据详情",
                    role: 6,
                    hidden: true,
                },
                children: [
                    {
                        path: "/examManage/examData/theory",
                        name: "examManageExamDataTheory",
                        component: () =>
                            import (
                                "../components/evaluation/TheoryList"
                            ),
                        meta: {
                            title: "理论题",
                            tabName: "examManageExamDataTheory",
                            role: 6,
                            parentName: ["examManageExamDataDetail", 'examManage'],
                            hidden: true,
                        },
                    },
                    {
                        path: "/examManage/examData/goodsInfo",
                        name: "examManageExamDataGoodsInfo",
                        component: () =>
                            import ("../components/evaluation/GoodsInfo"),
                        meta: {
                            title: "产品及服务信息管理",
                            tabName: "examManageExamDataGoodsInfo",
                            role: 6,
                            parentName: ["examManageExamDataDetail", 'examManage', ],
                            hidden: true,
                        },
                    },
                    {
                        path: "/examManage/examData/storeDecorate",
                        name: "examManageExamDataStoreDecorate",
                        component: () =>
                            import (
                                "../components/evaluation/StoreDecorate"
                            ),
                        meta: {
                            title: "线上店铺设计与装修",
                            tabName: "examManageExamDataStoreDecorate",
                            role: 6,
                            parentName: ["examManageExamDataDetail", 'examManage'],
                            hidden: true,
                        },
                    },
                    {
                        path: "/examManage/examData/storeManage",
                        name: "examManageExamDataStoreManage",
                        component: () =>
                            import (
                                "../components/evaluation/StoreManage"
                            ),
                        meta: {
                            title: "业务处理",
                            tabName: "examManageExamDataStoreManage",
                            role: 6,
                            parentName: ["examManageExamDataDetail", 'examManage'],
                            hidden: true,
                        },
                    },
                    {
                        path: "/examManage/examData/networkPromote",
                        name: "examManageExamDataNetworkPromote",
                        component: () =>
                            import (
                                "../components/evaluation/NetworkPromote"
                            ),
                        meta: {
                            title: "营销推广",
                            tabName: "examManageExamDataNetworkPromote",
                            role: 6,
                            parentName: ["examManageExamDataDetail", 'examManage'],
                            hidden: true,
                        },
                    },
                    {
                        path: "/examManage/examData/storeCustomer",
                        name: "examManageExamDataStoreCustomer",
                        component: () =>
                            import ("../components/evaluation/StoreCustomer"),
                        meta: {
                            title: "客户服务",
                            tabName: "examManageExamDataStoreCustomer",
                            role: 6,
                            parentName: ["examManageExamDataDetail", 'examManage'],
                            hidden: true,
                        },
                    },
                    {
                        path: "/examManage/examData/storeCustomerDetail",
                        name: "Detail",
                        component: () =>
                            import (
                                "../components/evaluation/StoreCustomerDetail"
                            ),
                        meta: {
                            title: "查看详情",
                            tabName: "examManageExamDataStoreCustomer",
                            role: 6,
                            parentName: ["examManageExamDataDetail", 'examManage'],
                            hidden: true,
                        },
                    },
                    {
                        path: "/examManage/examData/eCommerceData",
                        name: "examManageExamDataECommerceData",
                        component: () =>
                            import (
                                "../views/student/train/trainCenter/ECommerceCollectCleanDetail"
                            ),
                        meta: {
                            title: "商务数据分析",
                            tabName: "examManageExamDataECommerceData",
                            role: 6,
                            parentName: ["examManageExamDataDetail", 'examManage'],
                            hidden: true,
                        },
                    },
                    {
                        path: '/examManage/examData/onlineShopVisualDesignDetail',
                        name: 'examManageExamDataOnlineShopVisualDesignDetail',
                        // component: () =>
                        //     import ('../views/student/train/trainCenter/onlineShopVisualDesign/LookDetail.vue'),
                        component: () =>
                            import (
                                "../components/evaluation/StoreDecorate"
                                ),
                        meta: {
                            title: '网店视觉设计',
                            tabName: 'examManageExamDataOnlineShopVisualDesignDetail',
                            role: 6,
                            parentName: ['examManageExamDataDetail', 'examManage'],
                            hidden: true,
                        },
                    },
                    {
                        path: '/examManage/examData/cyberMarketing',
                        name: 'examManageExamDataCyberMarketing',
                        // component: () => import('../components/teacher/examCenter/examData/CyberMarketing'),
                        component: () =>
                            import ('../views/student/train/trainCenter/cyberMarketing/cyberMarketDetail'),
                        meta: {
                            title: '营销推广',
                            tabName: 'examManageExamDataCyberMarketing',
                            role: 6,
                            parentName: ['examManageExamDataDetail', 'examManage'],
                            hidden: true,
                        },
                    },
                    {
                        path: '/examManage/examData/onlineTradeManageDetail',
                        name: 'examManageExamDataOnlineTradeManageDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/onlineTradeManage/LookDetail.vue'),
                        meta: {
                            title: '网上交易管理',
                            tabName: 'examManageExamDataOnlineTradeManageDetail',
                            role: 6,
                            parentName: ['examManageExamDataDetail', 'examManage'],
                            hidden: true,
                        },
                    },
                    {
                        path: '/examManage/examData/cyberCustomer',
                        name: 'examManageExamDataCyberCustomer',
                        component: () =>
                            import ('../components/teacher/examCenter/examData/CyberCustomer'),
                        meta: {
                            title: '网络客户服务',
                            tabName: 'examManageExamDataCyberCustomer',
                            role: 6,
                            parentName: ['examManageExamDataDetail', 'examManage'],
                            hidden: true,
                        },
                    },
                    {
                        path: '/TheerExamManage/examData/cyberCustomer',
                        name: 'TheerExamManageExamDataCyberCustomer',
                        component: () =>
                            import ('../components/teacher/examCenter/examData/TheerCyberCustomer'),
                        meta: {
                            title: '网络客户服务',
                            tabName: 'examManageExamDataCyberCustomer',
                            role: 6,
                            parentName: ['examManageExamDataDetail', 'examManage'],
                            hidden: true,
                        },
                    },

                    {
                        path: '/examManage/examData/storeCustomer',
                        name: '',
                        component: () =>
                            import ('../components/teacher/examCenter/examData/StoreCustomer'),
                        meta: {
                            title: '网店客户服务',
                            tabName: '',
                            role: 6,
                            parentName: ['examManageExamDataDetail', 'examManage'],
                            hidden: true
                        },
                    },
                    {
                        path: '/examManage/examData/eCommerceAnalysisApplicationDetail',
                        name: 'examManageExamDataECommerceAnalysisApplicationDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/ECommerceAnalysisApplicationDetail'),
                        meta: {
                            title: '电子商务数据分析与应用',
                            tabName: 'examManageExamDataECommerceAnalysisApplicationDetail',
                            role: 6,
                            parentName: ['examManageExamDataDetail', 'examManage'],
                            hidden: true,
                        },
                    },
                    {
                        path: '/examManage/examData/ProductSeriveDetail',
                        name: 'examManageExamDataProductSeriveDetail',
                        component: () =>
                            import ('../views/student/train/trainCenter/ProductSeriveDetail'),
                        meta: {
                            title: '产品及服务信息管理',
                            tabName: 'examManageExamDataProductSeriveDetail',
                            role: 6,
                            parentName: ['examManageExamDataDetail', 'examManage'],
                            hidden: true,
                        },
                    },
                ],
            },
            {
                path: "/examManage/examData/goodsInfoDetail",
                name: "examManageExamDataGoodsInfoDetail",
                component: () =>
                    import (
                        "../components/evaluation/GoodsInfoDetail"
                    ),
                meta: {
                    title: "商品信息采集与处理详情",
                    tabName: "examManageExamDataGoodsInfoDetail",
                    role: 6,
                    parentName: ["examManageExamDataDetail", 'examManage'],
                    hidden: true,
                },
            },
            {
                path: '/evaluation/articleDetail',
                name: 'examManageExamarticleDetail',
                component: () =>
                    import ('../components/evaluation/articleDetail.vue'),
                meta: {
                    title: '软文详情',
                    role: 6,
                    tabName: 'examManageExamarticleDetail',
                    parentName: ["examManageExamDataDetail", 'examManage'],
                    hidden: true,
                },
            },
            {
                path: '/evaluation/articleStandard',
                name: 'examManageExamarticleStandard',
                component: () =>
                    import ('../components/evaluation/articleStandard.vue'),
                meta: {
                    title: '软文详情标准答案',
                    role: 6,
                    tabName: 'examManageExamarticleStandard',
                    parentName: ["examManageExamDataDetail", 'examManage'],
                    hidden: true,
                },
            },
            {
                path: '/examManage/examData/eCommerceDetail',
                name: 'CleaneCommerceDetail',
                component: () =>
                    import ("../views/student/train/trainCenter/ECommerceCleanDetail"),
                meta: {
                    title: '电子商务数据收集与清洗-详情',
                    parentName: ["examManageExamDataDetail", 'examManage'],
                    role: 6,
                    hidden: true
                }
            },
            {
                path: '/jd/examCenter/trainingData/storeCustomerDetail',
                name: 'examCenterTrainingDataStoreCustomerDetail',
                component: () =>
                    import ('../components/teacher/examCenter/examData/StoreCustomerDetail'),
                meta: {
                    title: '网路客服查看详情',
                    tabName: "",
                    role: 6,
                    parentName: ["examManageExamDataDetail", 'examManage'],
                    hidden: true
                },
            },
            {
                path: '/jd/examCenter/examData/eCommerceCollectDetail',
                name: 'examCenterExamDataECommerceCollectDetail',
                component: () =>
                    import ('../views/student/train/trainCenter/ECommerceCollectDetail'),
                meta: {
                    title: '客户信息收集-查看详情',
                    role: 6,
                    parentName: ['examManageExamDataDetail', 'examManage'],
                    hidden: true,
                },
            },
            {
                path: '/center/goods/detail',
                name: 'centerGoodsDetail',
                component: () =>
                    import ('../views/goodsDetail/goodsDetail.vue'),
                meta: {
                    title: '商品详情',
                    role: 6,
                    hidden: true,
                    parentName: ["examManageExamDataDetail", 'examManage']
                }
            },
            {

                path: '/judges/TheerCyberCustomerDetail',
                name: 'judgesTheerCyberCustomerDetail',
                component: () =>
                    import ('../views/teacher/TheerCyberCustomerDetail.vue'),
                meta: {
                    title: '网络客户服务--查看详情',
                    role: 6,
                    parentName: ['examManageExamDataDetail', 'examManage'],
                    hidden: true,
                },
            },
            {

                path: '/jd/examCenter/examData/onlineTradeManageDetail/deliverAddressDetail',
                name: 'examCenterExamDataOnlineTradeManageDetailDeliverAddressDetail',
                component: () =>
                    import ('../views/student/train/trainCenter/onlineTradeManage/DeliverAddressDetail.vue'),
                meta: {
                    title: '网上交易管理-查看详情',
                    role: 6,
                    hidden: true,
                    parentName: ['examManageExamDataDetail', 'examManage'],
                }

            },
            {
                path: '/jd/examCenter/examData/distributionDetail',
                name: 'examCenterExamDataDistributionDetail',
                component: () =>
                    import ('../views/student/train/trainCenter/onlineTradeManage/DistributionDetail.vue'),
                meta: {
                    title: '配送管理-查看详情',
                    role: 6,
                    hidden: true,
                    parentName: ['examManageExamDataDetail', 'examManage'],
                }
            },
        ],
    },
    {
        path: '/jd/teacher/goods/detail',
        name: 'teacherGoodsDetail',
        component: () =>
            import ('../views/goodsDetail/goodsDetail.vue'),
        meta: {
            title: '商品详情',
            role: 6,
        }
    },
    {
        path: '/student/examing/goodsInfo/hotKeyword',
        name: 'studentExamingGoodsInfoHotKeyword',
        component: () =>
            import ('../views/student/exam/goodsInfo/HotKeyword.vue'),
        meta: {
            title: '热门关键词',
            role: 5,
        },
    },
    {
        path: '/judges/teacher/goods/detail',
        name: 'teacherGoodsDetail',
        component: () =>
            // import ('../views/goodsDetail/goodsDetail.vue'),
            import ('../views/goodsDetail/DecoratorDetails.vue'),
        meta: {
            title: '商品详情',
            role: 4,
        }
    },
    {
        path: '/hotGoods/detail',
        name: 'hotGoodsDetail',
        component: () =>
            import ('../views/goodsDetail/HotGoods.vue'),
        meta: {
            title: '商品详情',
            role: 5,
        }
    },
    {
        path: '/newDecorator/detail',
        name: 'newDecoratorDetail',
        component: () =>
            import ('../views/goodsDetail/DecoratorDetails.vue'),
        meta: {
            title: '商品详情',
            role: 5,
        }
    },
    {
        path: '/teacher/newDecorator/detail',
        name: 'teacherNewDecoratorDetail',
        component: () =>
            import ('../views/goodsDetail/DecoratorDetails.vue'),
        meta: {
            title: '商品详情',
            role: 6,
        }
    },
    {
        path: '/newDecorator/fullScreen',
        name: 'newDecoratorFullScreen',
        component: () =>
            import ('../views/goodsDetail/FullScreen.vue'),
        meta: {
            title: '全屏预览',
            role: 5,
        }
    },
    {
        path: '/judges/newDecorator/fullScreen',
        name: 'judgesFullScreen',
        component: () =>
            import ('../views/goodsDetail/FullScreen.vue'),
        meta: {
            title: '全屏预览',
            role: 4,
        }
    },
    {
        path: '/goods/purchase/detail',
        name: 'goodsPurchaseDetail',
        component: () =>
            import ('../views/goodsDetail/PurchaseDetail.vue'),
        meta: {
            title: '商品详情',
            role: 5,
        }
    },
];

const createRouter = () => new VueRouter({
    scrollBehavior: () => ({ y: 0 }),
    base: process.env.BASE_URL,
    // routes: LoginRoutes.concat(adminRoutes)
    routes: adminRoutes.concat(schoolRoutes).concat(teacherRoutes).concat(judgesRoutes).concat(studentRoutes).concat(LoginRoutes).concat(evaluationRoutes)
})

const router = createRouter()

// const router = new VueRouter({
//   routes
// })

export default router
